import { formatTraitLevelValue } from 'libs/end-to-end/src/success-phenotype-v2-utils';
import upperFirstString from 'lodash/upperFirst';
import { DEFAULT_UNITS } from 'libs/end-to-end/src/success-phenotype-v2-utils';
import { DisparityOpportunityDescriptionInputs } from 'libs/end-to-end/src/disparity-opportunity-description-inputs';
import { TextComponent } from 'libs/end-to-end/src/text-component';
import { RootCauseGroupResult } from 'libs/end-to-end/src/root-cause-analysis';
import { MyMetricDefinition } from 'libs/end-to-end/src/my-metric-definition';
import { DimensionDefinition } from 'libs/end-to-end/src/types/databases/dimensions/dimension-definition';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';
import { guardExhaustive } from 'libs/end-to-end/src/generic';
import { OaxacaCategoriesName } from 'libs/end-to-end/src/oaxaca-bar-chart';
import { DateDuration } from 'libs/end-to-end/src/dates';
import { formatDateStandard } from 'libs/end-to-end/src/dates';
import { getDateAsMMMDDYYYY } from 'libs/end-to-end/src/dates';
import { FocusAreaEnum } from 'libs/end-to-end/src/focus-area';
import { formatNumber } from 'libs/end-to-end/src/number-formatting';
import { formatNumberForDisplayInUnits } from 'libs/end-to-end/src/number-formatting';
import { PayCorrectionDisplayType } from 'libs/end-to-end/src/pay-correction/types/PayCorrectionDisplayType';
import { getCalibrationScore } from 'libs/end-to-end/src/tests-utils';
import { TestCount } from 'libs/end-to-end/src/tests-utils';
import { getTotalTestCount } from 'libs/end-to-end/src/tests-utils';
import { getCalibrationLevel } from 'libs/end-to-end/src/calibration-level';
import { CalibrationLevel } from 'libs/end-to-end/src/calibration-level';
import upperFirst from 'lodash/upperFirst';
import { PhraseId } from 'libs/end-to-end/src/phrases';
import { Phrases } from 'libs/end-to-end/src/phrases';
import { capitalize } from 'lodash';
import { UserAnalysisInformation } from 'libs/end-to-end/src/types/user-analysis/user-analysis-details';
import { roundToPrecision } from 'libs/end-to-end/src/round-to-precision';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { MyFocusAreaDefinition } from 'libs/end-to-end/src/my-focus-area-definition';
import { toTitleCase } from 'libs/end-to-end/src/string-formatting';
import { SuccessPhenotypeV2Request } from 'libs/end-to-end/src/custom-viz/SuccessPhenotypeTypes';
import { MyObservation } from 'libs/end-to-end/src/my-observation';
import { getAnalysisNameFromPipelineAnalysisRequest } from 'libs/end-to-end/src/custom-viz/PipelineAnalysisTypes';
import { PipelineAnalysisRequest } from 'libs/end-to-end/src/custom-viz/PipelineAnalysisTypes';
import { HeatmapAnalysisRequest } from 'libs/end-to-end/src/custom-viz/HeatmapAnalysisTypes';
import { ProgressRequest } from 'libs/end-to-end/src/custom-viz/ProgressTypes';
import { BiasAnalysisRequest } from 'libs/end-to-end/src/custom-viz/BiasAnalysisTypes';
import { determineSecondaryFilterDefinitionsForFeature } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FiltersFeatureName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { inferTypeForFilterStore } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { convertFilterDefinitionForExtrasToFilterStoreValue } from 'libs/end-to-end/src/convert-filter-definition-for-extras-to-filter-store-value';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { FilterStoreValue } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { concatTranslatedContent } from 'libs/end-to-end/src/translation-content';
import { getTranslatedContentAsString } from 'libs/end-to-end/src/translation-content';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';
import { sortFilterValues } from 'libs/end-to-end/src/sorting';
import { getFilterDisplayName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getLevelByColumnValueFromObservation } from 'libs/end-to-end/src/dimension-config-utils';
import { getPrivilegedLevelForDimensionFromObservation } from 'libs/end-to-end/src/dimension-config-utils';
import { BinScatterMultiSelectRequest } from 'libs/end-to-end/src/custom-viz/BinScatterMultiSelectTypes';
import { format } from 'date-fns';
import { formatDistanceToNow } from 'date-fns';
import { isAfter } from 'date-fns';
import { isToday } from 'date-fns';
import { differenceInDays } from 'date-fns';
import { differenceInHours } from 'date-fns';
import { differenceInMinutes } from 'date-fns';
import { subDays } from 'date-fns';
import { isEntitlementFeatureWithOptionalFocusArea } from 'libs/end-to-end/src/group-entitlements';
import { getBiasAnalysisFilterValues } from 'libs/end-to-end/src/filters-v2/get-filter-values';
import { getBinScatterMultiSelectFilterValues } from 'libs/end-to-end/src/filters-v2/get-filter-values';
import { getHeatmapFilterValues } from 'libs/end-to-end/src/filters-v2/get-filter-values';
import { getPipelineAnalysisFilterValues } from 'libs/end-to-end/src/filters-v2/get-filter-values';
import { getSuccessFactorsFilterValues } from 'libs/end-to-end/src/filters-v2/get-filter-values';
import { getProgressFilterValues } from 'libs/end-to-end/src/filters-v2/get-filter-values';
import { TableViewRequest } from 'libs/end-to-end/src/custom-viz/TableViewTypes';
import { getAllowedGroupBySelectionsForTableView } from 'libs/end-to-end/src/table-view-utils';
import { SummaryStatsRequest } from 'libs/end-to-end/src/summary-stats';
import { GeolocationRequest } from 'libs/end-to-end/src/custom-viz/GeolocationTypes';
import { TimeSeriesTrendsRequest } from 'libs/end-to-end/src/custom-viz/TimeSeriesTrendsTypes';
import { getMetricByColumnHeaderValueFromObservation } from 'libs/end-to-end/src/me';
import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { DateRange } from 'libs/end-to-end/src/date-range';
import { AverageTrendSeriesId } from 'libs/end-to-end/src/progress';
import { ObservedMetricLineGroup } from 'libs/end-to-end/src/progress';
import { ControlGroupSeriesId } from 'libs/end-to-end/src/progress';
import { extractLineGroupFromSeriesId } from 'libs/end-to-end/src/progress';
import { resolveAnalysisNameForCustomViz } from 'libs/end-to-end/src/construct-body-display-of-custom-viz';
import { resolveFocusAreaForCustomViz } from 'libs/end-to-end/src/construct-body-display-of-custom-viz';
import { CustomVizId } from 'libs/end-to-end/src/custom-viz/CustomVizId';
import { RubricGradingType } from 'libs/end-to-end/src/types/rubrics/rubric';
import { PasswordComplexityErrorCode } from 'libs/end-to-end/src/passwords';

const englishGetPercentage = ({ value }: { value: number }) => {
  return `${roundToPrecision(value, 1)}%`;
};

const formatRelativeTimeShort = ({ date }: { date: Date }) => {
  const now = new Date();
  const minutes = Math.max(0, differenceInMinutes(now, date));

  if (minutes < 60) {
    return `${Math.max(1, minutes)} min ago`;
  }

  const hours = Math.max(1, differenceInHours(now, date));
  if (hours < 24) {
    return `${hours} hr ago`;
  }

  const days = Math.max(1, differenceInDays(now, date));
  return `${days} day${days === 1 ? '' : 's'} ago`;
};

export const englishGetAnalyzeBiasDescription = (
  input: DisparityOpportunityDescriptionInputs,
): TextComponent[] => {
  const {
    treatmentGroup,
    referenceGroup,
    metricDefinition,
    rawDisparityPercentage,
    controlledDisparityPercentage,
    debiasedDisparityPercentage,
    calibrationFraming,
    hasRunBiasTasks,
  } = input;

  const treatmentName = treatmentGroup.displayName.toLocaleLowerCase();
  const referenceName = referenceGroup.displayName.toLocaleLowerCase();

  const subjectName =
    metricDefinition.whiteLabeling.subjectPlural.toLocaleLowerCase();

  const subjectPassiveVerb =
    metricDefinition.whiteLabeling.subjectPassiveVerb.toLocaleLowerCase();

  const subjectConditionalVerb = metricDefinition.whiteLabeling
    .subjectConditionalVerb
    ? metricDefinition.whiteLabeling.subjectConditionalVerb.toLocaleLowerCase()
    : metricDefinition.whiteLabeling.subjectPassiveVerb.toLocaleLowerCase();

  const processesDescription =
    metricDefinition.whiteLabeling.proceseesDescription.toLocaleLowerCase();

  const disparityDescriptionComponents: TextComponent[] = [];

  const disparityTextUnsigned = englishGetPercentage({
    value: Math.abs(rawDisparityPercentage),
  });

  const controlledDisparityTextUnsigned = englishGetPercentage({
    value: Math.abs(controlledDisparityPercentage),
  });

  if (rawDisparityPercentage > 0) {
    disparityDescriptionComponents.push(
      {
        text: upperFirst(
          `${treatmentName} ${subjectName} ${subjectPassiveVerb} `,
        ),
        color: 'black',
      },
      {
        text: `${disparityTextUnsigned} more`,
        color: 'black',
        isBold: true,
      },
      {
        text: ` than ${referenceName} ${subjectName}. `,
        color: 'black',
      },
    );
  } else if (rawDisparityPercentage < 0) {
    disparityDescriptionComponents.push(
      {
        text: upperFirst(
          `${treatmentName} ${subjectName} ${subjectPassiveVerb} `,
        ),
        color: 'black',
      },
      {
        text: `${disparityTextUnsigned} less`,
        color: 'black',
        isBold: true,
      },
      {
        text: ` than ${referenceName} ${subjectName}. `,
        color: 'black',
      },
    );
  } else {
    disparityDescriptionComponents.push(
      {
        text: upperFirst(
          `${treatmentName} ${subjectName} ${subjectPassiveVerb} `,
        ),
        color: 'black',
      },
      {
        text: `at the same rate`,
        color: 'black',
        isBold: true,
      },
      {
        text: ` as ${referenceName} ${subjectName}. `,
        color: 'black',
      },
    );
  }

  if (controlledDisparityPercentage > 0) {
    disparityDescriptionComponents.push(
      {
        text: upperFirst(`${treatmentName} ${subjectName} `),
        color: 'black',
        isBold: false,
      },
      {
        text: `with similar factors`,
        color: 'black',
        isSuperscript: true,
        isDottedUnderline: true,
      },
      {
        text: ` ${subjectPassiveVerb} `,
        color: 'black',
        isBold: false,
      },
      {
        text: `${controlledDisparityTextUnsigned} more`,
        color: 'purple',
        isBold: true,
      },
      {
        text: ` than ${referenceName} ${subjectName}. `,
        color: 'black',
        isBold: false,
      },
    );
  } else if (controlledDisparityPercentage < 0) {
    disparityDescriptionComponents.push(
      {
        text: upperFirst(`${treatmentName} ${subjectName} `),
        color: 'black',
        isBold: false,
      },
      {
        text: `with similar factors`,
        color: 'black',
        isBold: false,
        isSuperscript: true,
        isDottedUnderline: true,
      },
      {
        text: ` ${subjectPassiveVerb} `,
        color: 'black',
      },
      {
        text: `${controlledDisparityTextUnsigned} less`,
        color: 'purple',
        isBold: true,
      },
      {
        text: ` than ${referenceName} ${subjectName}. `,
        color: 'black',
      },
    );
  } else {
    disparityDescriptionComponents.push(
      {
        text: upperFirst(`${treatmentName} ${subjectName} `),
        color: 'black',
      },
      {
        text: `with similar factors`,
        color: 'black',
        isSuperscript: true,
        isDottedUnderline: true,
      },
      {
        text: ` ${subjectPassiveVerb} `,
        color: 'black',
      },
      {
        text: `at the same rate`,
        color: 'purple',
        isBold: true,
      },
      {
        text: ` as ${referenceName} ${subjectName}. `,
        color: 'black',
        isBold: false,
      },
    );
  }

  const allTextComponents: TextComponent[] = [];

  allTextComponents.push(...disparityDescriptionComponents);

  const EPSILON = 0.0001;

  const hasDebiasedDisparity = debiasedDisparityPercentage !== null;
  const differingDisparity =
    hasDebiasedDisparity &&
    Math.abs(
      (controlledDisparityPercentage || 0) - (debiasedDisparityPercentage || 0),
    ) > EPSILON;
  const hasBias = hasDebiasedDisparity && differingDisparity;

  if (hasBias) {
    allTextComponents.push({
      text:
        calibrationFraming === 'optimization'
          ? `If all inefficiencies were removed from ${processesDescription}, ${treatmentName} ${subjectName} ${subjectConditionalVerb} `
          : `If all bias was removed from ${processesDescription}, ${treatmentName} ${subjectName} ${subjectConditionalVerb} `,
      color: 'black',
      isBold: false,
    });

    // at the same rate as ${referenceName} ${subjectName}.

    if (debiasedDisparityPercentage < 0) {
      allTextComponents.push({
        text: `${Math.abs(Math.round(debiasedDisparityPercentage))}% less `,
        color: 'blue',
        isBold: true,
      });
    } else if (debiasedDisparityPercentage > 0) {
      allTextComponents.push({
        text: `${Math.round(debiasedDisparityPercentage)}% more `,
        color: 'blue',
        isBold: true,
      });
    } else {
      allTextComponents.push({
        text: `at the same rate `,
        color: 'blue',
        isBold: true,
      });
    }

    allTextComponents.push({
      text: `than ${referenceName} ${subjectName}.`,
      color: 'black',
    });
  } else if (!hasDebiasedDisparity && differingDisparity) {
    allTextComponents.push({
      text:
        calibrationFraming === 'optimization'
          ? `Inefficiencies detected, but whether inefficiency is in favor of ${treatmentName} ${subjectName} or against ${treatmentName} ${subjectName} is unclear.`
          : `Bias detected, but whether bias is in favor of ${treatmentName} ${subjectName} or against ${treatmentName} ${subjectName} is unclear. Estimating a bias-free disparity requires further assumptions about the data.`,
      color: 'black',
    });
  } else if (hasRunBiasTasks) {
    allTextComponents.push(
      {
        text:
          calibrationFraming === 'optimization'
            ? `Analysis suggests there were `
            : `There was `,
        color: 'black',
      },
      {
        text:
          calibrationFraming === 'optimization'
            ? `no inefficiencies detected`
            : `no bias detected`,
        color: 'blue',
        isBold: true,
      },
      {
        text: ` in this process.`,
        color: 'black',
      },
    );
  }

  return allTextComponents;
};

export const englishGetOaxacaConclusion = ({
  analysisType,
  metricDefinition,
  treatmentLevelDefinition,
  referenceLevelDefinition,
  controlVariableName,
  categoriesName,
  originalTreatmentLevelDisparity,
}: {
  analysisType: string | null;
  metricDefinition: MyMetricDefinition;
  treatmentLevelDefinition: LevelDefinition;
  referenceLevelDefinition: LevelDefinition;
  controlVariableName: string | null;
  categoriesName: OaxacaCategoriesName | undefined;
  originalTreatmentLevelDisparity: number | null;
}): string => {
  const treatmentGroupName = `${treatmentLevelDefinition.displayName} ${metricDefinition.whiteLabeling.subjectPlural}`;
  // fallback to an empty string because controlVariableName can be null
  const capitalizedControlVariableName = capitalize(controlVariableName ?? '');
  // Determine comparison text based on the sign of originalTreatmentLevelDisparity
  // Negative disparity means treatment < reference (so "less than")
  // Positive disparity means treatment > reference (so "more than")
  const comparisonText =
    originalTreatmentLevelDisparity === null
      ? 'differently than'
      : originalTreatmentLevelDisparity < 0
        ? 'less than'
        : 'more than';

  if (analysisType === 'Oaxaca Beta') {
    return `${capitalizedControlVariableName} explains a significant amount of why ${treatmentGroupName} ${metricDefinition.whiteLabeling.subjectPassiveVerb} ${comparisonText} ${referenceLevelDefinition.displayName} ${metricDefinition.whiteLabeling.subjectPlural} with similar factors.`;
  }

  if (analysisType === 'Oaxaca X' && categoriesName) {
    return `${capitalizedControlVariableName} explains a significant amount of why ${categoriesName.treatmentCategory} ${metricDefinition.whiteLabeling.subjectPlural} ${metricDefinition.whiteLabeling.subjectPassiveVerb} ${comparisonText} ${categoriesName.referenceCategory} ${metricDefinition.whiteLabeling.subjectPlural} with similar factors.`;
  }

  if (analysisType === 'Adding Variables' && categoriesName) {
    return `${capitalizedControlVariableName} significantly impacts the controlled disparity in ${metricDefinition.displayName.toLowerCase()} between ${categoriesName.treatmentCategory} and ${categoriesName.referenceCategory} ${metricDefinition.whiteLabeling.subjectPlural} with similar factors.`;
  }

  return '';
};

export const englishGetHeadlineForExplanatoryFactors = ({
  controlVariableName,
}: {
  controlVariableName: string | null;
}): string => {
  return capitalize(controlVariableName ?? 'Explanatory Factors');
};

export const englishGetExplanationForExplanatoryFactors = ({
  analysisType,
  metricDefinition,
  dimensionDefinition,
  treatmentLevelDefinition,
  referenceLevelDefinition,
  controlVariableName,
  plotType,
  categoriesName,
}: {
  analysisType: string | null;
  metricDefinition: MyMetricDefinition;
  dimensionDefinition: DimensionDefinition;
  treatmentLevelDefinition: LevelDefinition;
  referenceLevelDefinition: LevelDefinition;
  controlVariableName: string | null;
  plotType: RootCauseGroupResult['plot_type'];
  categoriesName: OaxacaCategoriesName | undefined;
}): string => {
  if (!analysisType || !controlVariableName) {
    return '';
  }

  const treatmentGroupName = treatmentLevelDefinition.displayName;
  const referenceGroupName = referenceLevelDefinition.displayName;

  const treatmentGroupPlural = `${treatmentGroupName} ${metricDefinition.whiteLabeling.subjectPlural}`;

  const metricName = `${metricDefinition.displayName.toLowerCase()}${metricDefinition.isMetricBoolean ? ' rate' : ''}`;

  const dimensionDisplayName = dimensionDefinition.displayName.toLowerCase();
  const controlVariableDisplayName = controlVariableName.toLowerCase();

  if (
    analysisType === 'Oaxaca Beta' &&
    plotType === 'barChart' &&
    categoriesName
  ) {
    return `This bar chart shows the estimated ${metricName} for ${referenceGroupName} and ${treatmentGroupPlural} based on ${controlVariableDisplayName}. Our reference is the ${metricName} for those with ${controlVariableDisplayName} level - "${categoriesName.referenceCategory}". For those with other ${controlVariableDisplayName} levels, like "${categoriesName.treatmentCategory}", the chart shows how much the estimated ${metricName} of each ${dimensionDisplayName} changes compared to ${controlVariableName} level - "${categoriesName.referenceCategory}".\n\nThis helps show how ${controlVariableDisplayName} level affects estimated ${metricName} for each ${dimensionDisplayName} when all other factors are the same.`;
  }

  if (analysisType === 'Oaxaca Beta') {
    return `This line chart shows the estimated ${metricName} for ${referenceGroupName} and ${treatmentGroupPlural} based on ${controlVariableDisplayName}. The steepness of the lines shows how much the estimated ${metricName} changes as ${controlVariableDisplayName} changes. If the lines have different slopes, it means that ${controlVariableDisplayName} has a different impact on ${metricDefinition.displayName} depending on the ${dimensionDisplayName} of the ${metricDefinition.whiteLabeling.subjectSingular}.`;
  }

  if (
    ['Adding Variables', 'Oaxaca X'].includes(analysisType) &&
    categoriesName
  ) {
    return `This bar chart shows the estimated ${metricName} for ${categoriesName.treatmentCategory} and ${categoriesName.referenceCategory} ${metricDefinition.whiteLabeling.subjectPlural}, depending on whether or not we include ${controlVariableDisplayName} in the analysis. The bars labeled “Without ${controlVariableDisplayName}” show the estimated ${metricName} of each ${dimensionDisplayName} when we don’t account for ${controlVariableDisplayName} in our analysis. The bars labeled “With ${controlVariableDisplayName}” show the estimated ${metricName} of each ${dimensionDisplayName} when we do account for ${controlVariableDisplayName} in our analysis.\n\nThis helps you clearly see how factoring in differences in ${controlVariableDisplayName} across ${dimensionDisplayName} affects estimated ${metricName} for each ${dimensionDisplayName}, when all other factors are the same.`;
  }

  return '';
};

const mapAnalysisToPendingText = ({
  analysis,
  metricDefinitions,
}: {
  analysis: UserAnalysisInformation;
  metricDefinitions: MyMetricDefinition[];
}) => {
  const customVizId = analysis.customVizRequest.customVizId;

  if (customVizId === 'payBenchmarking' || customVizId === 'payCorrection') {
    return 'Loading Pay Recommendations...';
  } else if (customVizId === 'tableView') {
    return `Generating Table View...`;
  } else if (customVizId === 'summaryStats') {
    return `Generating Summary Stats...`;
  } else if (customVizId === 'hiringCopilot') {
    return 'Loading Hiring Recommendations...';
  } else if (customVizId === 'promotionCopilot') {
    return 'Loading Promotion Recommendations...';
  } else if (customVizId === 'biasAnalysis') {
    const isDeepDive =
      !!analysis.customVizRequest.inputs.extras.treatmentDimensionLevel;

    const metric = analysis.customVizRequest.inputs.extras.metric;
    const metricDefinition = metricDefinitions.find(
      (m) => m.columnHeaderValue === metric,
    );

    if (isDeepDive) {
      return `Analyzing ${metricDefinition?.displayName ?? ''} Deep Dive Analysis...`;
    }

    return `Analyzing ${metricDefinition?.displayName ?? ''} Disparity and Optimization...`;
  } else if (
    customVizId === 'binScatterMultiSelect' ||
    customVizId === 'binScatterCrossSelect'
  ) {
    const metric = analysis.customVizRequest.inputs.extras.metric;
    const metricDefinition = metricDefinitions.find(
      (m) => m.columnHeaderValue === metric,
    );

    return `Analyzing ${metricDefinition?.displayName ?? ''} Trends...`;
  } else if (customVizId === 'pipelineAnalysis') {
    return `Filtering Employee Lifecycle`;
  } else if (customVizId === 'successPhenotypeV2') {
    return `Analyzing Success Factors...`;
  } else if (customVizId === 'topLevelAnalysis') {
    return `Running Top Level Analysis...`;
  } else if (customVizId === 'progress') {
    return `Running Trends Analysis...`;
  } else if (customVizId === 'heatmap') {
    return `Running Heatmap Analysis...`;
  } else if (customVizId === 'nlpGraph') {
    return `Running NLP Graph...`;
  } else if (customVizId === 'timeSeriesTrends') {
    return `Running Time Series Trends...`;
  } else if (customVizId === 'richText') {
    return `Saving Rich Text...`;
  } else if (customVizId === 'geolocation') {
    return `Running Geolocation...`;
  } else if (customVizId === 'externalStreamlit') {
    return `Running External Streamlit...`;
  } else {
    throw guardExhaustive(customVizId);
  }
};

const mapAnalysisToSuccessText = ({
  analysis,
  metricDefinitions,
}: {
  analysis: UserAnalysisInformation;
  metricDefinitions: MyMetricDefinition[];
}) => {
  const customVizId = analysis.customVizRequest.customVizId;

  if (customVizId === 'payBenchmarking' || customVizId === 'payCorrection') {
    return 'Pay Recommendations Ready';
  } else if (customVizId === 'tableView') {
    return `Table View Ready`;
  } else if (customVizId === 'summaryStats') {
    return `Summary Stats Ready`;
  } else if (customVizId === 'hiringCopilot') {
    return 'Hiring Recommendations Ready';
  } else if (customVizId === 'promotionCopilot') {
    return 'Promotion Recommendations Ready';
  } else if (customVizId === 'biasAnalysis') {
    const isDeepDive =
      !!analysis.customVizRequest.inputs.extras.treatmentDimensionLevel;

    const metric = analysis.customVizRequest.inputs.extras.metric;
    const metricDefinition = metricDefinitions.find(
      (m) => m.columnHeaderValue === metric,
    );

    if (isDeepDive) {
      return `${metricDefinition?.displayName ?? ''} Deep Dive Analysis Ready`;
    }

    return `${metricDefinition?.displayName ?? ''} Analysis Ready`;
  } else if (
    customVizId === 'binScatterMultiSelect' ||
    customVizId === 'binScatterCrossSelect'
  ) {
    const metric = analysis.customVizRequest.inputs.extras.metric;
    const metricDefinition = metricDefinitions.find(
      (m) => m.columnHeaderValue === metric,
    );
    return `${metricDefinition?.displayName ?? ''} Group Trends Ready`;
  } else if (customVizId === 'pipelineAnalysis') {
    return `Employee Lifecycle Ready`;
  } else if (customVizId === 'successPhenotypeV2') {
    return `Success Factors Ready`;
  } else if (customVizId === 'topLevelAnalysis') {
    return `Top Level Analysis Ready`;
  } else if (customVizId === 'progress') {
    return `Trends Analysis Ready`;
  } else if (customVizId === 'heatmap') {
    return `Heatmap Analysis Ready`;
  } else if (customVizId === 'nlpGraph') {
    return `NLP Graph Ready`;
  } else if (customVizId === 'timeSeriesTrends') {
    return `Time Series Trends Ready`;
  } else if (customVizId === 'richText') {
    return `Rich Text Saved`;
  } else if (customVizId === 'geolocation') {
    return `Geolocation Ready`;
  } else if (customVizId === 'externalStreamlit') {
    return `External Streamlit Ready`;
  } else {
    throw guardExhaustive(customVizId);
  }
};

const mapAnalysisToFailureText = ({
  analysis,
  metricDefinitions,
}: {
  analysis: UserAnalysisInformation;
  metricDefinitions: MyMetricDefinition[];
}) => {
  const customVizId = analysis.customVizRequest.customVizId;

  if (customVizId === 'payBenchmarking' || customVizId === 'payCorrection') {
    return 'Pay Recommendations Failed';
  } else if (customVizId === 'tableView') {
    return `Table View Failed`;
  } else if (customVizId === 'summaryStats') {
    return `Summary Stats Failed`;
  } else if (customVizId === 'hiringCopilot') {
    return 'Hiring Recommendations Failed';
  } else if (customVizId === 'promotionCopilot') {
    return 'Promotion Recommendations Failed';
  } else if (customVizId === 'biasAnalysis') {
    const isDeepDive =
      !!analysis.customVizRequest.inputs.extras.treatmentDimensionLevel;

    const metric = analysis.customVizRequest.inputs.extras.metric;
    const metricDefinition = metricDefinitions.find(
      (m) => m.columnHeaderValue === metric,
    );

    if (isDeepDive) {
      return `${metricDefinition?.displayName ?? ''} Deep Dive Analysis Failed`;
    }

    return `${metricDefinition?.displayName ?? ''} Analysis Failed`;
  } else if (
    customVizId === 'binScatterMultiSelect' ||
    customVizId === 'binScatterCrossSelect'
  ) {
    const metric = analysis.customVizRequest.inputs.extras.metric;
    const metricDefinition = metricDefinitions.find(
      (m) => m.columnHeaderValue === metric,
    );

    return `${metricDefinition?.displayName ?? ''} Group Trends Failed`;
  } else if (customVizId === 'pipelineAnalysis') {
    return `Employee Lifecycle Failed`;
  } else if (customVizId === 'successPhenotypeV2') {
    return `Unable to load Success Factors`;
  } else if (customVizId === 'topLevelAnalysis') {
    return `Top Level Analysis Failed`;
  } else if (customVizId === 'progress') {
    return `Trends Analysis Failed`;
  } else if (customVizId === 'heatmap') {
    return `Heatmap Analysis Failed`;
  } else if (customVizId === 'nlpGraph') {
    return `NLP Graph Failed`;
  } else if (customVizId === 'timeSeriesTrends') {
    return `Time Series Trends Failed`;
  } else if (customVizId === 'richText') {
    return `Saving Rich Text Failed`;
  } else if (customVizId === 'geolocation') {
    return `Geolocation Failed`;
  } else if (customVizId === 'externalStreamlit') {
    return `External Streamlit Failed`;
  } else {
    throw guardExhaustive(customVizId);
  }
};

export const englishPhrases: Phrases = {
  id: () => `ID`,
  role: () => `Role`,
  passwordComplexityErrorMessage: ({ passwordComplexityErrorCode }) => {
    if (passwordComplexityErrorCode === 'not_long_enough') {
      return `Password must be at least 8 characters`;
    }

    if (passwordComplexityErrorCode === 'missing_digit') {
      return `Password must contain at least one digit`;
    }

    if (passwordComplexityErrorCode === 'missing_lowercase') {
      return `Password must contain at least one lowercase letter`;
    }

    if (passwordComplexityErrorCode === 'missing_uppercase') {
      return `Password must contain at least one uppercase letter`;
    }

    if (passwordComplexityErrorCode === 'missing_special_char') {
      return `Password must contain at least one special character`;
    }

    if (passwordComplexityErrorCode === 'extra_space') {
      return `Password must not contain leading or trailing spaces`;
    }

    throw guardExhaustive(passwordComplexityErrorCode);
  },
  organization: () => `Organization`,
  deepDiveConfidenceText: ({ confidencePercentage }) =>
    `Confidence: ${Math.round(confidencePercentage).toString(10)}%`,
  createNewOrganization: () => `Create New Organization`,
  createNewOrganizationDetails: () =>
    `Please provide the organization details below.`,
  organizationLogo: () => `Organization Logo`,
  organizationLogoDragAndDrop: () =>
    `Drag and drop an image here, or click to select`,
  organizationName: () => `Organization Name (*)`,
  organizationNamePlaceholder: () => `Enter organization name`,
  organizationLogoAdjustCrop: () =>
    `Adjust the crop area to select the logo portion of your image`,
  organizationLogoPreview: () => `Organization logo preview`,
  organizationLogoRemove: () => `Remove Logo`,
  organizationLogoUploading: () => `Uploading image...`,
  organizationLogoFileTypes: () => `PNG, JPG, GIF up to 5MB`,
  organizationLogoEdit: () => `Edit Organization`,
  organizationLogoEditDetails: () =>
    `You can update your organization's name and logo here.`,
  editDatabasesTitle: () => `Databases`,
  manageExternalEntitlements: () => `External Entitlements`,
  manageOrganizationEntitlements: () => `Manage Organization Entitlements`,
  manageOrganizationEntitlementsDescription: () =>
    `Grant or revoke access to external resources for this organization.`,
  delete: () => `Delete`,
  extraOrganizations: () => `Extra Organizations`,
  extraOrganizationsHelp: () =>
    `Extra organizations are additional organizations that you would like to assign this user to access.`,
  addExtraOrganization: () => `Add Extra Organization`,
  requiredFieldsIndicator: () => `(*) Required fields`,
  sideNavExploreTitle: () => englishGetSideNavExploreTitle(),
  sideNavSigma: () => `Sigma`,
  sideNavSquared: () => `Squared`,
  adjustedDisparity: () => `Adjusted disparity`,
  authErrorExpiredResetPassword: () => `Password reset link expired.`,
  authErrorExpiredResetPasswordLink: () => `Resend email`,
  authErrorUserNotFound: () => `Could not login with the provided credentials`,
  authErrorWeakPassword: () =>
    `Password must be at least 8 characters with upper and lowercase letters and symbols`,
  authErrorConfirmPasswordNotMatching: () => `Passwords do not match`,
  backToDashboardLink: () => `Back to dashboard`,
  bias: ({ calibrationFraming }) =>
    calibrationFraming === 'bias' ? `Bias` : `Optimization`,
  biasLevel0: () => `None`,
  biasLevel0No: () => `No`,
  biasLevel2: () => `Low`,
  biasLevel3: () => `Low to Medium`,
  biasLevel4: () => `Medium`,
  biasLevel5: () => `Medium to High`,
  biasLevel6: () => `High`,
  biasTypeInformation: () => `Information`,
  biasTypePreference: () => `Preference`,
  biasTypeStructural: () => `Structural`,
  chanceOfBias: ({ calibrationFraming }) =>
    `Results of ${calibrationFraming === 'bias' ? 'Bias' : 'Optimization'} Tests`,
  changeTreatmentsCta: () => `Select solutions`,
  confirmPasswordInputLabel: () => `Confirm password`,
  contactUs: () => `Contact us`,
  createNewPassword: () => `Create new password`,
  disparityPresentLabel: () => `Medium to High difference present`,
  disparityTypeDisability: () => `Disability`,
  disparityTypeGender: () => `Gender`,
  disparityTypeRace: () => `Race`,
  done: () => `Done`,
  emailInputLabel: () => `Email`,
  errorGeneric: () => `Something went wrong, please try again`,
  focusArea: () => `Focus Area`,
  focusAreaActiveTreatments: () => `Current Active Solutions`,
  focusAreaAttrition: () => `Attrition`,
  focusAreaEngagement: () => `Engagement`,
  focusAreaCurrentState: () => `Current State`,
  focusAreaGroupTrendsHeading: ({ metricDefinition }) => {
    if (metricDefinition.isMetricBoolean) {
      return `Compare ${metricDefinition.displayName} chances for different groups. Ideally, every line matches. Use filters for comparisons.`;
    } else {
      return `Compare ${metricDefinition.displayName} for different groups. Ideally, every line matches. Use filters for comparisons.`;
    }
  },
  focusAreaSelectTreatmentsHeadingTools: () => `Tools`,
  focusAreaSelectTreatmentsHeading: () => `Test Results`,
  focusAreaGroupTrendsSubheading: () => `Learn how to interpret trend lines`,
  focusAreaIndicatorsHeading: () => `Interpreting Trend Lines`,
  focusAreaSelectTreatmentsBlurb: () =>
    `Browse and select solutions to add to your Solution Center. Once solutions are added, you can see their projected impact in the Solution Center.`,
  focusAreaSummaryLearnBiases: () =>
    `Learn about Structural, Preference, and Information Bias`,
  treatmentSelectionHeading: () => `Select Solutions`,
  treatmentCardImpactFactorLabel: ({ impactFactor }) =>
    `Impact Factor: ${impactFactor}`,
  treatmentCardMetricLabel: ({ metricDisplayName }) =>
    `Metric: ${metricDisplayName}`,
  uploadValidationMalformedLine3: () => `Details of First Error`,
  viewSelectionCta: ({
    selectedTreatmentsCount,
  }: {
    selectedTreatmentsCount: number;
  }) =>
    selectedTreatmentsCount > 1
      ? `View selected solutions`
      : 'View selected solution',
  treatmentManagerUpskilling: () => `Manager Upskilling`,
  tableViewHeading: () => 'Table View',
  summaryStatsHeading: () => 'Summary Stats',
  tableCellValueLabel: () => 'Value:',
  tableCellCountLabel: () => 'Count:',
  tableCellSampleSizeLabel: () => 'Sample Size:',
  treatmentManagerUpskillingSummary: ({ focusArea }) => {
    let faAdjective: string;
    let faGerund: string;
    if (focusArea === 'Hiring') {
      faAdjective = 'hiring';
      faGerund = 'hiring';
    } else if (focusArea === 'Promotion') {
      faAdjective = 'promoting';
      faGerund = 'promotion';
    } else {
      faAdjective = '';
      faGerund = '';
    }
    return `This solution will help you support managers whose track records indicate suboptimal decisions with regards to ${faGerund} certain groups.\n\nBy identifying the managers in your organization with a history of suboptimal ${faAdjective} decisions, this solution enables you to provide guidance and/or training to those who need it most.`;
  },
  treatmentIntelligentSourcingStrategy: () => `Intelligent Sourcing Strategy`,
  treatmentIntelligentSourcingStrategySummary: () => {
    return `This solution identifies sourcing channels that will generate the strongest pool of diverse, high-performing candidates.\n\nBased on your historical data as well as insights from your industry, an Intelligent Sourcing Strategy will help you focus recruiting efforts on the most productive channels.`;
  },
  temp7: () => `Solution Center`,
  testStatusAllPassed: () => `All tests passed`,
  testStatusIncomplete: () => `Incomplete`,
  testsFailed: ({ failedTestsCount }) =>
    `${failedTestsCount} ${failedTestsCount === 1 ? 'test' : 'tests'} failed`,
  testsPassed: () => `tests passed`,
  testsResults: () => `Tests Results:`,
  testResults: () => `Test Results`,
  testsPassedCount: ({ passing, total }) => `${passing}/${total} tests passed`,
  testsCountNoLabel: ({ passing, total }) => `${passing}/${total}`,
  /**
   * @deprecated
   */
  treatmentBestPracticesAlgorithm: () => `Best Practices Making Algorithms`,
  /**
   * @deprecated
   */
  treatmentBestPracticesAlgorithmSummary: () =>
    `Utilize mathematically-proven algorithms to determine which candidate characteristics increase your organization's diversity without compromising on performance.`,
  treatmentDiversityCopilot: () => `Diversity Co-Pilot`,
  treatmentDiversityCopilotSummary: ({ focusArea }) => {
    const personType =
      focusArea === FocusAreaEnum.Values.Hiring ? 'applicants' : 'employees';

    return `This automated tool helps you achieve your organization’s diversity goals while also maximizing employee performance.\n\nBased on a mathematically-proven model that identifies the factors most predictive of both performance and diversity within your organization, the Diversity Co-Pilot recommends the most qualified ${personType} within the talent pool.`;
  },
  treatmentCompensationCopilot: () => 'Compensation Co-Pilot',
  treatmentCompensationCopilotSummary: () => {
    return `This automated tool helps you make better and more objective compensation decisions and reduce disparities.\n\nUsing an advanced machine learning algorithm, the Compensation Co-Pilot automatically recommends salary ranges that consider factors from the internal and external market. With this tool by your side, compensation decisions will become more fair and equitable within your organization.`;
  },
  treatmentHiringCopilot: () => 'Hiring Co-Pilot',
  treatmentHiringCopilotSummary: () => {
    return `This automated tool helps you make better and more objective hiring decisions by identifying the most qualified applicants.\n\nUsing an advanced machine learning algorithm, the Hiring Co-Pilot automatically recommends which applicants are the most qualified for a given role. With this tool by your side, the hiring process will become more efficient as you prioritize applicants with characteristics that predict success within your organization.`;
  },
  treatmentPromotionCopilot: () => 'Promotion Co-Pilot',
  treatmentPromotionCopilotSummary: () => {
    return `This automated tool helps you make better and more objective promotion decisions by identifying employees most likely to be ready for the next step.\n\nUsing an advanced machine learning algorithm, the Promotion Co-Pilot automatically identifies employees ready for promotion, based on their attributes and those that predict success in your organization. With this tool by your side, promotion decisions will become more objective and merit-based.`;
  },
  treatmentSourcingCopilot: () => 'Sourcing Co-Pilot',
  treatmentSourcingCopilotSummary: () => {
    return `This automated tool helps you focus recruiting efforts on the applicant sources most likely to yield highly-qualified and diverse candidates.\n\nBased on your current talent acquisition needs, your specific diversity goals, and the composition of the external talent pool, the Sourcing Co-Pilot automatically recommends channels and sourcing volumes for each given role. This tool will help create a more efficient sourcing process and help you reach your diversity goals faster.`;
  },
  // START: These should always say optimization.
  treatmentHiringProcessOptimization: () => 'Hiring Process Optimization',
  treatmentHiringProcessOptimizationSummary: () => {
    return `Measuring and improving your organization’s Hiring processes should be an ongoing effort.\n\nOur Solutions team can work with you to map the current Hiring process within your organization, then recommend targeted improvements to make the process stronger and more objective.`;
  },
  treatmentPerformanceProcessOptimization: () =>
    'Performance Process Optimization',
  treatmentPerformanceProcessOptimizationSummary: () => {
    return `Measuring and improving your organization’s Performance processes should be an ongoing effort.\n\nOur Solutions team can work with you to map the current Performance process within your organization, then recommend targeted improvements to make the process stronger and more objective.`;
  },
  treatmentPromotionProcessOptimization: () => 'Promotion Process Optimization',
  treatmentPromotionProcessOptimizationSummary: () => {
    return `This automated tool helps you make better and more objective promotion decisions by identifying employees most likely to be ready for the next step.\n\nUsing an advanced machine learning algorithm, the Promotion Co-Pilot automatically identifies employees ready for promotion, based on their attributes and those that predict success in your organization. With this tool by your side, promotion decisions will become more objective and merit-based.`;
  },
  // END: These should always say optimization.
  treatmentBiggestImpact: () => `Biggest Impact`,
  treatmentCartButton: () => `Solution Center`,
  treatmentCartCheckoutCta: () => `Go to Solution Center`,
  treatmentCartCheckoutCtaDisabled: () =>
    `Please select solutions before visiting the Solution Center`,
  treatmentCartCollapseTooltip: () => `Click to hide solutions`,
  treatmentCartExpandTooltip: () => `Click to view solutions`,
  treatmentCartIntroBlurb: () =>
    `View solutions you have selected from the Focus Areas here. When you have selected enough solutions to meet your target, activate them in the Solution Center for next steps.`,
  treatmentCartRemoveTooltip: () => `Remove solution`,
  treatmentCenter: () => `Solution Center`,
  treatmentCenterIntroBlurb: () =>
    `Click to activate the solutions that you are currently, or will be, implementing within your organization.`,
  treatmentTrainingStrategyCounterStereotype: () =>
    `Training Strategy (Counter-Stereotype)`,
  treatmentTrainingStrategyCounterStereotypeSummary: () => {
    return `When designed and implemented the right way, training can be an effective way to counter the effects of bias within your organization.\n\nA Counter-Stereotype Training Strategy helps employees discard harmful stereotypes and prejudiced associations that they may hold towards others.\n\nWe aren't trainers, but we can suggest content, vendors, and implementation considerations based on their proven ability to produce real results.`;
  },
  treatmentTrainingStrategyEmpathySkills: () =>
    `Training Strategy (Empathy Skills)`,
  treatmentTrainingStrategyEmpathySkillsSummary: () => {
    return `When designed and implemented the right way, training can be an effective way to counter the effects of bias within your organization.\n\nA Training Strategy to build Empathy Skills will help employees develop the capacity to understand others’ points of view and help foster a culture of understanding.\n\nWe aren't trainers, but we can suggest content, vendors, and implementation considerations based on their proven ability to produce real results.`;
  },
  treatmentTrainingStrategyStructuralInequality: () =>
    `Training Strategy (Structural Inequality)`,
  treatmentTrainingStrategyStructuralInequalitySummary: () => {
    return `When designed and implemented the right way, training can be an effective way to counter the effects of bias within your organization.\n\nA Training Strategy focused on building knowledge of Structural Inequality will help employees understand how policies and practices can inherently favor some groups over others, to be more cognizant of these potential effects when making decisions.\n\nWe aren't trainers, but we can suggest content, vendors, and implementation considerations based on their proven ability to produce real results.`;
  },
  /**
   * @deprecated
   */
  treatmentInterGroupContact: () => `Inter-group Contact`,
  /**
   * @deprecated
   */
  treatmentInterGroupContactSummary: () =>
    `Analyze how diversity amongst your existing teams is impacting your Focus Area metrics at this time.`,
  /**
   * @deprecated
   */
  treatmentInterGroupContactTraining: () => `Inter-group Contact Training`,
  /**
   * @deprecated
   */
  treatmentInterGroupContactTrainingSummary: () =>
    `Work with experts who train individuals or teams to increase collaboration amongst diverse groups within your company.`,
  treatmentManagerBestPractices: () => `Manager Best Practices`,
  treatmentManagerBestPracticesSummary: ({ focusArea }) => {
    let fillText: string;
    if (focusArea === 'Hiring') {
      fillText = 'hire';
    } else if (focusArea === 'Promotion') {
      fillText = 'promote';
    } else {
      fillText = 'evaluate';
    }

    return `This solution will help you uncover and cultivate tactics the most effective managers use to ${fillText} high-performing, diverse talent.\n\nBy identifying the managers in your organization who have a proven aptitude for ${fillText} high-performing, diverse talent, Manager Best Practices enables you to learn more about their approach and encourage others to adopt similar tactics.`;
  },
  treatmentMostPopular: () => `Most Popular`,
  treatmentSuccessPhenotype: () => `Success Phenotype`,
  treatmentSuccessPhenotypeSummary: () => {
    return `This solution defines the characteristics that predict employee performance within your organization so you can optimize criteria used in talent decisions.\n\nUsing advanced analytics and machine learning, the Success Phenotype will identify the specific factors most predictive of performance in your organization. We’ll help you use this information to re-calibrate criteria used in talent decisions so you can provide opportunities to the most qualified people.`;
  },
  treatmentProvideMoreData: () => `Provide More Data`,
  treatmentProvideMoreDataSummary: () => {
    return `There was not enough data for us to confidently provide more insights in this area.\n\nWith more data, we will be able to perform additional analyses and recommend tailored solutions to help your organization improve.`;
  },
  treatmentQuickestWin: () => `Quickest Win`,
  treatmentSelectionLink: () => `Navigate to solutions`,
  treatmentSelectionBlurb: ({ calibrationFraming }) =>
    `Highlighted solutions help address policies and practices that led to failed ${calibrationFraming === 'bias' ? 'bias' : 'optimization'} tests. Visit the Solution Center to finish activating solutions.`,
  treatmentSelectionConfirm: () => `Confirm Changes`,
  sendPasswordReset: () => `Send password reset`,
  serverErrorDataMissingOrg: () =>
    `The organization linked to your account does not exist. Please contact the administrator.`,
  serverErrorDataMissingOrgId: () =>
    `Account is not linked to an organization. Please contact the administrator.`,
  serverErrorDataNotReady: () =>
    `Your data is not ready to be accessed. Please wait to try again`,
  serverErrorMissingRole: () =>
    `Account does not have an assigned role. Please contact the administrator.`,
  someDisparityPresentLabel: () => `Low to Medium difference present`,
  submitDisabledFillAllInputs: () => `Please fill all inputs before submission`,
  raceUnknown: () => `Unknown Race`,
  rawDisparity: () => `Raw Disparity`,
  controlledDisparity: () => `Controlled Disparity`,
  debiasedDisparity: () => `Bias-free Disparity`,
  expectedDisparity: () => `Expected Disparity`,
  percentage: ({ value }) => englishGetPercentage({ value }),
  resetPassword: () => `Reset Password`,
  scatterChartFilterText: () => `Filter by:`,
  focusAreaSummaryBiasLevelTitle: ({ calibrationFraming }) =>
    `${calibrationFraming === 'bias' ? 'Bias' : 'Optimization'} Level`,
  focusAreaSummaryTalentOptimizationTitle: ({ calibrationFraming }) =>
    calibrationFraming === 'bias' ? `Bias Level` : `Optimization`,
  focusAreaSummaryDisparityTitle: ({ dimension }) => `${dimension} Disparity`,
  focusAreaSummaryGenderDisparityTitle: () => `Gender Disparity`,
  focusAreaSummaryRacialDisparityTitle: () => `Racial Disparity`,
  focusAreaSummaryDisparityRace: () => `Racial Disparity`,
  focusAreaSummaryTestResults: ({ calibrationFraming }) =>
    `Results of ${calibrationFraming === 'bias' ? 'Bias' : 'Optimization'} Tests`,
  focusAreaTopContributorsHeading: ({ calibrationFraming }) =>
    `Top ${calibrationFraming === 'bias' ? 'Bias' : 'Optimization'} Contributors`,
  focusAreaTreatmentGoal: () => `Solution Goal`,
  focusAreaCompensation: () => `Compensation`,
  focusAreaDisplayName: ({ focusArea }) =>
    englishGetFocusAreaDisplayName({ focusArea }),
  forgotYourPassword: () => `Forgot your password?`,
  genderUnknown: () => `Unknown Gender`,
  glossary: () => `Glossary`,
  glossaryHeading: () => `Glossary Of Terms`,
  glossaryInstructionsBlurb: () =>
    `This list includes some terms you’ll often see when engaging in work that involves diversity, equity, and inclusion, as well as terms that are specific to the Sigma Squared experience. To find a specific word you may be looking for, press Control/Command+F.`,
  glossaryPraticipateBlurb: () =>
    `The DE&I conversation is constantly evolving, as will these definitions. We encourage everyone to participate in the discussion regarding their ongoing evaluation and refinement.`,
  incompleteTestBlurb: () => {
    return `There was not enough data for us to confidently provide more insights in this area.\n\nWith more data, we will be able to perform additional analyses and recommend tailored solutions to help your organization improve.`;
  },
  inputErrorEmail: () => `Please enter a valid email`,
  loadingText: () => `Loading....`,
  logIn: () => `Log In`,
  logInWithSSO: () => `Log In with SSO`,
  logOut: () => `Log Out`,
  lowDisparityPresentLabel: () => `Zero to Low difference present`,
  navBackToHome: () => `Back to home`,
  noSelectedTreatments: () => `No solutions selected`,
  allTestsPassed: () => `All tests passed`,
  noRecommendedSolutions: () => `You passed! No solutions necessary`,
  testsSelectAVideoBelowToStartWatching: () =>
    `Select a Video Below to Start Watching`,
  testsLearnAboutFailedTests: () => `Learn about failed tests`,
  testsVideoComingSoon: () => `Video Coming Soon!`,
  testsVideoUnavailable: () => `Video Unavailable`,
  overview: () => `Overview`,
  overviewNavigationDashboard: () => 'Dashboard',
  overviewNavigationEmployeeLifecycle: () =>
    englishGetOverviewNavigationEmployeeLifecycle(),
  overviewScoreBiasLevelLabel: ({ calibrationFraming }) =>
    `Overall ${calibrationFraming === 'bias' ? 'bias' : 'optimization'} detected`,
  overviewScoreBiasTestsLabel: ({ calibrationFraming }) =>
    `${calibrationFraming === 'bias' ? 'Bias' : 'Optimization'} tests passed`,
  overviewScoreHeading: ({ calibrationFraming }) =>
    calibrationFraming === 'bias' ? `Bias Test Score` : `Optimization Score`,
  overviewTopContributorsBlurb: ({ calibrationFraming }) =>
    `The most effective solutions will be those that are applicable to these departments, which are the highest contributors to your overall ${calibrationFraming === 'bias' ? 'bias' : 'optimization'} score. `,
  overviewTopContributorsHeading: ({ calibrationFraming }) =>
    `Top ${calibrationFraming === 'bias' ? 'Bias' : 'Optimization'} Contributors`,
  overviewTreatmentsCtaLink: () => `Go to Solution Center`,
  overviewTreatmentsHeading: () => `Current Active Solutions`,
  overviewVisualizationBlurb: () =>
    `Explore more of your insights and choose solutions to address your organization's inefficiencies by clicking on a Focus Area.`,
  overviewVisualizationContributors: () => `Top Area Contributors`,
  overviewVisualizationHeading: ({ calibrationFraming }) =>
    `${calibrationFraming === 'bias' ? 'Bias Level' : 'Optimization'} by Focus Area`,
  passwordInputLabel: () => `Password`,
  passwordResetEmailSent: () =>
    `Thanks! You'll get an email with a link to reset your password shortly.`,
  predicted: () => `predicted`,
  disparityHeading: ({ disparityType }) =>
    `Is there disparity by ${disparityType}`,
  failedTestBlurb: ({ biasTypeName, focusAreaName }) =>
    capitalize(
      `${biasTypeName} inefficiencies towards this dimension group has been detected. This group is experiencing ongoing adverse effects from at least one ${focusAreaName}-related practice or policy.`,
    ),
  focusAreaDisparitiesBlurb1: ({ noun }) =>
    `The following graph allows you to examine disparity between different demographic groups in terms of their race, gender, or disability status. The black solid line represents the baseline demographic, which is the most historically benefitted group, and displays their ${noun} compared to their qualification. Use the filters below the graph to compare any differences in probability trends between the baseline and all other demographics.`,
  focusAreaDisparitiesBlurb2: ({ noun }) =>
    `Ideally, having a greater qualification index increases a person’s ${noun}.`,
  focusAreaIndicatorsBlurb: ({ metricDefinition, calibrationFraming }) => {
    let noun: string;
    if (metricDefinition.isMetricBoolean) {
      noun = `${metricDefinition.displayName.toLowerCase()} probability`;
    } else {
      noun = metricDefinition.displayName.toLowerCase();
    }
    return `In a best-case scenario, every line will overlap each other. This would mean that each demographic has the same ${noun} based on their qualification and is being treated equally. However, any gap between the lines means there is a difference in probability between the groups. A larger gap indicates a larger difference between groups and, therefore, a greater potential for ${calibrationFraming === 'bias' ? 'bias' : 'optimization'}. An intersecting line indicates that at one point, groups have the same ${noun} based on their qualification, but at other points they are not equal.`;
  },
  focusAreaIntroBlurb: ({ focusAreaName }) =>
    `View insights for ${focusAreaName}-related practices found within your organization.`,
  inputErrorRequiredGeneric: ({ inputName }) =>
    `${inputName} field cannot be empty`,
  levelOfBiasBlurb: ({ focusAreaName, calibrationFraming }) =>
    `The ${calibrationFraming === 'bias' ? 'level of bias' : 'optimization'} within your organization’s ${focusAreaName}-related practices is calculated based on how many tests your organization has passed within the three types of bias we examine. The goal is to pass every test and see zero bias detected, but if it is present you can improve your score by selecting and implementing solutions that change your practices.`,
  overviewScoreBiasTestsResults: ({ passedTests, totalTests }) =>
    `${passedTests} out of ${totalTests}`,
  overviewTreatmentsBlurb: ({
    totalTreatments,
    percentImprovementPrediction,
    calibrationFraming,
  }) =>
    `Solutions help address the ${calibrationFraming === 'bias' ? 'bias' : 'optimization'} within your organization. Based on your current insights, we recommend implementing a maximum of ${totalTreatments} to help ${
      calibrationFraming === 'bias'
        ? 'reduce your bias'
        : 'increase your optimization'
    } by ${percentImprovementPrediction}%.`,
  passingTestBlurb: ({ focusAreaName, biasTypeName, calibrationFraming }) =>
    `All ${focusAreaName}-related ${biasTypeName} ${calibrationFraming === 'bias' ? 'bias' : 'optimization'} tests for this dimension group are currently passing! No solutions are recommended at this time.`,
  polarChartTooltipTestStatement: ({ passingTests, totalTests }) =>
    `${passingTests} out of ${totalTests} tests passed`,
  polarChartTooltipTreatmentStatement: ({ availableTreatments }) =>
    `${availableTreatments} solutions available`,
  predictionsChartTooltipActivePlural: ({ count }) =>
    `${count} solutions active`,
  predictionsChartTooltipActiveSingular: ({ count }) =>
    `${count} solution active`,
  predictionsChartTooltipFailedPlural: ({ count }) => `${count} failed tests`,
  predictionsChartTooltipFailedSingular: ({ count }) => `${count} failed test`,
  predictionsChartTooltipPassedPlural: ({ count }) => `${count} passed tests`,
  predictionsChartTooltipPassedSingular: ({ count }) => `${count} passed test`,
  temp2: ({ RaceGenderDisability, corresponding }) =>
    `${RaceGenderDisability}: ${corresponding}`,
  treatmentSelectionCountPlural: ({ count }) => `${count} solutions selected`,
  treatmentSelectionCountSingular: ({ count }) => `${count} solution selected`,
  treatmentSelectionTestsFailed: ({ failedTestsCount, totalTestsCount }) =>
    `${failedTestsCount} of ${totalTestsCount} tests failed`,
  treatmentSelectionTestsIncomplete: ({ numTests }) => `${numTests} incomplete`,
  treatmentsActiveCountPlural: ({ count }) => `${count} solutions active`,
  treatmentsActiveCountSingular: ({ count }) => `${count} solution active`,
  uploadValidationMalformedLine1: ({ errorCount }) =>
    `Total File Errors: ${errorCount}`,
  uploadValidationMalformedLine2: ({ rowsWithError }) =>
    `Errors in Data Row(s): ${rowsWithError}`,
  uploadValidationMalformedLine4: ({ firstErrorRow, firstErrorMessage }) =>
    `Row ${firstErrorRow}: ${firstErrorMessage}`,
  welcomeTitle: () => `Welcome to Sigma2`,
  welcomeBlurb: () =>
    `Please come back once your organization admin has completed the organization setup process.`,
  rootCauseAnalysisUnavailable: () =>
    `Root Cause Analysis is unavailable for this upload.`,
  rootCauseAnalysisEmpty: () =>
    `A root cause cannot be provided at this time. This could be due to insufficient data, or because we cannot explain the disparity with high confidence. Please reach out to your Sigma Squared team for more information.`,

  piplineAnalysisDemographicDescription: ({
    phaseName,
    count,
    shortDemographicLabel,
    pctOfEvent,
  }) => {
    return `${count} ${shortDemographicLabel} applicants were on the ${phaseName.toLowerCase()} pool, and that is ${pctOfEvent}% of the total ${phaseName}.`;
  },
  candidates: () => `Candidates`,
  pipelineAnalysisSectionTitleApplicantPool: () => `Applicant Pool`,
  pipelineAnalysisSectionTitleHired: () => `Hired`,
  pipelineAnalysisSectionTitleNotHired: () => `Not Hired`,
  pipelineAnalysisSectionTitleHighPerformers: () => `High Performers`,
  pipelineAnalysisSectionTitleLowPerformers: () => `Low Performers`,
  pipelineAnalysisSectionTitlePromoted: () => `Promoted`,
  pipelineAnalysisSectionTitleNotPromoted: () => `Not Promoted`,
  pipelineAnalysisSectionTitleStayed: () => `Stayed`,
  pipelineAnalysisSectionTitleLeft: () => `Left`,
  impactFactorLow: () => `Low`,
  impactFactorMedium: () => `Medium`,
  impactFactorHigh: () => `High`,
  pipelineDemographicTooltipApplicantPool: ({
    count,
    shortDemographicLabel,
    pctOfEvent,
  }) =>
    `${count} ${shortDemographicLabel} applicants applied, and that is ${pctOfEvent}% of the total applicant pool.`,
  pipelineDemographicTooltipHired: ({
    count,
    shortDemographicLabel,
    pctOfEvent,
  }) =>
    `${count} ${shortDemographicLabel} applicants were hired, and that is ${pctOfEvent}% of the total hires.`,
  pipelineDemographicTooltipNotHired: ({
    count,
    shortDemographicLabel,
    pctOfEvent,
  }) =>
    `${count} ${shortDemographicLabel} applicants were not hired, and that is ${pctOfEvent}% of the total not hired.`,
  pipelineDemographicTooltipHighPerformers: ({
    count,
    shortDemographicLabel,
    pctOfEvent,
  }) =>
    `${count} ${shortDemographicLabel} employees were high performers, and that is ${pctOfEvent}% of the total high performers.`,
  pipelineDemographicTooltipLowPerformers: ({
    count,
    shortDemographicLabel,
    pctOfEvent,
  }) =>
    `${count} ${shortDemographicLabel} employees were low performers, and that is ${pctOfEvent}% of the total low performers.`,
  pipelineDemographicTooltipPromoted: ({
    count,
    shortDemographicLabel,
    pctOfEvent,
  }) =>
    `${count} ${shortDemographicLabel} employees were promoted, and that is ${pctOfEvent}% of the total promoted.`,
  pipelineDemographicTooltipNotPromoted: ({
    count,
    shortDemographicLabel,
    pctOfEvent,
  }) =>
    `${count} ${shortDemographicLabel} employees were not promoted, and that is ${pctOfEvent}% of the total not promoted.`,
  pipelineDemographicTooltipStayed: ({
    count,
    shortDemographicLabel,
    pctOfEvent,
  }) =>
    `${count} ${shortDemographicLabel} employees stayed, and that is ${pctOfEvent}% of the total stayed.`,
  pipelineDemographicTooltipLeft: ({
    count,
    shortDemographicLabel,
    pctOfEvent,
  }) =>
    `${count} ${shortDemographicLabel} employees left, and that is ${pctOfEvent}% of the total left.`,
  learnAboutBiasesModalTitle: () =>
    `Learn about Structural, Preference and Information Bias`,
  focusAreaDisabledCallout: () => `Upgrade to unlock`,
  focusAreaDisabledTitle: ({ focusAreaName }) => `${focusAreaName} Deep Dive`,
  focusAreaDisabledText: () =>
    `View your organization's engagement levels and delve into the reasons behind the figures, empowering you to select the most impactful solutions.`,
  focusAreaDisabledButton: () => `Contact Us to Upgrade`,
  focusAreaDisabledEmailSubject: ({ focusAreaName }) =>
    `How can I upgrade to learn more about ${focusAreaName}`,
  focusAreaEmptyCallout: () => `Provide more data`,
  focusAreaEmptyTitle: () => `We need more data`,
  focusAreaEmptyText: () =>
    `To deliver deeper insights, we require more comprehensive data. Please reach out to our support team for guidance on enriching your dataset.`,
  focusAreaEmptyButton: () => `Contact Support`,
  focusAreaEmptyEmailSubject: ({ focusAreaName }) =>
    `Can you help me gain insight into ${focusAreaName}`,

  focusAreaKeyTakeawayCardAchievementTitle: () => `Let's Celebrate`,
  focusAreaKeyTakeawayCardRiskTitle: () => `Focus On`,
  focusAreaKeyTakeawayCardSolutionTitle: () => `Top Solutions`,
  focusAreaKeyTakeawayTreatmentSelectionModalMoreSolutionsTitle: () =>
    'More solutions',

  focusAreaKeyTakeawayCardPatternSummarySingularHtml: ({ pattern }) => [
    { text: 'Pattern detected:', isBold: true },
    { text: `Present in 1 ${pattern}.` },
  ],
  focusAreaKeyTakeawayCardPatternSummaryPluralHtml: ({
    pluralPattern,
    numPatternsFound,
  }) => [
    { text: 'Pattern detected:', isBold: true },
    { text: ` Present in ${numPatternsFound} ${pluralPattern}s.` },
  ],
  focusAreaDisparityConfidence: ({ value }) => `Confidence: ${value}`,
  focusAreaDisparityInsightTitle: () => `Insight`,
  focusAreaDisparityRootCauseAnalysisLink: () => `Go to Root Cause Analysis`,
  focusAreaDisparityRootCauseAnalysisUnableToProvide: () =>
    `A root cause cannot be provided at this time. This could be due to insufficient data, or because we cannot explain the disparity with high confidence. Please reach out to your Sigma Squared team for more information.`,
  focusAreaDisparityRootCauseAnalysisSameFiltersTitle: () =>
    `Update Filter Options`,
  focusAreaDisparityRootCauseAnalysisSameFiltersBlurb1: () =>
    `The filter options you have selected are the same.`,
  focusAreaDisparityRootCauseAnalysisSameFiltersBlurb2: () =>
    `Try changing the filters to check for a disparity`,
  focusAreaSummaryTitle: ({ calibrationFraming }) =>
    `Disparity & ${calibrationFraming === 'bias' ? 'Bias' : 'Optimization'} Levels`,
  focusAreaDisparityCalibrationTypeLink: () => `Learn about test types`,
  focusAreaDisparityConfidencePlaceholder: () => `--`,
  focusAreaDisparityConfidenceNA: () => `N/A`,
  focusAreaDisparityCalibrationCaption: ({
    focusAreaName,
    calibrationFraming,
  }) =>
    `${calibrationFraming === 'bias' ? 'bias' : 'optimization'} detected in ${focusAreaName}`,
  focusAreaDisparityCalibrationLevelTooltip: ({
    calibrationFraming,
    metricDefinition,
  }) =>
    `The level of ${calibrationFraming === 'bias' ? 'bias' : 'optimization'} within your organization's ${metricDefinition.whiteLabeling.proceseesDescription} is calculated based on how many tests your organization has passed within the three types of ${calibrationFraming === 'bias' ? 'bias' : 'optimization'} we examine. The goal is to pass every test. You can improve your score by selecting and implementing solutions that change your practices.`,
  focusAreaDisparityCalibrationLevelLabel: ({ testType }) =>
    `${testType} Tests`,
  focusAreaDeepDiveTitle: () => 'Deep Dive',
  focusAreaRootCauseAnalysisTitle: () => 'Root Cause Analysis',
  focusAreaRootCauseAnalysisBarGraphDisparityLabel: ({ percentage }) =>
    `${percentage}% disparity`,
  focusAreaRootCauseAnalysisBarGraphEntryWageDisparityLegend: () =>
    'Entry Wage Disparity',
  focusAreaRootCauseAnalysisBarGraphTeamLegend: () => 'Team',
  men: () => 'Men',
  women: () => 'Women',
  selectAll: () => `Select All`,
  selectAllLabel: ({ count }) => `All (${count})`,
  noResultsFound: () => `No results found`,
  analyze: () => `Analyze`,
  backToTop: () => `Back to top`,
  collapse: () => 'Collapse',
  hiringCopilotFilterDepartment: () => 'Department',
  hiringCopilotFilterRole: () => 'Role',
  hiringCopilotFilterLocation: () => 'Location',
  hiringCopilotFilterTime: () => 'Time',
  hiringCopilotFilterTimeLastMonth: () => 'Last Month',
  hiringCopilotLineGraphYAxisLabel: () => 'NUMBER OF EMPLOYEES',
  hiringCopilotPerformanceBarLowReadiness: () => 'LOW READINESS',
  hiringCopilotPerformanceBarAverageReadiness: () => 'AVERAGE READINESS',
  hiringCopilotPerformanceBarHighReadiness: () => 'HIGH READINESS',
  hiringCopilotTooltipID: ({ id }) => `ID: ${id}`,
  hiringCopilotTooltipReadiness: () => `Readiness:`,
  copilotTooltipStatisticalConfidence: () => `Statistical confidence`,
  copilotTooltipExperience: () => `Industry Experience:`,
  copilotTooltipEducation: () => `Level of Education:`,
  copilotTooltipLocation: () => `Location Data:`,
  copilotTooltipSchool: () => `School:`,
  copilotTooltipNotEnoughData: () => `Not Enough Data`,
  copilotTooltipSuggestedCompensation: () => `Suggested Compensation`,
  hiringCopilotTooltipLinkedIn: () => `LinkedIn:`,
  hiringCopilotAddToSlate: () => `Add to list`,
  hiringCopilotRemoveFromSlate: () => `Remove from Slate`,
  hiringCopilotReadinessRating: () => `Readiness Rating`,
  hiringCopilotReadinessRatingTooltipText:
    () => `Sigma Squared's forecast for an applicant's performance based on
                          your current and historical employees' skills and performance.`,
  promotionCopilotReadinessRatingTooltipText:
    () => `Sigma Squared's forecast for a candidate's performance based on
                          your current and historical employees' skills and performance.`,
  hiringCopilotOver40: () => `Over 40`,
  hiringCopilotUnder40: () => `Under 40`,
  hiringCopilotSlateActionsShare: () => `Share`,
  hiringCopilotSlateActionsDownload: () => `Download`,
  hiringCopilotSlateHeaderTitle: () => `Slate`,
  hiringCopilotSlateYourSlateDescription: ({ calibrationFraming }) =>
    `These are the top candidates that will also help ${calibrationFraming === 'bias' ? 'reduce bias' : 'increase optimization'}. Customize and download the list.`,
  promotionCopilotSlateYourSlateDescription: ({ calibrationFraming }) =>
    `These are the top employees that will also help ${calibrationFraming === 'bias' ? 'reduce bias' : 'increase optimization'}. Customize and download the list.`,
  hiringCopilotResetSlate: () => `Reset to recommendation`,
  hiringCopilotSlateYourSlate: () => `Your Slate`,
  hiringCopilotSlateHighestToLowest: () => `Highest to Lowest`,
  hiringCopilotSlateLowestToHighest: () => `Lowest to Highest`,
  hiringCopilotSlateNumberOfCandidates: ({ count }) => `${count} Candidate(s)`,
  promotionCopilotSlateNumberOfCandidates: ({ count }) =>
    `${count} Employee(s)`,
  hiringCopilotSlateEmptyStateTitle: () => `No applicants found`,
  hiringCopilotSlateEmptyStateDescription:
    () => `The filtered data set does not include any applicants. Try
                          changing the filters to check for candidates.`,
  hiringCopilotSlateItemID: ({ id }) => `ID: ${id}`,
  hiringCopilotSlateItemReadiness: () => `Readiness:`,
  hiringCopilotSlateItemOffer: () => `Offer:`,
  hiringCopilotMyListAverageReadinessTitle: () => `Average Readiness`,
  hiringCopilotMyListAverageReadinessDescription: () =>
    `All selected candidates`,

  hiringCopilotChartDescription: () =>
    "This chart illustrates the “readiness” of job applicants, based on comparison to the attributes of employees who have historically performed well in your organization. It allows you to gauge how applicants (represented by dots ⬤) measure up against your organization's current employees (represented by the line ∿).",

  promotionCopilotChartDescription: () =>
    `This chart illustrates how ready your current employees are for promotion, based on comparison to the attributes of employees who have historically performed well in your organization. It allows you to gauge how candidates (represented by dots ⬤) measure up against your organization's current employees (represented by the line ∿).`,

  hiringCopilotTableDescription: () =>
    'This list ranks job applicants by “readiness,” based on comparison to the attributes of employees who have historically performed well in your organization.',

  promotionCopilotTableDescription: () =>
    'This list ranks employee candidates by “readiness,” based on comparison to the attributes of employees who have historically performed well in your organization.',

  promotionCopilotApplicantPoolTitle: () => `Employee Ranking`,

  hiringCopilotEmptyStateTitle: () => `No applicants found`,
  hiringCopilotEmptyStateDescription:
    () => `The filtered data set does not include any applicants. Try
                          changing the filters to check for candidates.`,

  promotionCopilotEmptyStateTitle: () => `No employees found`,
  promotionCopilotEmptyStateDescription: () =>
    `The filtered data set does not include any employees. Try changing the filters to check for candidates.`,

  hiringCopilotTitle: () => `Hiring Copilot`,
  promotionCopilotTitle: () => `Promotion Copilot`,
  payBenchmarkingTitle: () => `Pay Benchmarking`,
  payCorrectionTitle: () => `Pay Correction`,
  hiringCopilotErrorMessage: () =>
    `There is not enough data to calculate readiness, please adjust your filters`,
  promotionCopilotErrorMessage: () =>
    `There is not enough data to calculate readiness. Please adjust your filters`,
  copilotTitle: ({ focusArea }) => `${focusArea} Copilot`,
  unlockCompetitiveAdvantage: () => `Unlock competitive advantage`,
  copilotTopCandidatesIdentified: () => `Top candidates identified`,
  copilotTopEmployeesIdentified: () => `Top employees identified`,
  hiringCopilotDescription:
    () => `Hire the best candidates while remedying your identified
                          disparities.`,
  promotionCopilotDescription: () => `Promote your top performers without bias`,
  payBenchmarkingDescription: () =>
    `The power of market benchmarks to determine fair compensation offers.`,
  payCorrectionDescription: () =>
    `Precise adjustment recommendations based on performance and experience.`,
  statisticalConfidenceHigh: () => `High Statistical Confidence`,
  statisticalConfidenceMedium: () => `Medium Statistical Confidence`,
  statisticalConfidenceLow: () => `Low Statistical Confidence`,
  copilotOpen: () => `Open Copilot`,
  copilotEnableIt: () => `Get in touch to enable`,
  degreeNoDegree: () => `No Degree`,
  degreeAssociatesDegree: () => `Associates Degree`,
  degreeBachelorsDegree: () => `Bachelors Degree`,
  degreeMastersDegree: () => `Masters Degree`,
  degreeProfessionalDegree: () => `Professional Degree`,
  degreeDoctoralDegree: () => `Doctoral Degree`,
  degreeUnknown: () => `N/A`,
  dateRangeTextLastMonth: () => `Last Month`,
  dateRangeTextLastWeek: () => `Last week`,
  dateRangeTextFromTo: ({ from, to }) => {
    const defaultMessage = 'No date selected';

    if (from && to) {
      return `${getDateAsMMMDDYYYY(from)} - ${getDateAsMMMDDYYYY(to)}`;
    }

    if (from) {
      return getDateAsMMMDDYYYY(from);
    }

    if (to) {
      return getDateAsMMMDDYYYY(to);
    }

    return defaultMessage;
  },
  applicationDateLabel: () => 'Application Date Range',
  tools: () => `Tools`,
  help: () => `Help`,
  focusAreas: () => `Focus Areas`,
  copilot: () => `Co-pilot`,
  explorePageTitle: () => `Explore`,
  heatmapPageTitle: () => `Heatmap`,
  tableViewPageTitle: () => `Tables`,
  summaryStatsPageTitle: () => `Summary Stats`,
  richTextPageTitle: () => `Rich Text`,
  geolocationPageTitle: () => `Geolocation`,
  customAppsPageTitle: () => `Custom Apps`,
  copilotNavigationHiring: () => `Hiring`,
  copilotNavigationPayBenchmarking: () => `Pay Benchmarking`,
  copilotNavigationPayCorrection: () => `Pay Correction`,
  copilotNavigationPromotion: () => `Promotion`,
  compUnitSalary: () => `Salary`,
  compUnitHourly: () => `Hourly`,
  tablePaginationFooter: ({ numVisibleItems, numTotalItems }) =>
    `Showing ${formatNumber(numVisibleItems)} of ${formatNumber(
      numTotalItems,
    )} entries`,
  dateRangeStartMonthLabel: () => `From`,
  dateRangeEndMonthLabel: () => `To`,
  payCorrectionDisplayType: ({ displayType }) => {
    return englishGetPayCorrectionDisplayType({ displayType });
  },
  payCorrectionDisplayTypeTitle: ({ displayType }) => {
    return englishGetPayCorrectionDisplayType({ displayType });
  },
  payCorrectionBiasType: ({ biasType }) => {
    const biasTypeMap: Record<string, string> = {
      'by-race': 'By Race',
      'by-gender': 'By Gender',
      overall: 'Overall',
    };

    return biasTypeMap[biasType];
  },
  payCorrectionTooltipPayGap: () => `Pay Gap:`,
  payCorrectionTooltipNeedsAttention: () => `Needs Attention:`,
  payCorrectionTooltipOnAverageUnderpaid: () => `On average underpaid:`,
  payCorrectionTooltipBudgetNeeded: () => `Budget needed:`,
  payCorrectionProjectedGenderPayGapTooltip: ({
    getPrivilegedLevelForDimension,
  }) => {
    const privGender = getPrivilegedLevelForDimension('Gender');

    if (!privGender) {
      return '';
    }

    return `This is the pay gap that will exist for all employees excluding ${privGender.displayName} employees, assuming all of the recommended pay adjustments are adopted.`;
  },
  payCorrectionProjectedRacePayGapTooltip: ({
    getPrivilegedLevelForDimension,
  }) => {
    const privRace = getPrivilegedLevelForDimension('Race');

    if (!privRace) {
      return '';
    }

    return `This is the pay gap that will exist for all employees excluding ${privRace.displayName} employees, assuming all of the recommended pay adjustments are adopted.`;
  },
  payCorrectionTodaysPayGapTooltip: () =>
    'This is the total current gap between actual and recommended salaries for employees who need attention.',
  simple: () => `Simple`,
  advanced: () => `Advanced`,
  databasesPageOrganizationSelectBoxLabel: () => `Organization`,
  databasesPageWelcomeText: () =>
    `Welcome! Please select an organization to begin managing their data.`,
  databaseNameLabel: () => `Database Name`,
  databaseNewSubmitButtonLabel: () => `Create Database`,
  executiveSummary: () => `Executive Summary`,
  topSolutions: () => `Top Solutions`,
  calibration: ({ calibrationFraming }) =>
    calibrationFraming === 'bias' ? `Bias` : `Optimization`,
  insight: () => `Insight`,
  talentCalibration: ({ calibrationFraming }) =>
    calibrationFraming === 'bias' ? 'Bias Levels' : `Optimization`,
  insightType: ({ insight, levelDisplay }) => {
    return `${levelDisplay} ${insight.type}`;
  },
  hidden: () => `Hidden`,
  insightNumMinutesToRead: ({ insight }) => {
    const numGraphs = insight.groupResults.length;
    const avgMinToReadGraph = 1;
    const minRead = Math.max(numGraphs * avgMinToReadGraph, 1);

    return String(minRead) + ' min read';
  },
  insightConfidencePercentage: ({ insight }) => {
    if (!insight.confidencePercentage) {
      return '';
    }

    return `${insight.confidencePercentage}% confidence`;
  },
  insightDetailsGraphExplanationTitle: ({ groupResult, numerator }) => {
    return `${numerator}. ${upperFirst(groupResult.control_variable)}`;
  },
  insightBackToAllInsights: () => {
    return 'Back to all insights';
  },
  insightDownload: () => {
    return 'Download';
  },
  downloadAnalysis: () => {
    return 'Download Analysis';
  },
  insightDisparityBarChartWithControlVariable: ({ controlVariable }) => {
    return `With ${controlVariable}`;
  },
  insightDisparityBarChartWithoutControlVariable: ({ controlVariable }) => {
    return `Without ${controlVariable}`;
  },
  insightRelatedInsightsHeading: () => {
    return 'Related Insights';
  },
  insightAllInsightsTitle: () => {
    return 'All Insights';
  },
  insightAllInsightsSubtitle: () => {
    return 'Ordered by statistical significance';
  },
  insightsNoInsightsFound: () => 'No insights found',
  insightNotFoundHeadline: () => 'Insight not found',
  insightNotFoundBody: () => 'The insight you are looking for does not exist.',

  successPhenotypeTitle: () => {
    return englishGetSuccessPhenotypeTitle();
  },
  successPhenotypeV2Subtitle: () => {
    return ``;
  },
  successPhenotypeV2BarGraphTitle: ({
    activeTrait,
    controlVariableDefinitionsMapping,
  }) => {
    return controlVariableDefinitionsMapping[
      activeTrait.controlVariableColumnHeaderValue
    ].displayName;
  },
  successPhenotypeV2BarGraphDescription: ({
    bestTraitLevel,
    controlVariableDefinition,
    metricDisplayName,
  }) => {
    let prefix = '';

    switch (bestTraitLevel.type) {
      case 'twoSided': {
        const formattedTraitLevelValueWithoutComparisonOperator =
          formatTraitLevelValue({
            controlVariableDefinition,
            traitLevel: bestTraitLevel,
          }).replace(/^(>|≤)/, '');

        prefix = `Having ${formattedTraitLevelValueWithoutComparisonOperator}`;

        break;
      }

      case 'lessThanOrEqual': {
        const formattedTraitLevelValueWithoutComparisonOperator =
          formatTraitLevelValue({
            controlVariableDefinition,
            traitLevel: bestTraitLevel,
            withoutUnit: true,
          }).replace(/^(>|≤)/, '');

        const unitSinglular =
          controlVariableDefinition.numericalTraitDefinition?.unitSingular ??
          DEFAULT_UNITS.singular;

        const unitPlural =
          controlVariableDefinition.numericalTraitDefinition?.unitPlural ??
          DEFAULT_UNITS.plural;

        const units = bestTraitLevel.value === 1 ? unitSinglular : unitPlural;

        prefix = `Having ${formattedTraitLevelValueWithoutComparisonOperator} or less ${units} of`;

        break;
      }

      case 'greaterThan': {
        const formattedTraitLevelValueWithoutComparisonOperator =
          formatTraitLevelValue({
            controlVariableDefinition,
            traitLevel: bestTraitLevel,
          }).replace(/^(>|≤)/, '');

        prefix = `Having more than ${formattedTraitLevelValueWithoutComparisonOperator} of`;

        break;
      }

      case 'equal': {
        prefix = `Having ${bestTraitLevel.value.toLowerCase()}`;
        break;
      }
    }

    return `${prefix} ${controlVariableDefinition.displayName.toLowerCase()} is most predictive for ${metricDisplayName.toLowerCase()}.`;
  },
  successPhenotypeV2EmptyStateTitle: () =>
    'Dive into the data and uncover the key factors of successful employees',
  successPhenotypeV2EmptyStateSubtitle: () =>
    "Customize the fields above to generate personalized Success Factors tailored to your organization's desired outcomes.",
  successPhenotypeV2MissingDataStateTitle: () =>
    "There isn't enough data to generate Success Factors",
  successPhenotypeV2MissingDataStateSubtitle: () =>
    'Please adjust the filters and/or metric to generate Success Factors.',
  successPhenotypeMetricBarText: () => {
    return `Predictors for`;
  },
  heatmapAnalysisMetricBarText: () => `Controlled disparities by`,
  successPhenotypeDescription: () => {
    return 'Based on your organization’s skills and productivity data, these are the set of characteristics that make individuals more likely to achieve success in their role. To build a team of top performers, use this phenotype as a guideline.';
  },
  successPhenotypeLoading: () => {
    return 'Generating Success Factors...';
  },
  successPhenotypeCompanyPhenotypeTitle: () => {
    return 'Company Success Factors';
  },
  successPhenotypeMetricsLabel1: () => {
    return 'Optimize for:';
  },
  successPhenotypeMetricsLabel2: () => {
    return 'Metrics';
  },
  successPhenotypeCompanyPhenotypeDescriptionHtml: () => {
    return `This size of the percentage shows us how important a competency is in understanding how well an employee performs at their job. Whether the percentage is positive or negative indicates if the feature has a good or bad effect on performance.`;
  },
  successPhenotypeCompetenciesTitle: () => {
    return 'Competencies';
  },
  successPhenotypeCompetenciesSummary: () => {
    return 'Top 5 factors for your organization';
  },
  successPhenotypeAttributesTitle: () => {
    return 'Attributes';
  },
  successPhenotypeAttributesSummary: () => {
    return 'Top 3 attributes for your organization';
  },
  successPhenotypeError: () => {
    return 'There was an error loading the success phenotype';
  },
  keyFactorsPageTitle: () => 'Key Factors',
  keyFactorsPageSubHeading: () =>
    `Key Factors S2 model identifies characteristics and traits, determined through rigorous pattern analysis of your historical data, that have an impact on any given metric. This is an accurate data-driven picture of what is most statistically proven to drive your organization's outcomes.`,
  keyFactorsOptimizingCardSubHeading: () => 'Performance Review',
  keyFactorsOptimizingCardViewBreakdown: () => 'View Breakdown',
  keyFactorsOptimizingCardAdditionalFactors: () => 'See Additional Factors',
  keyFactorsOptimizingCardFooterBlurb: () =>
    'These factors are used by our Copilot to identify top candidates.',
  keyFactorsOptimizingCardFooterTryCopilot: () => 'Try Copilot',
  keyFactorsOptimizingCardImpact: ({ impact }) =>
    `${formatNumberForDisplayInUnits({ value: impact, isPercentageAlreadyMultipliedBy100: true, units: 'percentage' })} Impact`,
  keyFactorsOptimizingCardBasedOn: ({
    metricName,
    calibrationFraming,
    subjectPlural,
  }) =>
    `Based on our predictive calculations of your data, your ${subjectPlural} are more likely to have a ${calibrationFraming === 'Positive' ? 'higher' : 'lower'} ${metricName.toLocaleLowerCase()} based on the following traits`,
  keyFactorsRadialChartCenterLabel: () => 'Scale of Impact',
  keyFactorsRadialChartPercentImpact: () => '% Impact',
  keyFactorsRadialChartNumberOfPeople: ({ numberOfPeople }) =>
    `# of People: ${formatNumber(numberOfPeople)}`,
  keyFactorsRadialChartAccuracy: ({ accuracy }) => {
    switch (accuracy) {
      case 'high':
        return 'Accuracy: High';
      case 'low':
        return 'Accuracy: Low';
      case 'medium':
        return 'Accuracy: Medium';
      default:
        throw guardExhaustive(accuracy);
    }
  },
  keyFactorsBreakdownShowFullAnalysis: () => 'Show Full Analysis',
  keyFactorsBreakdownHideFullAnalysis: () => 'Hide Full Analysis',
  keyFactorsBreakdownTraitCardLikelihood: ({ metric, controlVariable }) =>
    `Likelihood % of higher ${metric.displayName} based on ${controlVariable.numericalTraitDefinition?.unitPlural} of ${controlVariable.displayName.toLowerCase()}`,
  keyFactorsOptimalRuleFallback: ({
    metricDisplayName,
    controlVariableDisplayName,
    targetRange,
  }) =>
    `When optimizing ${metricDisplayName.toLocaleLowerCase()}, prioritize ${controlVariableDisplayName.toLocaleLowerCase()} of ${targetRange} as a key factor.`,
  keyFactorsBreakdownFallback: ({
    controlVariableDisplayName,
    targetRange,
    metricCalibrationFraming,
    metricDisplayName,
  }) =>
    `Within ${controlVariableDisplayName.toLocaleLowerCase()} groups, ${targetRange} has the strongest correlation with ${metricCalibrationFraming.toLocaleLowerCase()} ${metricDisplayName.toLocaleLowerCase()}.`,
  keyFactorsOptimizingCardNoFactors: () => 'No factors found for optimization.',
  keyFactorsOptimizingCardNotEnoughData: () =>
    'Not enough data available for optimization.',
  targetRange: () => 'Target range: ',
  numberOfPeopleTooltip: () => [
    {
      isBold: true,
      text: '# of People',
    },
    {
      text: ' is the sample size utilized to generate this analysis and includes  individuals from both current and historic records',
    },
  ],
  accuracyTooltip: () => [
    {
      isBold: true,
      text: 'Accuracy',
    },
    {
      text: ' refers to the quality of the analysis based on the data provided',
    },
  ],
  metricBarSelectLabel: () => {
    return 'Metrics';
  },
  shortNone: () => {
    return englishGetShortNone();
  },
  longNone: () => {
    return englishGetLongNone();
  },
  shortVeryLow: () => {
    return englishGetShortVeryLow();
  },
  longVeryLow: () => {
    return englishGetLongVeryLow();
  },
  shortLow: () => {
    return englishGetShortLow();
  },
  longLow: () => {
    return englishGetLongLow();
  },
  shortLowToMed: () => {
    return englishGetShortLowToMed();
  },
  longLowToMed: () => {
    return englishGetLongLowToMed();
  },
  shortMed: () => {
    return englishGetShortMed();
  },
  longMed: () => {
    return englishGetLongMed();
  },
  shortMedToHigh: () => {
    return englishGetShortMedToHigh();
  },
  longMedToHigh: () => {
    return englishGetLongMedToHigh();
  },
  shortHigh: () => {
    return englishGetShortHigh();
  },
  longHigh: () => {
    return englishGetLongHigh();
  },
  shortVeryHigh: () => {
    return englishGetShortVeryHigh();
  },
  longVeryHigh: () => {
    return englishGetLongVeryHigh();
  },
  shortHighest: () => {
    return englishGetShortHighest();
  },
  longHighest: () => {
    return englishGetLongHighest();
  },

  insightDisplay: ({
    showBeforeEmpsOrApps,
    empsOrAppsDisplay,
    insightFormat,
    levelDisplay,
  }) => {
    const display = insightFormat.replaceAll('$level', levelDisplay);

    if (showBeforeEmpsOrApps) {
      return `${display} ${empsOrAppsDisplay}`;
    } else {
      return `${empsOrAppsDisplay} ${display}`;
    }
  },

  insightWithReferenceDisplay: ({
    showBeforeEmpsOrApps,
    empsOrAppsDisplay,
    insightWithReferenceFormat,
    levelDisplay,
    referenceDisplay,
  }) => {
    const display = insightWithReferenceFormat
      .replaceAll('$level', levelDisplay.toLowerCase())
      .replaceAll('$reference', referenceDisplay.toLowerCase());

    if (showBeforeEmpsOrApps) {
      return `${display} ${empsOrAppsDisplay}`;
    } else {
      return `${empsOrAppsDisplay} ${display}`;
    }
  },

  insightDisparityTitle: ({ focusAreaDisplay, insightWithReferenceDisplay }) =>
    englishGetInsightDisparityTitle({
      focusAreaDisplay,
      insightWithReferenceDisplay,
    }),

  lowerHigherDisplay: ({ type }) => {
    return type === 'higher' ? 'higher' : 'lower';
  },

  insightDisparityText: ({
    focusAreaDisplay,
    insightWithReferenceDisplay,
    percentDisplay,
    lowerHigherDisplay,
  }) =>
    englishGetInsightDisparityText({
      focusAreaDisplay,
      insightWithReferenceDisplay,
      percentDisplay,
      lowerHigherDisplay,
    }),

  insightParityTitle: ({ focusAreaDisplay, insightWithReferenceDisplay }) =>
    englishGetInsightParityTitle({
      focusAreaDisplay,
      insightWithReferenceDisplay,
    }),

  insightParityText: ({ focusAreaDisplay, insightWithReferenceDisplay }) =>
    englishGetInsightParityText({
      focusAreaDisplay,
      insightWithReferenceDisplay,
    }),

  insightHighCalibrationTitle: ({
    focusAreaDisplay,
    insightDisplay,
    calibrationFraming,
  }) =>
    englishGetInsightHighCalibrationTitle({
      focusAreaDisplay,
      insightDisplay,
      calibrationFraming,
    }),

  insightHighCalibrationText: ({
    focusAreaDisplay,
    insightDisplay,
    passedTestCount,
    totalTestCount,
    calibrationScoreDisplay,
    calibrationFraming,
  }) =>
    englishGetInsightHighCalibrationText({
      focusAreaDisplay,
      insightDisplay,
      passedTestCount,
      totalTestCount,
      calibrationScoreDisplay,
      calibrationFraming,
    }),

  insightMedCalibrationTitle: ({
    focusAreaDisplay,
    insightDisplay,
    calibrationFraming,
  }) =>
    englishGetInsightMedCalibrationTitle({
      focusAreaDisplay,
      insightDisplay,
      calibrationFraming,
    }),

  insightMedCalibrationText: ({
    focusAreaDisplay,
    insightDisplay,
    passedTestCount,
    totalTestCount,
    calibrationScoreDisplay,
    calibrationFraming,
  }) =>
    englishGetInsightMedCalibrationText({
      focusAreaDisplay,
      insightDisplay,
      passedTestCount,
      totalTestCount,
      calibrationScoreDisplay,
      calibrationFraming,
    }),

  insightLowCalibrationTitle: ({
    focusAreaDisplay,
    insightDisplay,
    calibrationFraming,
  }) =>
    englishGetInsightLowCalibrationTitle({
      focusAreaDisplay,
      insightDisplay,
      calibrationFraming,
    }),

  insightLowCalibrationText: ({
    focusAreaDisplay,
    insightDisplay,
    passedTestCount,
    totalTestCount,
    calibrationScoreDisplay,
    calibrationFraming,
  }) =>
    englishGetInsightLowCalibrationText({
      focusAreaDisplay,
      insightDisplay,
      passedTestCount,
      totalTestCount,
      calibrationScoreDisplay,
      calibrationFraming,
    }),

  insightTitleNew: ({
    insight,
    focusAreaDisplay,
    insightDisplay,
    insightWithReferenceDisplay,
    calibrationFraming,
  }) => {
    if (insight.type === 'parity') {
      return englishGetInsightParityTitle({
        focusAreaDisplay,
        insightWithReferenceDisplay,
      });
    }

    if (insight.type === 'disparity') {
      return englishGetInsightDisparityTitle({
        focusAreaDisplay,
        insightWithReferenceDisplay,
      });
    }

    if (insight.type === 'optimization') {
      const counts = insight.totalTestCount ?? {
        total: 0,
        passing: 0,
        failing: 0,
        incomplete: 0,
      };

      const score = getCalibrationScore({
        testCount: counts,
      });
      const level = getCalibrationLevel(score);

      if (level === 'poor' || level === 'belowAverage') {
        return englishGetInsightLowCalibrationTitle({
          focusAreaDisplay,
          insightDisplay,
          calibrationFraming,
        });
      } else if (level === 'average') {
        return englishGetInsightMedCalibrationTitle({
          focusAreaDisplay,
          insightDisplay,
          calibrationFraming,
        });
      } else {
        return englishGetInsightHighCalibrationTitle({
          focusAreaDisplay,
          insightDisplay,
          calibrationFraming,
        });
      }
    }

    return ``;
  },

  calibrationScoreDisplay: ({ counts, calibrationFraming }) => {
    const score = getCalibrationScore({
      testCount: counts,
    });
    const level: CalibrationLevel = getCalibrationLevel(score);

    if (level === 'poor') {
      return calibrationFraming === 'bias'
        ? englishGetShortHigh()
        : englishGetShortLow();
    }

    if (level === 'belowAverage') {
      return calibrationFraming === 'bias'
        ? englishGetShortMedToHigh()
        : englishGetShortLowToMed();
    }

    if (level === 'average') {
      return englishGetShortMed();
    }

    if (level === 'good') {
      return calibrationFraming === 'bias'
        ? englishGetShortLowToMed()
        : englishGetShortMedToHigh();
    }

    if (level === 'veryGood') {
      return calibrationFraming === 'bias'
        ? englishGetShortLow()
        : englishGetShortHigh();
    }

    if (level === 'excellent') {
      return calibrationFraming === 'bias'
        ? englishGetShortVeryLow()
        : englishGetShortVeryHigh();
    }

    if (level === 'best') {
      return calibrationFraming === 'bias'
        ? englishGetShortNone()
        : englishGetShortHighest();
    }

    throw guardExhaustive(level);
  },

  optimizationOfSkillsAndCompetencies: () =>
    `Optimization of Skills and Competencies`,

  insightTextNew: ({
    insight,
    focusAreaDisplay,
    insightDisplay,
    insightWithReferenceDisplay,
    lowerHigherDisplay,
    calibrationFraming,
  }) => {
    if (insight.type === 'parity') {
      return englishGetInsightParityText({
        focusAreaDisplay,
        insightWithReferenceDisplay,
      });
    }

    if (insight.type === 'disparity') {
      return englishGetInsightDisparityText({
        focusAreaDisplay,
        insightWithReferenceDisplay,
        percentDisplay:
          Math.abs(insight.highlight?.percentage ?? 0).toFixed(1) ?? '0',
        lowerHigherDisplay,
      });
    }

    if (insight.type === 'optimization') {
      const counts = insight.totalTestCount ?? {
        total: 0,
        passing: 0,
        failing: 0,
        incomplete: 0,
      };

      const score = getCalibrationScore({
        testCount: counts,
      });
      const level = getCalibrationLevel(score);

      if (level === 'poor' || level === 'belowAverage') {
        return englishGetInsightLowCalibrationText({
          focusAreaDisplay,
          insightDisplay,
          calibrationScoreDisplay: englishGetCalibrationScoreDisplay({
            counts,
            calibrationFraming,
          }),
          passedTestCount: counts.passing,
          totalTestCount: getTotalTestCount(counts),
          calibrationFraming,
        });
      } else if (level === 'average') {
        return englishGetInsightMedCalibrationText({
          focusAreaDisplay,
          insightDisplay,
          calibrationScoreDisplay: englishGetCalibrationScoreDisplay({
            counts,
            calibrationFraming,
          }),
          passedTestCount: counts.passing,
          totalTestCount: getTotalTestCount(counts),
          calibrationFraming,
        });
      } else {
        return englishGetInsightHighCalibrationText({
          focusAreaDisplay,
          insightDisplay,
          calibrationScoreDisplay: englishGetCalibrationScoreDisplay({
            counts,
            calibrationFraming,
          }),
          passedTestCount: counts.passing,
          totalTestCount: getTotalTestCount(counts),
          calibrationFraming,
        });
      }
    }

    return ``;
  },
  focusAreaSectionTab: ({ tabValue }) => {
    switch (tabValue) {
      case 'summary':
      case 'summary-v2':
        return 'Summary';
      case 'group-trends':
        return 'Group Trends';
      case 'solutions':
        return 'Solutions';
      case 'insights':
        return 'Insights';
      case 'insight-details':
        return 'Insight Details';
    }
  },

  exploreCalibrationLevels: ({ calibrationFraming }) =>
    `Explore ${calibrationFraming === 'bias' ? 'Bias' : 'Optimization'} Levels`,
  focusAreaViewAllInsights: () => 'View All Insights',
  keyInsights: () => 'Key Insights',
  binScatterEmptyText: ({ hasLevels }) => {
    return hasLevels
      ? 'No significant disparities were identified.'
      : 'Please select one or more dimensions to view key insights.';
  },
  viewBy: () => 'View by:',
  reset: () => 'Reset',

  dangerousUserInput: ({ value, fallback = 'Unknown' }) => {
    return value ? value : fallback;
  },

  scatterChartXTooltip: ({ metricDefinition, index }) => {
    if (metricDefinition.calibrationFraming === 'Positive') {
      return metricDefinition.isMetricBoolean
        ? `${metricDefinition.displayName} readiness: ${index}`
        : `Qualification: ${index}`;
    } else if (metricDefinition.calibrationFraming === 'Negative') {
      return `${metricDefinition.displayName} risk: ${index}`;
    } else {
      throw guardExhaustive(metricDefinition.calibrationFraming);
    }
  },

  scatterChartYTooltip: ({ metricDefinition, focusArea, dependentValue }) => {
    if (metricDefinition.isMetricBoolean) {
      return `Chance: ${dependentValue}`;
    } else {
      if (focusArea.focusArea === 'Compensation') {
        return `Current ${metricDefinition.displayName}: ${dependentValue}`;
      } else {
        return `${metricDefinition.displayName}: ${dependentValue}`;
      }
    }
  },

  scatterChartXLabel: ({ metricDefinition }) => {
    if (metricDefinition.calibrationFraming === 'Positive') {
      return metricDefinition.isMetricBoolean
        ? `${metricDefinition.displayName} readiness`
        : `${metricDefinition.displayName} qualification`;
    } else if (metricDefinition.calibrationFraming === 'Negative') {
      return `${metricDefinition.displayName} risk`;
    } else {
      throw guardExhaustive(metricDefinition.calibrationFraming);
    }
  },

  scatterChartYLabel: ({ focusAreaDefinition, metricDefinition }) => {
    if (metricDefinition.isMetricBoolean) {
      return `Chances ${metricDefinition.whiteLabeling.subjectPlural} ${metricDefinition.whiteLabeling.subjectConditionalVerb}`;
    } else {
      /** TODO: This is a rule that Emil and Kyle discussed and agreed on. For bin scatter, the idea of whether to use
       * "current" or "average" should be configurable based on a metric modifier. This is a temporary solution until
       * we have a better way to handle this.
       */
      if (focusAreaDefinition.focusArea === 'Compensation') {
        return `Current ${metricDefinition.displayName}`;
      } else {
        return `Average ${metricDefinition.displayName}`;
      }
    }
  },

  disparityBlurb1: ({ metricDefinition }) => {
    if (metricDefinition.isMetricBoolean) {
      return `${metricDefinition.displayName} rate of`;
    } else {
      return `${metricDefinition.displayName} of`;
    }
  },

  disparityBlurb2: ({ metricDefinition }) => {
    return `${metricDefinition.whiteLabeling.subjectPlural} compared to`;
  },

  payCorrectionCalibrationHeading: ({ calibrationFraming }) =>
    `${calibrationFraming === 'bias' ? 'Bias' : 'Optimization'} Levels in Pay`,

  unableToLoadObservation: () =>
    `There was an error loading your database. Please try again shortly, and if the problem persists contact support for assistance.`,
  biasNone: () => `No Bias`,
  biasVeryLow: () => `Very Low Bias`,
  biasLow: () => `Low Bias`,
  biasLowToMed: () => `Low to Medium Bias`,
  biasMed: () => `Medium Bias`,
  biasMedToHigh: () => `Medium to High Bias`,
  biasHigh: () => `High Bias`,

  optimizationLow: () => `Low Optimization`,
  optimizationLowToMed: () => `Low to Medium Optimization`,
  optimizationMed: () => `Medium Optimization`,
  optimizationMedToHigh: () => `Medium to High Optimization`,
  optimizationHigh: () => `High Optimization`,
  optimizationVeryHigh: () => `Very High Optimization`,
  optimizationHighest: () => `Highest Optimization`,

  biasOptimizationInSentenceNo: () => `No`,
  payCorrectionGraphExplanation: ({ calibrationFraming }) =>
    calibrationFraming === 'bias'
      ? 'The ideal state is to have a blank graph, with no bias charted.'
      : 'The ideal state is to have a full graph, with max optimization charted.',

  employeeLifecycleAIExplanationHeading: ({ dimension }) =>
    `Employee Lifecycle by ${dimension}`,

  binScatterMultiSelectAIExplanationHeading: ({ yAxis, dimension, xAxis }) =>
    `${yAxis} by ${dimension} and ${xAxis}`,

  chartInterpretationTitle: () => `Chart interpretation`,
  selectAnOrganizationPlaceholder: () =>
    'Please select an organization to view insights.',
  successPhenotypeHiringCopilotShoutout: () =>
    'The traits identified here are used by our hiring co-pilot to identify top candidates. ',
  successPhenotypeHiringCopilotLink: () => 'Try it out now!',
  dataIntelligenceTopOpportunities: ({ config }) =>
    config === 'largest-differences'
      ? 'Largest Differences'
      : 'Top Opportunities',
  dataIntelligenceTopOpportunitiesEmptyTitle: ({ processesDescription }) =>
    `Your ${processesDescription ?? 'processes'} are exemplary`,
  dataIntelligenceTopOpportunitiesEmptyBody: ({
    processesDescription,
    calibrationFraming,
  }) =>
    `We did not detect any ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'biases'} in your ${processesDescription ?? 'processes'}, indicating that your processes are optimized.`,
  dataIntelligenceDeepDive: () => 'Deep Dive',
  metric: () => englishGetMetric(),

  whyNoBiasOrInefficiencyDetection: ({
    calibrationFraming,
  }: {
    calibrationFraming: CalibrationFraming;
  }) => {
    if (calibrationFraming === 'optimization') {
      return 'Why no inefficiency detected?';
    } else if (calibrationFraming === 'bias') {
      return 'Why no bias detected?';
    } else {
      throw guardExhaustive(calibrationFraming);
    }
  },

  whyNoBiasOrInefficiencyDetectionTooltip: ({
    calibrationFraming,
  }: {
    calibrationFraming: CalibrationFraming;
  }) => {
    if (calibrationFraming === 'optimization') {
      return 'Inefficiency analysis focuses on decision-maker actions. This metric reflects individual choices rather than organizational decisions, so inefficiency testing is not applicable.';
    } else if (calibrationFraming === 'bias') {
      return 'Bias analysis focuses on decision-maker actions. This metric reflects individual choices rather than organizational decisions, so bias testing is not applicable.';
    } else {
      throw guardExhaustive(calibrationFraming);
    }
  },

  secondaryFilterButtonText: () => `Filter`,
  secondaryFilterButtonEditText: () => `Edit Filter`,
  clearAllButtonText: () => `Clear All`,
  selectAllButtonText: () => `Select All`,

  filterSearchBoxPlaceholder: () => `Search...`,

  exportButtonLabel: ({ amount }) =>
    amount > 0 ? `Export (${amount})` : `Export`,

  searchableFilterListBoxEmpty: () => `No results found`,
  filterApplyButton: ({ count }) => (count > 0 ? `Apply (${count})` : `Apply`),
  filterCancelButton: () => `Cancel`,
  recommendedSolutionsSectionHeader: () => 'Recommended Solutions',
  recommendedSolutionsSectionEmptyDescription: () =>
    'We don’t have any solutions to recommend.',
  recommendedSolutionHeader: () => 'Recommended',
  recommendedSolutionImpact: () => 'Estimated Impact:',

  deepDiveSubTabProcessBiasTitle: ({ calibrationFraming }) =>
    calibrationFraming === 'optimization'
      ? 'Process Inefficiencies'
      : 'Process Bias',
  deepDiveSubTabExplanatoryFactorsTitle: () => 'Explanatory Factors',
  deepDiveSubTabProcessBiasUnexplained: () => 'Unexplained',

  userAnalysisOverlaySeeResults: () => 'See Results',
  userAnalysisOverlayUnableToLoadDescription: () =>
    'This error has been sent to our team',
  userAnalysisOverlayNotEnoughDataDescription: () => 'Not enough data',
  userAnalysisOverlayCancel: () => 'Cancel',

  enableDeepDiveDataIntelligenceCheckboxLabel: () =>
    `Enable Data Intelligence Deep Dive`,

  focusAreaTableToolsHeader: () => `Tools`,
  filterSetsHeading: () => `Filter Sets`,
  noSelection: () => englishGetNoSelection(),
  dataIntelligenceDeepDiveDisabled: () =>
    `Data Intelligence Deep Dive is disabled. You may change that in the misc tab, then come back to change filter sets.`,
  precision: () => `Precision (decimals)`,
  overviewCardSuccessPhenotypeBody: () =>
    `We’ve aggregated data to uncover the attributes of a top performer.`,
  overviewCardHeatmapBody: () =>
    `Analyze your organizations data from a bird’s eye view, before diving deep into the nuance.`,
  overviewCardDashboardsBody: () =>
    `Create personalized views for your team with custom metrics, charts, and insights aligned to your goals.`,
  overviewCardSavedAnalysesBody: () =>
    `Bookmark any chart or graph to easily refer back to it in the future.`,
  overviewCardProgressBody: () =>
    `Watch how your metrics evolve across days, weeks, months, and beyond.`,
  overviewCardHiringCopilotBody: () =>
    `Evaluate applicants’ readiness based on top talent performance.`,
  overviewCardPayBenchmarkingCopilotBody: () =>
    `The power of market benchmarks to determine fair compensation offers.`,
  overviewCardPayCorrectionCopilotBody: () =>
    `Precise adjustment recommendations based on performance and experience.`,
  overviewCardPromotionCopilotBody: () =>
    `Fairly promote the best employees based on performance.`,
  overviewCardTableViewBody: () =>
    `Organize raw data into tables that highlight key metrics and insights at a glance.`,
  overviewCardTableViewTitle: () => `Summary Table`,
  disparityLabel: () => `DISPARITY`,
  biasDetectedLabel: () => `BIAS DETECTED`,

  textWithNewlines: ({ text }) => text,
  topSkillsForCompany: () => `Top Skills for Company`,
  underOptimizedMetrics: () => `Under Optimized Metrics`,
  goToPerformance: () => `Go to Performance`,
  noDataAvailable: () => `No data available`,
  seeMoreRoles: () => `See more roles`,
  forYou: () => `For You`,
  continueExploring: () => `Continue Exploring`,
  orgSwitcherOrgSelectionLabel: ({ orgName }) =>
    orgName ?? 'Select organization',
  databaseRevisions: () => `Database Revisions`,
  databaseNameOrNA: ({ databaseName }) => databaseName ?? 'N/A',
  edit: () => `Edit`,
  currentConfiguration: () => `Current Configuration`,
  nextScheduledTime: () => `Next Scheduled Time`,
  interval: () => `Interval`,
  status: () => `Status`,
  runs: () => `Runs`,
  save: () => `Save`,
  saved: () => `Saved`,
  savedCount: ({ savedList }) => {
    const listLength = savedList?.length ?? 0;
    const listLengthStr = listLength > 0 ? `(${listLength})` : '';
    return `Saved ${listLengthStr}`;
  },
  savedAnalyses: () => `Saved Analyses`,
  unsave: () => `Unsave`,
  allSaved: () => `All Saved`,
  noSavedAnalysesYet: () => `No saved analyses yet?`,
  youCanSaveAnalyses: () =>
    `You can save deep-dive analyses to review them anytime, by clicking the bookmark icon at the end of the filter bar.`,
  saveAnalysesForKey: () => `Pro-tip: Save analyses for key decisions.`,
  bookmarkAnalysesYouRely: () =>
    `Bookmark the deep-dive analyses you rely on most for important strategy and planning.`,
  customHeaders: () => `Custom Headers`,
  customHeadersSecret: () => `Custom Headers (Secret)`,
  urlList: () => `URL List`,
  tableList: () => `Table List`,
  preload: () => `Preload`,
  preview: () => `Preview`,
  translationPhrasing: () => `Translation Phrasing`,
  uploadSnapshotDateOverride: () => `Upload Snapshot Date Override`,
  invalidUploadSnapshotDateFormat: () =>
    `Invalid Upload Snapshot Date (format is YYYY-MM-DD)`,
  employeeGroup: ({ subjectName }) => englishGetEmployeeGroup({ subjectName }),
  comparisonGroup: () => englishGetComparisonGroup(),
  selectEventStudyGroup: () => 'Select Group',
  selectSingleDate: () => 'Select Date',
  eventStudyTooltip: () => [
    {
      isBold: true,
      text: 'What’s an Event Study?\n\n',
    },
    {
      text: 'An event study helps you see how things changed after something important happened. Think of it like taking a "before and after" photo. You look at your data before the event (like launching a new program or changing a policy), then compare it to what happened after. This helps you understand if the event actually made a difference.\n\n',
    },
    {
      text: 'For example, if your company started a new training program in June, an event study would show you whether employee performance improved after June compared to before.',
    },
  ],
  eventStudyMenuHeading: () => 'Event Study',
  eventStudyMenuDescription: () =>
    'Analyze the effect of a single event on your business.',
  eventStudyMenuDateLabel: () => 'Event Date:',
  eventStudyMenuDateDescription: () =>
    'Select the date for which you’d like to examine your organizational trends.',
  eventStudyMenuGroupLabel: () => 'Study Group (optional):',
  eventStudyMenuGroupDescription: () =>
    'Optionally, select a group, within your organization, to analyze, using the selected date.',
  eventStudyMetricChangeBeforeJumpLabel: () => 'Before jump:',
  eventStudyMetricChangeAfterJumpLabel: () => 'After jump:',
  eventStudyMetricChangeJumpLabel: () => 'Jump:',
  eventStudyMetricChangeHeading: ({ metricDefinition }) =>
    `${metricDefinition.displayName} change:`,
  eventStudyMetricConfidence: ({ percentage }) =>
    `Confidence: ${formatNumberForDisplayInUnits({ value: percentage, isPercentageAlreadyMultipliedBy100: true, units: 'percentage' })}`,
  eventStudyMetricChangeTooltip: () => [
    {
      isBold: true,
      text: 'Before, Jump, & After\n\n',
    },
    {
      text: 'These three numbers show you the story of what happened around your event. Before is the average from the months leading up to the event. Jump is the immediate change right when the event happened. After is the average from the months following the event. Together, they help you see if there was a sudden spike, a gradual shift, or a lasting change in your data.\n\n',
    },
    {
      text: `For example, If you're tracking employee satisfaction and launched a new benefits program in March, you might see satisfaction was 70% before, jumped to 85% in March, then stayed at 80% after.`,
    },
  ],
  eventStudyMetricChangeConfidenceTooltip: ({
    percentage,
    sampleSize,
    duration,
    metricDefinition,
  }) => [
    {
      isBold: true,
      text: `${formatNumberForDisplayInUnits({ value: percentage, isPercentageAlreadyMultipliedBy100: true, units: 'percentage' })} Confidence\n\n`,
    },
    {
      text: `This level of confidence is based on ${sampleSize} ${metricDefinition.whiteLabeling.subjectPlural} over ${englishFormatDateDuration({ duration })}.
The confidence percentage shows how sure we are about each number. Higher confidence (closer to 100%) means we have enough data to trust the result. Lower confidence means there might not be enough information yet, so the number could change.\n\n`,
    },
    {
      text: `Think of it like being more certain about your grade after taking 10 quizzes versus just 2 quizzes.`,
    },
  ],
  progressChartXAxisLabel: () => 'Time',
  dateDuration: ({ duration }) => englishFormatDateDuration({ duration }),
  dateRange: ({ start, end }) => englishFormatDateRange({ start, end }),
  dateRangeDefaultLabel: () => 'Date Range',
  dimension: () => englishGetDimension(),
  pleaseSelect: ({ fieldDisplayNames }) => {
    const lower = fieldDisplayNames.map((i) => i.toLowerCase());
    const article = lower.length > 0 && lower[0].startsWith('a') ? 'an' : 'a';
    const oxfordCommaTogether = (i: string[]): string => {
      if (i.length === 1) {
        return i[0];
      } else if (i.length === 2) {
        return i.join(' and ');
      } else {
        return i.slice(0, i.length - 1).join(', ') + ', and ' + i[i.length - 1];
      }
    };

    return `Please select ${article} ${oxfordCommaTogether(lower)}`;
  },
  startRangeLabel: ({ fieldDisplayName }) => `Start ${fieldDisplayName}`,
  endRangeLabel: ({ fieldDisplayName }) => `End ${fieldDisplayName}`,
  levelDisplayName: ({ definition }) => definition.displayName,
  dimensionDisplayName: ({ definition }) => definition.displayName,
  metricDisplayName: ({ definition }) => definition.displayName,
  metricEventDisplayName: ({ definition }) =>
    definition.whiteLabeling.eventDisplayName ?? definition.displayName,
  filterDefinitionDisplayName: ({ definition }) => definition.displayName,
  numberRangeDisplay: ({ start, end }) =>
    englishGetNumberRangeDisplay({ start, end }),
  dateDisplay: ({ date }) => englishGetDateDisplay({ date }),
  heatmap: () => 'Heatmap',
  exploreHeatmapNotEnoughDataTitle: () =>
    'There isn’t enough data to generate a Heatmap',
  exploreHeatmapNotEnoughDataBody: () =>
    'Please adjust the filters to generate a Heatmap',
  exploreGoogleMapNotEnoughDataTitle: () =>
    'There isn’t enough data to generate a map',
  exploreGoogleMapNotEnoughDataBody: () =>
    'Please adjust the filters to generate a map',
  analysisGenericFailureTitle: () => 'We ran into an error',
  analysisGenericFailureBody: () =>
    'Please change your filters and try again. We have been notified.',
  exploreHeatmapAnalysisToastTitle: ({ metricDisplayName, levelDisplayName }) =>
    `${metricDisplayName} in ${levelDisplayName}`,
  exploreHeatmapAnalysisToastDisparity: () => 'controlled disparity',
  exploreHeatmapAnalysisToastPeople: () => 'people',
  exploreHeatmapAnalysisToastConfidence: () => 'Confidence:',
  exploreHeatmapAnalysisToastLearnMore: () => 'Learn More',
  exploreHeatmapAnalysisToastInfo: () =>
    'This scale reflects the size of the difference between two groups and how sure we are that the difference is real. To ensure fairness, we consider relevant factors about the individuals in the groups. Lighter colors mean smaller or less certain differences, while darker colors mean bigger or more certain differences.',
  exploreHeatmapAnalysisToastNoData: () => 'Not enough data',
  exploreHeatmapHighImpactArea: () => 'High Impact Area',
  exploreHeatmapLowImpactArea: () => 'Low Impact Area',
  exploreHeatmapDownloadButtonLabel: () => 'Download',
  exploreHeatmapAnalysisExplanationHeading: ({
    treatmentGroupLevelDefinition,
    referenceGroupLevelDefinition,
  }) =>
    `Comparing ${treatmentGroupLevelDefinition.displayName} to ${referenceGroupLevelDefinition.displayName}`,
  exploreHeatmapExplanationOverviewFallback: ({
    treatmentGroupDisplayName,
    referenceGroupDisplayName,
  }) =>
    `${treatmentGroupDisplayName} shows different outcomes compared to ${referenceGroupDisplayName} across multiple metrics.`,
  showExplanationDetails: () => 'Show Analysis',
  hideExplanationDetails: () => 'Hide Analysis',
  dataIntelligenceEmptyExplanatoryFactorsTitle: () =>
    'No Single Factor Significantly Explains Disparity',
  dataIntelligenceNoBiasDetectedTitle: ({ calibrationFraming }) =>
    `No ${calibrationFraming === 'optimization' ? 'Inefficiencies' : 'Bias'} Detected`,
  dataIntelligenceNoBiasDetectedBody: ({
    comparisonGroupDisplayName,
    calibrationFraming,
    metricDefinition,
  }) =>
    `We did not detect any ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'bias'} affecting the ${metricDefinition.whiteLabeling.proceseesDescription} of the ${comparisonGroupDisplayName} ${metricDefinition.whiteLabeling.subjectSingular} group.`,
  dataIntelligenceEmptyUnexplainedTitle: () => 'Unexplained',
  dataIntelligenceEmptyUnexplainedBody: () =>
    'A portion of this disparity cannot be explained through our analyses. Improving the quality of your data can help us detect biases and other factors contributing to this disparity.',
  dataIntelligenceEmptyExplanatoryFactorsBody: ({
    metricDefinition,
    treatmentLevelDefinition,
    referenceLevelDefinition,
  }) =>
    `There is no single explanatory factor that explains a significant portion of the ${metricDefinition.displayName.toLowerCase()} disparity between ${treatmentLevelDefinition.displayName.toLowerCase()} and ${referenceLevelDefinition.displayName.toLowerCase()} ${metricDefinition.whiteLabeling.subjectPlural}.`,
  dataIntelligenceEmptyDataTitle: () =>
    'There isn’t enough data to generate insights',
  dataIntelligenceEmptyDataBody: () =>
    'Adjust the filters to explore disparities and biases in your talent processes.',
  dataIntelligenceClearFiltersButton: () => 'Clear Filters',
  controlVariableName: ({ name }) => name,
  similarFactors: () => 'Similar Factors',
  payGapTooltipContents: ({ contents }) => contents,
  plusSomeMore: ({ count }) => `+${count} more`,
  dataSetQuestionRubricMappingTitle: () => `Data Set Question Rubric Mapping`,
  dataSetResumeGradingRubricTitle: () => `Resume Grading Rubric`,
  dataSetQuestionRubricMappingError: () =>
    `Error loading the data set question rubric mapping, please refresh to try again.`,
  dataSetQuestionRubricMappingDescription: () => {
    return `Questions vary between jobs and as such, the question rubric mapping is used by the ai interview grader to determine the correct rubric to use for a given question. The mapping is structured as a question to a rubric with a fuzzy matching on the question. For example, the exact question can be is "What is your greatest strength?" or a fuzzy match question could just be "greatest strength". Rubric is a set of criteria used to evaluate a candidate's performance on a given question. The rubric is structured as a set of criteria with a weight and a description. The weight is used to determine the importance of the criteria in the evaluation. For example, a rubric could measure "Clarity" with a weight of 0.5 and a description of "How clear and concise the candidate's response is".`;
  },
  dataSetResumeGradingRubricDescription: () => {
    return `The resume grading rubric is used to determine the score of a resume. The rubric is structured as a set of criteria with a weight and a description. The weight is used to determine the importance of the criteria in the evaluation. For example, a rubric could measure "Clarity" with a weight of 0.5 and a description of "How clear and concise the candidate's response is".`;
  },
  dataSetRubricOneQuestionRequired: () => `At least one question is required`,
  dataSetPostProcessingScriptTitle: () => `Data Set Post-Processing Script`,
  dataSetPostProcessingScriptError: () =>
    `Error loading the data set post-processing script, please refresh to try again.`,
  dataSetPostProcessingScriptDescription: () => {
    return [
      {
        text: `Each time this data set is uploaded or pulled, the script below will be ran. It is passed in two parameters:\n\n`,
      },
      {
        text: '1. ',
      },
      {
        text: '`datasources`',
        isBold: true,
      },
      {
        text: ` - This will be a map of all the files that were pulled or uploaded in the data set prior to the script's execution. For example, if the data set is pulling data from merge, the map might look something like this:\n\n`,
      },
      {
        text: `{\n  "Applications_0.json": "/tmp/xxxxxxxx/Applications_0.json",\n  "Applications_1.json": "/tmp/xxxxxxxx/Applications_1.json"\n}\n\n`,
      },
      {
        text: `The key will be the file name, and the value will be the path to the file which can be read from the file system during the execution of the script.\n\n`,
      },
      {
        text: `2. `,
      },
      {
        text: '`output_dir`',
        isBold: true,
      },
      {
        text: ` - This is a directory path which you may write any number of files to, and each of the files written will be appended to the outputs of the data set version.\n\n`,
      },
    ];
  },
  runPostProcessingForVersionButton: () => `Run Post-Processing`,
  runPostProcessingAndWorkflowsForVersionButton: () =>
    `Run Post-Processing and Workflows`,
  runPostProcessingForVersionConfirmation: () =>
    `Are you sure you want to run the post-processing script for this version?`,
  progress: () => englishGetProgress(),
  timeSeriesTrends: () => englishGetTimeSeriesTrends(),
  disparity: () => englishGetDisparity(),
  averageRate: () => englishGetAverageRates(),
  notEnoughDataProgress: () => 'There isn’t enough data to show trends',
  adjustFiltersProgress: () =>
    'Please adjust the filters to see how your disparities have changed over time.',
  notEnoughDataEventStudy: () => 'We couldn’t find data in this time period',
  adjustFiltersEventStudy: () =>
    'Try adjusting your timeframe or filters to see results.',
  aiInterviewerStartDate: () => `AI Interviewer Start Date`,
  invalidAIInterviewerStartDateFormat: () =>
    `Invalid AI Interviewer Start Date (format is YYYY-MM-DD)`,
  rateGroupsMeaning: ({ noun, metric }) =>
    `The ${noun} ${metric.toLowerCase()} for each segment.`,
  rawDisparityMeaning: ({ metricDisplayName, subjectPlural }) =>
    `The difference between the ${metricDisplayName.toLowerCase()} of two ${subjectPlural}, without accounting for explanatory factors.`,
  controlledDisparityMeaning: ({ metricDisplayName, subjectPlural }) =>
    `The difference between the ${metricDisplayName.toLowerCase()} of two ${subjectPlural}, while accounting for explanatory factors.`,
  chartTooltipTitleSingleGroup: ({ level, whiteLabelingSubjectPlural }) =>
    `${level} ${upperFirstString(whiteLabelingSubjectPlural)}`,
  chartTooltipTitleComparisonGroup: ({
    level,
    comparisonGroupValue,
    whiteLabelingSubjectPlural,
  }) =>
    `${level} vs. ${comparisonGroupValue} ${upperFirstString(whiteLabelingSubjectPlural)}`,
  chartTooltipFittedTrendLine: ({ metricDisplayName }) =>
    `Average ${metricDisplayName}`,
  chartTypeControlBarLabel: () => 'Bar Chart',
  chartTypeControlLineLabel: () => 'Line Chart',
  learnMore: () => 'Learn More',
  organizationsPageTableTitle: () => 'Organization List',
  usersPageTableTitle: () => 'User List',
  yes: () => 'Yes',
  no: () => 'No',
  search: () => 'Search',
  nextPage: () => 'Next Page',
  auditsPageTitle: () => 'Audits',
  auditsPageSubHeading: () => 'You can view and search through audits here.',
  auditsPageAuditTableLabel: () => 'Audit Table',
  auditsPagePageSizeLabel: () => 'Page Size',
  auditsPageAuditTimestampHeading: () => 'Audit Timestamp',
  auditsPageAuditOperationHeading: () => 'Operation',
  auditsPageAuditSessionUserHeading: () => 'Session User',
  auditsPageAuditActorRoleHeading: () => 'Actor Role',
  auditsPageAuditActorUserIdHeading: () => 'Actor User Id',
  auditsPageCreatedAtHeading: () => 'Created At',
  auditsPageUpdatedAtHeading: () => 'Updated At',
  auditsPageSourceIdHeading: () => 'Source Id',
  auditsPageOrganizationIdHeading: () => 'Organization Id',
  auditsPageUserIdHeading: () => 'User Id',
  auditsPageNameHeading: () => 'Name',
  auditsPageDescriptionHeading: () => 'Description',
  auditsPageCognitoUsernameHeading: () => 'Cognito Username',
  auditsPageEmailHeading: () => 'Email',
  auditsPageStateHeading: () => 'State',
  auditsPageIsSuperAdminHeading: () => 'Is Super Admin',
  auditsPagePasswordResetTokenHeading: () => 'Password Reset Token',
  auditsPagePasswordResetTokenExpiresAtHeading: () =>
    'Password Reset Token Expiration',
  auditsPageEnrollmentTypeHeading: () => 'Enrollment Type',
  auditsPageLogoMimeTypeHeading: () => 'Logo Mime Type',
  auditsPageLogoUrlHeading: () => 'Logo Url',
  auditsPageRoleHeading: () => 'Role',
  auditsPageOrganizationUserIdHeading: () => 'Organization User Id',
  auditsPageOrganizationGroupIdHeading: () => 'Organization Group Id',
  auditsPageDatabaseIdHeading: () => 'Database Id',
  auditsPageEntitlementIdHeading: () => 'Entitlement Id',
  auditsPageFeatureKeyHeading: () => 'Feature Key',
  auditsPageFocusAreaHeading: () => 'Focus Area',
  auditsPageDataRuleHeading: () => 'Data Rule',
  auditsPageOwnerUserIdHeading: () => 'Owner User Id',
  auditsPagePositionOnDashboardHeading: () => 'Position On Dashboard',
  auditsPagePositionOnRowHeading: () => 'Position On Row',
  auditsPageDashboardIdHeading: () => 'Dashboard Id',
  auditsPageInvitedByUserIdHeading: () => 'Invited By User Id',
  auditsPageLastInvitationSentAtHeading: () => 'Last Invitation Sent At',
  auditsPageRevokedAtHeading: () => 'Revoked At',
  auditsPageRevokedByUserIdHeading: () => 'Revoked By User Id',
  auditsPageCustomVizHeading: () => 'Custom Viz Request',
  auditsPageEnabledHeading: () => 'Enabled',
  auditsPageWhitelistedHostsHeading: () => 'Whitelisted Hosts',
  dataGeneratorPageTitle: () => 'Data Generator',
  dataGeneratorPageSubHeading: () => 'Generate data',
  dataGeneratorDataTypeLabel: ({ dataType }) => {
    switch (dataType) {
      case 'numerical':
        return 'Numerical';
      case 'categorical':
        return 'Categorical';
      default:
        throw guardExhaustive(dataType);
    }
  },
  dataGeneratorDataClassLabel: ({ dataClass }) => {
    switch (dataClass) {
      case 'controlVariable':
        return 'Control Variable';
      case 'dimension':
        return 'Dimension';
      case 'metric':
        return 'Metric';
      case 'none':
        return 'None';
      default:
        throw guardExhaustive(dataClass);
    }
  },
  dataGeneratorCreateCopyButtonLabel: () => 'Create Copy',
  dataGeneratorCreateRelationshipSetLabel: () => 'Create Relationship Set',
  dataGeneratorAreYouSureDeleteRelationshipSet: () =>
    'This will delete the relationship set and all of its relationships. Are you sure you want to continue?',
  dataGeneratorDeleteRelationshipSetLabel: () => 'Delete Relationship Set',
  dataGeneratorRelationshipSetTitle: ({
    num,
    count,
  }: {
    num: number;
    count: number;
  }) => [
    { text: `Relationship Set ` },
    { text: `(#${num} of ${count})`, isBold: true },
  ],

  dataGeneratorCreateBiasSetLabel: () => 'Create Bias Set',
  dataGeneratorAreYouSureDeleteBiasSet: () =>
    'This will delete the bias set. Are you sure you want to continue?',
  dataGeneratorDeleteBiasSetLabel: () => 'Delete Bias Set',
  dataGeneratorBiasSetTitle: ({
    num,
    count,
  }: {
    num: number;
    count: number;
  }) => [
    { text: `Bias Set ` },
    { text: `(#${num} of ${count})`, isBold: true },
  ],

  dataGeneratorCreateNewRunButtonLabel: () => 'Create New Run',
  male: () => 'Male',
  female: () => 'Female',
  onlineSchool: () => 'Online School',
  publicSchool: () => 'Public School',
  moreLikely: ({ odd }) => `${odd}x more likely`,
  lessLikely: ({ odd }) => `${odd}x less likely`,
  learnMoreAboutThisBias: () => 'Learn more about this bias',

  customVizProgressStep: ({ step }) => {
    switch (step) {
      case 'generalAnalysisStarting':
        return '🔄 Analysis Starting...';
      case 'biasAnalysisApplyingFilters':
      case 'heatmapApplyingFilters':
      case 'progressApplyingFilters':
      case 'binScatterApplyingFilters':
      case 'successPhenotypeApplyingFilters':
      case 'timeSeriesTrendsApplyingFilters':
        return '📊 Loading data from filters...';
      case 'biasAnalysisPreparingIterations':
        return '⚙ Preparing and Sequencing tests...';
      case 'heatmapPreparingIterations':
      case 'progressPreparingIterations':
        return '⚙ Preparing and Sequencing analysis...';
      case 'biasAnalysisCalculatingDisparitiesAndBiases':
        return '🔍 Calculating differences and running tests...';
      case 'heatmapCalculatingIterations':
        return '🔍 Calculating differences...';
      case 'progressCalculatingIterations':
      case 'pipelineAnalysisRunningAnalysis':
        return '🔍 Calculating results...';
      case 'binScatterCalculating':
        return '🔍 Calculating trends...';
      case 'successPhenotypeModelTraining':
        return '📈 Evaluating historical data...';
      case 'successPhenotypeCalculating':
        return '🔍 Calculating factors...';
      case 'timeSeriesTrendsCalculating':
        return '🔍 Calculating trends...';
      case 'biasAnalysisPreparingOutputs':
      case 'heatmapPreparingOutputs':
      case 'progressPreparingOutputs':
      case 'successPhenotypePreparingOutputs':
        return '✨ Generating visualization...';
      case 'generalRunningAnalysisFallback':
        return 'Running...';
      default:
        throw guardExhaustive(step);
    }
  },

  biasTaskIdDisplayName: ({ biasTaskId }) => {
    switch (biasTaskId) {
      case 'calculate_skill_index':
        return 'Calculate Skill Index';
      case 'calculate_disparities':
        return 'Calculate Disparities';
      case 'calculate_department_disparities':
        return 'Calculate Department Disparities';
      case 'department_disparity_pref_bias_test':
        return 'Department Disparity Pref Bias Test';
      case 'altonji_pierret_info_bias_test':
        return 'Altonji Pierret Info Bias Test';
      case 'tech_info_bias_test':
        return 'Tech Info Bias Test';
      case 'fryer_jackson_info_bias_test':
        return 'Fryer Jackson Info Bias Test';
      case 'fryer_trajectory_pref_bias_test':
        return 'Fryer Trajectory Pref Bias Test';
      case 'same_manager_trajectory_info_bias_test_growth':
        return 'Same Manager Trajectory Info Bias Test Growth';
      case 'same_manager_trajectory_info_bias_test_entry':
        return 'Same Manager Trajectory Info Bias Test Entry';
      case 'referral_info_bias_test':
        return 'Referral Info Bias Test';
      case 'referral_struct_bias_test':
        return 'Referral Struct Bias Test';
      case 'becker_pref_bias_test':
        return 'Becker Pref Bias Test';
      case 'anwar_fang_pref_bias_test':
        return 'Anwar Fang Pref Bias Test';
      case 'cornell_welch_info_bias_test':
        return 'Cornell Welch Info Bias Test';
      case 'hiring_manager_info_bias_test':
        return 'Hiring Manager Info Bias Test';
      case 'focus_area_predictor':
        return 'Focus Area Predictor';
      case 'threshold_analysis':
        return 'Threshold Analysis';
      case 'expected_performance_calculation':
        return 'Expected Performance Calculation';
      default:
        throw guardExhaustive(biasTaskId);
    }
  },

  togglePathway: () => `Toggle a pathway:`,
  pipelineAnalysisConfigurations: () => 'Pipeline analysis page configurations',

  filterMultiSelectDisplayPreview: ({ items }) => {
    if (items.length === 0) {
      return [{ text: '' }];
    }

    // If the first item is really long, we want to show a preview of the items instead so that we get a count, rather than the item being truncated instead
    const firstItemIsReallyLong = items[0].length > 45;

    // Use preview mode if there are more than two items, or if there are exactly 2 items and the first item is really long
    const usePreviewMode =
      items.length > 2 || (items.length === 2 && firstItemIsReallyLong);

    // We show a preview of 1 item if the first item is really long, otherwise we show a preview of 2 items
    const previewPeekLength = firstItemIsReallyLong ? 1 : 2;
    const previewItems = items.slice(0, previewPeekLength);

    return [
      {
        text: previewItems.join(', '),
        truncationGroupRunCount: usePreviewMode ? 2 : 1,
      },
      ...(usePreviewMode
        ? [{ text: `, and ${items.length - previewPeekLength} more` }]
        : []),
    ];
  },

  filterMultiSelectDisplayLongformPreviewCompressed: ({ items }) => {
    const fullText = items.join(', ');
    return [
      {
        text: `${items.length} selected`,
        tooltip: fullText,
        isDottedUnderline: true,
      },
    ];
  },

  filterMultiSelectDisplayLongformPreview: ({ items }) => {
    return englishGetFilterMultiSelectDisplayLongformPreview({ items });
  },
  translateFilterStoreValueLongform: ({ value, optionalDisplayValues }) =>
    englishTranslateFilterStoreValueLongform({ value, optionalDisplayValues }),
  recommendedSolutionImpactFactorPillText: ({ impactFactor }) =>
    impactFactor === 'Medium' ? 'Moderate' : impactFactor,

  userAnalysisOverlayTimeRemaining: ({ estimatedTimeRemainingInSeconds }) => {
    if (estimatedTimeRemainingInSeconds === null) {
      return 'Calculating...';
    }
    if (estimatedTimeRemainingInSeconds < 15) {
      return 'Almost there...';
    } else {
      const minutesLeft = Math.ceil(estimatedTimeRemainingInSeconds / 60);
      return `${minutesLeft} ${minutesLeft === 1 ? 'minute' : 'minutes'} left...`;
    }
  },

  pendingReportToastDownload: () => 'Download Report',
  pendingReportToastFailed: () => 'Failed to export report',
  pendingReportToastCancel: () => 'Cancel',
  pendingReportToastLoading: () => 'Exporting...',
  pendingReportToastTitle: () => 'Export Report',

  userAnalysisOverlayTitle: ({ analysis, metricDefinitions }) => {
    let result: string | undefined = '';

    if (analysis.status === 'pending') {
      result = mapAnalysisToPendingText({
        analysis,
        metricDefinitions,
      });
    } else if (
      analysis.status === 'succeeded' ||
      analysis.status === 'not-enough-data'
    ) {
      result = mapAnalysisToSuccessText({
        analysis,
        metricDefinitions,
      });
    } else if (analysis.status === 'failed') {
      result = mapAnalysisToFailureText({
        analysis,
        metricDefinitions,
      });
    } else {
      throw guardExhaustive(analysis.status);
    }

    // This should never happen, but just in case it'll show something
    return result ?? 'Analysis Result';
  },
  editFocusAreaTools: ({ focusArea }) => `Edit Tools: ${focusArea}`,
  focusAreaToolsPreviewValidationError: ({ error }) => {
    if (error === 'invalidDataIntelligenceDeepDiveFilterSetName') {
      return 'Data intelligence deep dive requires a valid filter set name.';
    }

    throw guardExhaustive(error);
  },

  xAxisForBiasVisualization: ({
    metricDefinition,
    treatmentLevel,
    biasTestId,
    framing,
    skillFraming,
  }) => {
    if (biasTestId === null) {
      return '';
    }

    switch (biasTestId) {
      case 0:
        return 'Tenure';
      case 1:
        return '';
      case 2:
        return '';
      case 3:
        return '';
      case 4:
        return '';
      case 5:
        return `${treatmentLevel.displayName} representation`;
      case 6:
        return '';
      case 7:
        return `Proportion of ${metricDefinition.whiteLabeling.subjectPlural} sourced from referrals`;
      case 8:
        return '';
      case 9:
        // when metric framing is Positive, skill framing is positive: skill index
        // when metric framing is Positive, skill framing is negative: skill index
        // when metric framing is Negative, skill framing is positive: risk index
        // when metric framing is Negative, skill framing is negative: skill index
        return framing === 'Negative' && skillFraming === 'Positive'
          ? 'Risk Index'
          : 'Skill Index';
      case 10:
        return '';
      case 11:
        return '';
      case 12:
        return '';
      case 13:
        // Since metric calibration framing is only negative for LE use cases and HR metrics like attrition, we can use metric calibration framing to determine the axis label
        return `${metricDefinition.calibrationFraming === 'Positive' ? 'Skill Level' : 'Standard of Evidence'} (in points)`;
      default:
        return '';
    }
  },

  yAxisForBiasVisualization: ({
    metricDefinition,
    performanceMetricDefinition,
    treatmentLevel,
    biasTestId,
    taskMetricModifier,
    taskMetricDisplayName,
  }) => {
    if (biasTestId === null) {
      return '';
    }

    const performanceMetricDisplayName = (
      performanceMetricDefinition ?? metricDefinition
    ).displayName.toLowerCase();

    let metricFullDisplayName: string;
    if (taskMetricModifier === 'RunningAverage') {
      metricFullDisplayName = `Running Average ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'LogAverage') {
      metricFullDisplayName = `Log Average ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'Variance') {
      metricFullDisplayName = `${taskMetricDisplayName} variance`;
    } else if (taskMetricModifier === 'Log') {
      metricFullDisplayName = `Log ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'Joining') {
      metricFullDisplayName = `Joining ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'LogJoining') {
      metricFullDisplayName = `Log Joining ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'Leaving') {
      metricFullDisplayName = `Leaving ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'Growth') {
      metricFullDisplayName = `${taskMetricDisplayName} growth rate`;
    } else if (taskMetricModifier === 'Average') {
      metricFullDisplayName = `Average ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === null) {
      metricFullDisplayName = taskMetricDisplayName;
    } else {
      throw guardExhaustive(taskMetricModifier);
    }

    switch (biasTestId) {
      case 9:
        return metricFullDisplayName;
      case 3:
        return `Joining ${metricDefinition.displayName.toLowerCase()} disparity`;
      case 0:
        return metricDefinition.displayName;
      case 12:
        return `${metricDefinition.displayName} growth rate`;
      case 6:
        return `Joining ${metricDefinition.displayName.toLowerCase()} disparity`;
      case 4:
        return `Joining ${performanceMetricDisplayName}`;
      case 11:
        return `${metricDefinition.displayName} disparity`;
      case 10:
        return `${performanceMetricDisplayName} variance`;
      case 5:
        return `${metricDefinition.displayName} disparity`;
      case 1:
        return metricFullDisplayName;
      case 2:
        return metricFullDisplayName;
      case 7:
        return `${treatmentLevel.displayName} representation`;
      case 8:
        return '';
      case 13:
        return '';
      default:
        return '';
    }
  },

  yAxisForExplanatoryFactors: ({ metricDefinition, groupResult }) => {
    if (groupResult.plot_type === 'BinScatterControlledVsUncontrolled') {
      if (metricDefinition.isMetricBoolean) {
        return `Chances ${metricDefinition.whiteLabeling.subjectPlural} ${metricDefinition.whiteLabeling.subjectConditionalVerb}`;
      } else {
        return metricDefinition.displayName;
      }
    } else if ('decompositionType' in groupResult) {
      return groupResult.decompositionType === 'Oaxaca Beta'
        ? `Estimated ${metricDefinition.displayName}`
        : `Accounting for ${groupResult.controlVariableDisplayName}`;
    } else {
      return `${metricDefinition.displayName} disparity`;
    }
  },

  headlineForBiasVisualization: ({
    textOutputs,
    metricDefinition,
    treatmentLevelDefinition,
    referenceLevelDefinition,
    dimensionDefinition,
    metricCalibrationFraming,
    metricSkillCalibrationFraming,
    failType,
  }) => {
    if (!textOutputs || typeof textOutputs === 'string') {
      return 'Bias';
    }

    const defaultHeadline = '';

    if (textOutputs.biasTestId === undefined) return defaultHeadline;

    const treatmentGroupDisplayName = `${treatmentLevelDefinition.displayName} ${metricDefinition.whiteLabeling.subjectPlural}`;
    const metricDisplayName = metricDefinition.displayName.toLowerCase();
    const metricSubjectPluralDisplayName =
      metricDefinition.whiteLabeling.subjectPlural.toLowerCase();
    const dimensionDisplayName = dimensionDefinition.displayName.toLowerCase();
    const treatmentLevelDisplayName =
      treatmentLevelDefinition.displayName.toLowerCase();
    const referenceLevelDisplayName =
      referenceLevelDefinition.displayName.toLowerCase();

    const skillOrRisk =
      metricCalibrationFraming === 'Negative' &&
      metricSkillCalibrationFraming === 'Positive'
        ? 'risk'
        : 'skill';

    let positiveOrNegativeText = '';
    let higherOrLowerText = '';
    // bias against - positive framing => negative
    // bias against - negative framing => positive
    // bias for - positive framing => positive
    // bias for - negative framing => negative
    if (failType === 'BiasAgainst' && metricCalibrationFraming === 'Positive') {
      positiveOrNegativeText = 'negative';
    } else if (
      failType === 'BiasAgainst' &&
      metricCalibrationFraming === 'Negative'
    ) {
      positiveOrNegativeText = 'positive';
    } else if (
      failType === 'BiasInFavorOf' &&
      metricCalibrationFraming === 'Positive'
    ) {
      positiveOrNegativeText = 'positive';
    } else if (
      failType === 'BiasInFavorOf' &&
      metricCalibrationFraming === 'Negative'
    ) {
      positiveOrNegativeText = 'negative';
    }
    switch (textOutputs.biasTestId) {
      case 0:
        return `Higher ${positiveOrNegativeText} ${metricDisplayName} disparity at shorter tenures`;
      case 1:
        return `Different ${dimensionDisplayName} preferences among ${treatmentLevelDisplayName} and/or ${referenceLevelDisplayName} managers`;
      case 2:
        return `Different ${metricDisplayName} standards for ${metricSubjectPluralDisplayName} based on ${dimensionDisplayName}`;
      case 3:
        return `Higher ${positiveOrNegativeText} ${metricDisplayName} disparity in departments with subjective skill assessments`;
      case 4:
        return `Worse, more varied performance among ${treatmentGroupDisplayName} with ${referenceLevelDisplayName} managers`;
      case 5:
        return `Higher ${metricDisplayName} disparities in departments with fewer ${treatmentGroupDisplayName}`;
      case 6:
        return `Higher ${positiveOrNegativeText} ${metricDisplayName} disparities against externally-sourced ${metricSubjectPluralDisplayName}`;
      case 7:
        return `Referrals reduce ${dimensionDisplayName} representation`;
      case 8:
        return defaultHeadline;
      case 9:
        return `Higher ${positiveOrNegativeText} ${metricDisplayName} disparity at lower ${skillOrRisk} levels`;
      case 10:
        return `More consistent performance among ${treatmentGroupDisplayName} with managers of same ${dimensionDisplayName}`;
      case 11:
        return `Higher ${positiveOrNegativeText} ${metricDisplayName} disparities for ${treatmentGroupDisplayName} hired by ${referenceLevelDisplayName} managers`;
      case 12:
        // notice that the higherOrLowerText here is different from higherOrLowerText below in explanationForBiasVisualization
        if (
          failType === 'BiasAgainst' &&
          metricCalibrationFraming === 'Positive'
        ) {
          higherOrLowerText = 'Lower';
        } else if (
          failType === 'BiasAgainst' &&
          metricCalibrationFraming === 'Negative'
        ) {
          higherOrLowerText = 'Higher';
        } else if (
          failType === 'BiasInFavorOf' &&
          metricCalibrationFraming === 'Positive'
        ) {
          higherOrLowerText = 'Higher';
        } else if (
          failType === 'BiasInFavorOf' &&
          metricCalibrationFraming === 'Negative'
        ) {
          higherOrLowerText = 'Lower';
        }
        return `${higherOrLowerText} ${metricDisplayName} growth for ${treatmentGroupDisplayName} with managers of different ${dimensionDisplayName}`;
      case 13:
        return `Threshold Gap Analysis:\nWhere ${metricDisplayName} decisions change, by ${dimensionDisplayName}`;
      default:
        return defaultHeadline;
    }
  },

  explanationForBiasVisualization: ({
    textOutputs,
    metricDefinition,
    treatmentLevelDefinition,
    referenceLevelDefinition,
    dimensionDefinition,
    metricCalibrationFraming,
    metricSkillCalibrationFraming,
    failType,
    taskMetricDisplayName,
    taskMetricModifier,
    calibrationFraming,
    treatmentThresholdDetails,
    referenceThresholdDetails,
    //todo need access to point vals.
  }) => {
    if (!textOutputs || typeof textOutputs === 'string') {
      return '';
    }

    if (textOutputs.biasTestId === undefined) return '';

    const treatmentGroupDisplayName =
      `${treatmentLevelDefinition.displayName} ${metricDefinition.whiteLabeling.subjectPlural}`.toLocaleLowerCase();
    const referenceGroupDisplayName =
      `${referenceLevelDefinition.displayName} ${metricDefinition.whiteLabeling.subjectPlural}`.toLocaleLowerCase();

    const metricDisplayName = metricDefinition.displayName.toLowerCase();
    const metricSubjectPluralDisplayName =
      metricDefinition.whiteLabeling.subjectPlural.toLowerCase();
    const metricSubjectSingularDisplayName =
      metricDefinition.whiteLabeling.subjectSingular.toLowerCase();
    const dimensionDisplayName = dimensionDefinition.displayName.toLowerCase();
    const treatmentLevelDisplayName =
      treatmentLevelDefinition.displayName.toLowerCase();
    const referenceLevelDisplayName =
      referenceLevelDefinition.displayName.toLowerCase();

    const skillOrRisk =
      metricCalibrationFraming === 'Negative' &&
      metricSkillCalibrationFraming === 'Positive'
        ? 'risk'
        : 'skilled';

    let positiveOrNegativeText = '';
    let higherOrLowerText = '';
    // negative positive disparity
    // bias against and positive framing => greater negative
    // bias against and negative framing => greater positive
    // bias for and positive framing => greater positive
    // bias for and negative framing => greater negative
    if (failType === 'BiasAgainst' && metricCalibrationFraming === 'Positive') {
      positiveOrNegativeText = 'negative';
      higherOrLowerText = 'higher';
    } else if (
      failType === 'BiasAgainst' &&
      metricCalibrationFraming === 'Negative'
    ) {
      positiveOrNegativeText = 'positive';
      higherOrLowerText = 'lower';
    } else if (
      failType === 'BiasInFavorOf' &&
      metricCalibrationFraming === 'Positive'
    ) {
      positiveOrNegativeText = 'positive';
      higherOrLowerText = 'lower';
    } else if (
      failType === 'BiasInFavorOf' &&
      metricCalibrationFraming === 'Negative'
    ) {
      positiveOrNegativeText = 'negative';
      higherOrLowerText = 'higher';
    }
    let biasFramingText: string;
    if (failType === 'BiasAgainst') {
      biasFramingText = 'against';
    } else if (failType === 'BiasInFavorOf') {
      biasFramingText = 'in favor of';
    } else {
      throw guardExhaustive(failType);
    }

    let metricFullDisplayName: string;
    if (taskMetricModifier === 'RunningAverage') {
      metricFullDisplayName = `Running Average ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'LogAverage') {
      metricFullDisplayName = `Log Average ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'Variance') {
      metricFullDisplayName = `${taskMetricDisplayName} variance`;
    } else if (taskMetricModifier === 'Log') {
      metricFullDisplayName = `Log ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'Joining') {
      metricFullDisplayName = `Joining ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'LogJoining') {
      metricFullDisplayName = `Log Joining ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'Leaving') {
      metricFullDisplayName = `Leaving ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === 'Growth') {
      metricFullDisplayName = `${taskMetricDisplayName} growth rate`;
    } else if (taskMetricModifier === 'Average') {
      metricFullDisplayName = `Average ${taskMetricDisplayName}`;
    } else if (taskMetricModifier === null) {
      metricFullDisplayName = taskMetricDisplayName;
    } else {
      throw guardExhaustive(taskMetricModifier);
    }

    const calibratedPrefix =
      calibrationFraming === 'optimization'
        ? 'Data shows'
        : 'There is evidence of';

    switch (textOutputs.biasTestId) {
      case 0:
        return `${calibratedPrefix} ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'information bias'} ${biasFramingText} ${treatmentGroupDisplayName} because as these ${metricSubjectPluralDisplayName} stay longer at your organization, the ${metricDisplayName} disparity reduces significantly. This is evidence of ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'information bias'} because as the organization learns more about a ${treatmentLevelDisplayName} ${metricSubjectSingularDisplayName}'s skill level, it relies less on ${dimensionDisplayName} and more on objective signals of skill.`;
      case 1:
        return `${calibratedPrefix} ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'preference bias'} when it comes to the first year performance of ${metricSubjectPluralDisplayName} who have ${treatmentLevelDisplayName} managers as opposed to ${referenceLevelDisplayName} managers. More specifically, there is a significant difference in the first year performances of ${treatmentGroupDisplayName} with ${treatmentLevelDisplayName} managers as opposed to ${referenceLevelDisplayName} managers. However, the direction of this difference is in the opposite direction when considering ${referenceGroupDisplayName}. This suggests that ${treatmentLevelDisplayName} and/or ${referenceLevelDisplayName} managers have different preferences for ${calibrationFraming === 'optimization' ? 'subjects' : 'employees'} based on their ${dimensionDisplayName}.`;
      case 2:
        return `${calibratedPrefix} ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'preference bias'} ${biasFramingText} ${treatmentGroupDisplayName} because they have significantly ${higherOrLowerText} ${metricFullDisplayName} than ${referenceGroupDisplayName}.`;
      case 3:
        return `${calibratedPrefix} ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'information bias'} ${biasFramingText} ${treatmentGroupDisplayName} in non-tech departments at your organization. This is demonstrated by the significant differences in ${metricDisplayName} disparity between ${treatmentLevelDefinition.displayName} and ${referenceGroupDisplayName} in tech departments as opposed to non-tech departments. This is evidence of ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'information bias'} because tech-related roles have more objective assessments of skills, which leave less room for ${calibrationFraming === 'optimization' ? 'inefficiency' : 'bias'} to creep in.`;
      case 4:
        return `${calibratedPrefix} ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'information bias'} against ${treatmentGroupDisplayName} who had managers that did not have the same ${dimensionDisplayName}. This is demonstrated by the significantly lower average and higher variance in the true performance of ${treatmentGroupDisplayName} with ${referenceLevelDisplayName} managers. This is considered ${calibrationFraming === 'optimization' ? 'as an inefficiency' : 'information bias'} because the ${referenceLevelDisplayName} managers rely on noisy, subjective signals of performance that aren't correlated with true performance, which ultimately leads to the true performance of ${treatmentGroupDisplayName} being lower on average and highly varied.`;
      case 5:
        return `${calibratedPrefix} increased representation of ${treatmentGroupDisplayName} in a given department reduces the amount of disparity in ${metricDisplayName} for that department. We observe that departments with better representation also have less disparity against ${treatmentGroupDisplayName}. This ${calibrationFraming === 'optimization' ? 'is indicative of inefficiency' : `suggests that there is preference bias against ${treatmentGroupDisplayName}`} because underrepresentation is associated with worse outcomes.`;
      case 6:
        return `${calibratedPrefix} ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'information bias'} ${biasFramingText} ${treatmentGroupDisplayName} who were not sourced from referral networks. More specifically, the disparity in ${metricDisplayName} between ${treatmentGroupDisplayName} and ${referenceGroupDisplayName} is less ${positiveOrNegativeText} when the ${metricSubjectPluralDisplayName} were sourced from referral networks. This is considered ${calibrationFraming === 'optimization' ? 'as an inefficiency' : 'information bias'} because it can be assumed that the organization has more information about ${metricSubjectPluralDisplayName} that are sourced from referral networks than those sourced from non-referrals.`;
      case 7:
        return `${calibratedPrefix} referral networks reduce representation of ${treatmentGroupDisplayName} in your organization. This means that increasing the proportion of new hires sourced from referrals is associated with a smaller proportion of ${treatmentGroupDisplayName}.`;
      case 8:
        return '';
      case 9:
        return `${calibratedPrefix} ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'information bias'} ${biasFramingText} ${treatmentGroupDisplayName} because there is a greater ${positiveOrNegativeText} disparity between low-${skillOrRisk} ${treatmentGroupDisplayName} and ${referenceGroupDisplayName} than between high-${skillOrRisk} ${treatmentGroupDisplayName} and ${referenceGroupDisplayName}. It can be seen that as the ${skillOrRisk} of ${treatmentGroupDisplayName} increases, the ${metricDisplayName} has less ${positiveOrNegativeText} disparity.`;
      case 10:
        return `${calibratedPrefix} ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'preference bias'} from managers of ${treatmentGroupDisplayName}. This test determines whether ${treatmentGroupDisplayName} have less varied performance when managed by ${treatmentLevelDefinition.displayName} managers as opposed to managers of a different ${dimensionDisplayName}. If ${treatmentGroupDisplayName} who have had at least one ${treatmentLevelDefinition.displayName} manager have significantly lower variance in their performance over time than ${treatmentGroupDisplayName} who had only managers of a different ${dimensionDisplayName}, then this ${calibrationFraming === 'optimization' ? 'indicates inefficiency.' : 'is indicative of bias.'}`;
      case 11:
        return `${calibratedPrefix} ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'information bias'} ${biasFramingText} ${treatmentGroupDisplayName} by ${referenceLevelDefinition.displayName} hiring managers because there is a significant difference in ${metricDisplayName} disparities between ${treatmentGroupDisplayName} and ${referenceGroupDisplayName} when the hiring managers are ${treatmentLevelDefinition.displayName} as opposed to ${referenceLevelDefinition.displayName}.`;
      case 12:
        return `${calibratedPrefix} ${calibrationFraming === 'optimization' ? 'inefficiencies' : 'information bias'} because the ${metricDisplayName} trajectories of ${treatmentGroupDisplayName} differ based on the ${dimensionDisplayName} of their managers. This is demonstrated by the ${higherOrLowerText} growth rate in ${metricDisplayName} for ${treatmentGroupDisplayName} with ${treatmentLevelDefinition.displayName} managers. This is considered ${calibrationFraming === 'optimization' ? 'an inefficiency' : 'information bias'} because managers of the same ${dimensionDisplayName} have better information about these ${metricSubjectPluralDisplayName} than managers of a different ${dimensionDisplayName}.`;
      case 13:
        return `There is a significant difference in the amount of ${metricCalibrationFraming === 'Positive' ? 'skill level' : 'standard of evidence'} required to justify the ${metricDisplayName} of ${treatmentGroupDisplayName} compared to ${referenceGroupDisplayName}. The data shows ${higherOrLowerText === 'higher' ? referenceGroupDisplayName : treatmentGroupDisplayName} experience a decisive increase in ${metricDisplayName} probability at ${Math.round(referenceThresholdDetails?.threshold ?? 0)} points of ${metricCalibrationFraming === 'Positive' ? 'skill' : 'evidence'}, while ${higherOrLowerText === 'higher' ? treatmentGroupDisplayName : referenceGroupDisplayName} don't face a similar increase until reaching ${Math.round(treatmentThresholdDetails?.threshold ?? 0)} points -- creating a ${Math.round(Math.abs((referenceThresholdDetails?.threshold ?? 0) - (treatmentThresholdDetails?.threshold ?? 0)))} point gap between ${dimensionDisplayName}s.\n\nThis means, according to the data available, ${higherOrLowerText === 'higher' ? treatmentGroupDisplayName : referenceGroupDisplayName} require a higher ${metricCalibrationFraming === 'Positive' ? 'skill level' : 'standard of evidence'} to justify ${metricFullDisplayName} compared to ${higherOrLowerText === 'higher' ? referenceGroupDisplayName : treatmentGroupDisplayName}.`;
      default:
        return '';
    }
  },
  thresholdTreatmentGroupExplanation: ({
    treatmentThresholdDetails,
    treatmentLevelDefinition,
    metricDefinition,
  }) => {
    if (!treatmentThresholdDetails) {
      return '';
    }

    const percentBelow = englishGetPercentage({
      value: treatmentThresholdDetails.below_threshold_value * 100,
    });
    const percentAbove = englishGetPercentage({
      value: treatmentThresholdDetails.above_threshold_value * 100,
    });

    const body = `At ${Math.round(treatmentThresholdDetails.threshold)} ${metricDefinition.calibrationFraming === 'Positive' ? 'skill level' : 'standard of evidence'} points, ${treatmentLevelDefinition?.displayName.toLocaleLowerCase()}s experience a significant increase in ${metricDefinition.displayName} probability, jumping from ${percentBelow} to ${percentAbove}. This represents the critical threshold where ${metricDefinition.calibrationFraming === 'Positive' ? 'skill level' : 'standard of evidence'} typically plays a big role in ${metricDefinition.displayName} consideration for ${treatmentLevelDefinition?.displayName.toLocaleLowerCase()}s.`;

    return [
      {
        text: `Decision Threshold Point:\n`,
        isBold: true,
        color: 'black',
      },
      {
        text: `${capitalize(metricDefinition.displayName)} probability jump: ${percentBelow} --> ${percentAbove}.\n `,
        isBold: true,
        color: 'purple',
      },

      { text: body },
    ];
  },

  thresholdReferenceGroupExplanation: ({
    referenceThresholdDetails,
    referenceLevelDefinition,
    metricDefinition,
  }) => {
    if (!referenceThresholdDetails) {
      return '';
    }
    const percentBelow = englishGetPercentage({
      value: referenceThresholdDetails.below_threshold_value * 100,
    });
    const percentAbove = englishGetPercentage({
      value: referenceThresholdDetails.above_threshold_value * 100,
    });

    const body = `At ${Math.round(referenceThresholdDetails.threshold)} ${metricDefinition.calibrationFraming === 'Positive' ? 'skill level' : 'standard of evidence'} points, ${referenceLevelDefinition?.displayName.toLocaleLowerCase()}s experience a significant increase in ${metricDefinition.displayName} probability, jumping from ${percentBelow} to ${percentAbove}. This represents the critical threshold where ${metricDefinition.calibrationFraming === 'Positive' ? 'skill level' : 'standard of evidence'} typically plays a big role in ${metricDefinition.displayName} consideration for ${referenceLevelDefinition?.displayName.toLocaleLowerCase()}s.`;

    return [
      {
        text: `Decision Threshold Point:\n`,
        isBold: true,
        color: 'black',
      },
      {
        text: `${capitalize(metricDefinition.displayName)} probability jump: ${percentBelow} --> ${percentAbove}.\n `,
        isBold: true,
        color: 'blue',
      },

      { text: body },
    ];
  },

  thresholdGapExplanation: ({
    treatmentThresholdDetails,
    referenceThresholdDetails,
    metricDefinition,
  }) => {
    if (!treatmentThresholdDetails || !referenceThresholdDetails) {
      return '';
    }

    const gap = Math.round(
      Math.abs(
        treatmentThresholdDetails.threshold -
          referenceThresholdDetails.threshold,
      ),
    );

    const body = `These are points where each group experiences a substantial increase in likelihood of ${metricDefinition.displayName}, indicating different standards applied to each group.`;

    return [
      {
        text: `This ${gap} point difference shows the gap between critical decision thresholds.\n`,
        isBold: true,
        color: 'black',
      },
      { text: body },
    ];
  },

  thresholdWhatsThisTitle() {
    return [
      {
        text: 'What is a point?',
        isBold: true,
        color: 'black',
      },
    ];
  },

  thresholdWhatsThisDescription: ({ metricDefinition, controlVariables }) => {
    return [
      {
        text: `A 'point' represents a standardized unit that quantifies how much ${metricDefinition.calibrationFraming === 'Positive' ? 'skill level' : 'standard of evidence'} is present - based on historical data - to justify a ${metricDefinition.displayName} decision.\n\nThe score is calculated after accounting for a set of control variables, such as:\n\n ${controlVariables?.join('\n')}\n\n The ${metricDefinition.calibrationFraming === 'Positive' ? 'Skill Level' : 'Standard of Evidence'} Index score allows comparisons across different groups and contexts by holding these factors constant.`,
        color: 'black',
      },
    ];
  },

  headlineForExplanatoryFactors: ({ controlVariableName }) => {
    return englishGetHeadlineForExplanatoryFactors({ controlVariableName });
  },
  explanationForExplanatoryFactors: ({
    dimensionDefinition,
    metricDefinition,
    treatmentLevelDefinition,
    referenceLevelDefinition,
    controlVariableName,
    analysisType,
    plotType,
    categoriesName,
  }) => {
    return englishGetExplanationForExplanatoryFactors({
      dimensionDefinition,
      metricDefinition,
      treatmentLevelDefinition,
      referenceLevelDefinition,
      controlVariableName,
      analysisType,
      plotType,
      categoriesName,
    });
  },
  oaxacaConclusion: (params: {
    metricDefinition: MyMetricDefinition;
    treatmentLevelDefinition: LevelDefinition;
    referenceLevelDefinition: LevelDefinition;
    controlVariableName: string | null;
    analysisType: string | null;
    categoriesName: OaxacaCategoriesName | undefined;
    originalTreatmentLevelDisparity: number | null;
  }) => {
    return englishGetOaxacaConclusion({
      metricDefinition: params.metricDefinition,
      treatmentLevelDefinition: params.treatmentLevelDefinition,
      referenceLevelDefinition: params.referenceLevelDefinition,
      controlVariableName: params.controlVariableName,
      analysisType: params.analysisType,
      categoriesName: params.categoriesName,
      originalTreatmentLevelDisparity: params.originalTreatmentLevelDisparity,
    });
  },
  referenceGroupNote: () => {
    return [
      { text: '* This is the ' },
      { text: 'Comparison Group', isBold: true },
      {
        text: ', the reference group used to benchmark and analyze relative differences.',
      },
    ];
  },
  disparityOpportunityTitle: ({
    metricDisplayName,
    treatmentGroupDisplayName,
    whiteLabelingSubjectPlural,
  }) =>
    upperFirstString(
      `${metricDisplayName} of ${treatmentGroupDisplayName} ${whiteLabelingSubjectPlural}`.toLocaleLowerCase(),
    ),

  privilegedLevelDisplayName: ({ myObservation, dimension }) =>
    englishGetPrivilegedLevelDisplayName({
      dimension,
      myObservation,
    }),

  biasAnalysisCardTitle: ({ myObservation, request }) => {
    return englishGetBiasAnalysisCardTitle({
      myObservation,
      request,
    });
  },

  biasAnalysisCardBody: ({ myObservation, request }) => {
    return englishGetBiasAnalysisCardBody({
      myObservation,
      request,
    });
  },

  tableViewCardTitle: ({ myObservation, request }) => {
    return englishGetTableViewCardTitle({
      myObservation,
      request,
    });
  },

  tableViewCardBody: ({ myObservation, request }) => {
    return englishGetTableViewCardBody({
      myObservation,
      request,
    });
  },

  summaryStatsCardTitle: ({ myObservation, request }) => {
    return englishGetSummaryStatsCardTitle({
      myObservation,
      request,
    });
  },

  summaryStatsCardBody: ({ myObservation, request }) => {
    return englishGetSummaryStatsCardBody({
      myObservation,
      request,
    });
  },

  savedAnalysisLevelDisplayName: ({
    myObservation,
    dimension,
    treatmentDimensionLevel,
  }) =>
    englishGetSavedAnalysisLevelDisplayName({
      myObservation,
      dimension,
      treatmentDimensionLevel,
    }),

  progressCardTitle: ({ myObservation, request }) => {
    return englishGetProgressCardTitle({
      myObservation,
      request,
    });
  },

  progressCardBody: ({ myObservation, request }) => {
    return englishGetProgressCardBody({
      myObservation,
      request,
    });
  },

  timeSeriesTrendsCardTitle: ({ myObservation, request }) => {
    return englishGetTimeSeriesTrendsCardTitle({
      myObservation,
      request,
    });
  },

  timeSeriesTrendsCardBody: ({ myObservation, request }) => {
    return englishGetTimeSeriesTrendsCardBody({
      myObservation,
      request,
    });
  },

  timeSeriesTrendsLineChartSeriesLabel: ({ seriesId, metricDefinition }) => {
    if (seriesId === AverageTrendSeriesId) {
      return `Average ${metricDefinition.displayName}`;
    }

    if (seriesId === ControlGroupSeriesId) {
      return 'Control Group';
    }

    const lineGroup = extractLineGroupFromSeriesId(seriesId);
    if (!lineGroup) {
      return seriesId;
    }

    if (lineGroup === ObservedMetricLineGroup) {
      return `Observed ${metricDefinition.displayName}`;
    }

    return lineGroup;
  },

  timeSeriesTrendsLineChartLegendAllLabel: () => 'All',

  exploreCardTitle: ({ myObservation, request }) => {
    return englishGetExploreCardTitle({
      myObservation,
      request,
    });
  },

  exploreCardBody: ({ myObservation, request }) => {
    return englishGetExploreCardBody({
      myObservation,
      request,
    });
  },

  binScatterMultiSelectCardTitle: ({ myObservation, request }) => {
    return englishGetBinScatterMultiSelectCardTitle({
      myObservation,
      request,
    });
  },

  binScatterMultiSelectCardBody: ({ myObservation, request }) => {
    return englishGetBinScatterMultiSelectCardBody({
      myObservation,
      request,
    });
  },

  pipelineAnalysisCardTitle: ({ myObservation, request }) => {
    return englishGetPipelineAnalysisCardTitle({
      myObservation,
      request,
    });
  },

  pipelineAnalysisCardBody: ({ myObservation, request }) => {
    return englishGetPipelineAnalysisCardBody({
      myObservation,
      request,
    });
  },

  successFactorsCardTitle: ({ request, myObservation }) => {
    return englishGetSuccessFactorsCardTitle({
      request,
      myObservation,
    });
  },

  successFactorsCardBody: ({ request, myObservation }) => {
    return englishGetSuccessFactorsCardBody({
      request,
      myObservation,
    });
  },

  savedAnalysisCardTitle: ({ myObservation, request }) => {
    if (!request || !myObservation) {
      return `Unknown`;
    }

    switch (request.customVizId) {
      case 'biasAnalysis':
        return englishGetBiasAnalysisCardTitle({
          myObservation,
          request,
        });
      case 'progress':
        return englishGetProgressCardTitle({
          myObservation,
          request,
        });
      case 'heatmap':
        return englishGetExploreCardTitle({
          request,
          myObservation,
        });
      case 'pipelineAnalysis':
        return englishGetPipelineAnalysisCardTitle({
          request,
          myObservation,
        });
      case 'successPhenotypeV2':
        return englishGetSuccessFactorsCardTitle({
          myObservation,
          request,
        });
      case 'binScatterMultiSelect':
        return englishGetBinScatterMultiSelectCardTitle({
          myObservation,
          request,
        });
      case 'tableView':
        return englishGetTableViewCardTitle({
          myObservation,
          request,
        });
      case 'summaryStats':
        return englishGetSummaryStatsCardTitle({
          myObservation,
          request,
        });
      case 'timeSeriesTrends':
        return englishGetTimeSeriesTrendsCardTitle({
          myObservation,
          request,
        });
      case 'richText':
        return englishPhrases.richTextPageTitle();
      case 'geolocation':
        return englishGetGeolocationCardTitle({
          request,
          myObservation,
        });
    }

    return `Unknown`;
  },

  savedAnalysisCardBody: ({ myObservation, request }) => {
    if (!request || !myObservation) {
      return `- no filters -`;
    }

    switch (request.customVizId) {
      case 'biasAnalysis':
        return englishGetBiasAnalysisCardBody({
          myObservation,
          request,
        });
      case 'progress':
        return englishGetProgressCardBody({
          myObservation,
          request,
        });
      case 'heatmap':
        return englishGetExploreCardBody({
          request,
          myObservation,
        });
      case 'pipelineAnalysis':
        return englishGetPipelineAnalysisCardBody({
          request,
          myObservation,
        });
      case 'successPhenotypeV2':
        return englishGetSuccessFactorsCardBody({
          myObservation,
          request,
        });
      case 'binScatterMultiSelect':
        return englishGetBinScatterMultiSelectCardBody({
          myObservation,
          request,
        });
      case 'tableView':
        return englishGetTableViewCardBody({
          myObservation,
          request,
        });
      case 'summaryStats':
        return englishGetSummaryStatsCardBody({
          myObservation,
          request,
        });
      case 'geolocation':
        return englishGetGeolocationCardBody({
          request,
          myObservation,
        });
      case 'timeSeriesTrends':
        return englishGetTimeSeriesTrendsCardBody({
          myObservation,
          request,
        });
    }

    return `- no filters -`;
  },

  analyzeBiasDescription: (input) => {
    return englishGetAnalyzeBiasDescription(input);
  },

  groupTrends: () => `Group Trends`,
  biasAnalysis: () => 'Bias Analysis',
  binScatterMultiSelect: () => 'Bin Scatter Multi Select',

  groupName: () => `Group Name`,
  actions: () => `Actions`,

  manageEntitlements: () => 'Manage Entitlements',
  addRemoveUsers: () => 'Add/Remove Users',
  deleteGroup: () => 'Delete Group',

  patternLabel: () => `I want to match data that...`,
  patternLabelWithoutDotDotDot: () => `I want to match data that`,
  addSegmentLabel: () => `+ Add Segment`,
  textSegmentLabel: () => `one of the following text strings`,
  wildcardStringSegmentLabel: () => `any text string`,
  wildcardNumberSegmentLabel: () => `any number`,
  wildcardDateSegmentLabel: () => `any date`,
  whitespaceSegmentLabel: () => `any whitespace`,
  firstSegmentLabel: () => `starts with`,
  nextSegmentLabel: () => `followed by`,
  endPatternLabel: () => `and ends.`,
  caseSensitiveLabel: () => `case sensitive`,
  caseInsensitiveLabel: () => `case insensitive`,
  matchingWithLabel: () => `matching with`,
  nothingPatternSegmentWildcardLabel: () => `no exceptions`,
  charactersPatternSegmentWildcardLabel: () => `these characters excluded`,
  textPatternSegmentWildcardLabel: () => `these specific text strings excluded`,
  withLabel: () => `with`,
  patternExcludedText: ({ text, isCaseSensitive }) =>
    `\"${text}\" ${isCaseSensitive ? '(case sensitive)' : '(case insensitive)'}`,
  removeInParenthesis: () => `(remove)`,
  caseSensitiveToggleText: () => `Cc`,
  caseSensitiveToggleTooltip: ({ isCaseSensitive }) =>
    isCaseSensitive
      ? 'Click to toggle case sensitivity off'
      : 'Click to toggle case sensitivity on',
  nanAndInfinityToggleTooltip: ({ allowNanAndInfinity }) =>
    allowNanAndInfinity
      ? `Click to exclude NaN/infinity`
      : `Click to include NaN/infinity`,
  enterCharactersPlaceholder: () => `enter characters...`,
  comma: () => `,`,
  patternTextPreview: ({ text, isCaseSensitive }) =>
    `\"${text}\" ${isCaseSensitive ? '(case sensitive)' : '(case insensitive)'}`,
  enterTextPlaceholder: () => `enter text...`,
  space: () => ` `,
  period: () => '.',
  minimumToggleText: () => `>=`,
  minimumToggleTooltip: ({ hasMinimum }) =>
    hasMinimum ? `Click to remove minimum` : `Click to add minimum`,
  maximumToggleText: () => `<=`,
  maximumToggleTooltip: ({ hasMaximum }) =>
    hasMaximum ? `Click to remove maximum` : `Click to add maximum`,
  numberWildcardPreview: ({ minimum, maximum, allowNanAndInfinity }) => {
    const minText =
      minimum !== undefined ? ` greater than or equal to \"${minimum}\"` : '';
    const showAnd = minimum !== undefined && maximum !== undefined;
    const maxText =
      maximum !== undefined
        ? ` ${showAnd ? 'and ' : ''}less than or equal to \"${maximum}\"`
        : '';
    const nanText = allowNanAndInfinity
      ? ' including NaN/infinity'
      : ' excluding NaN/infinity';
    return `${minText}${maxText}${nanText}`.trim();
  },
  dateWildcardPreview: ({ minimum, maximum }) => {
    const minText =
      minimum !== undefined
        ? ` on the date or after the date \"${minimum}\"`
        : '';
    const showAnd = minimum !== undefined && maximum !== undefined;
    const maxText =
      maximum !== undefined
        ? ` ${showAnd ? 'and ' : ''}on the date or before the date \"${maximum}\"`
        : '';
    return `${minText}${maxText}`.trim();
  },
  addTextStringTooltip: ({ isDisabled }) =>
    isDisabled
      ? `Enter text and click to add text string`
      : `Click to add a text string`,
  segmentSaveChangesTooltip: ({ isDisabled }) =>
    isDisabled
      ? `Fix errors and click to save changes to pattern segment`
      : `Click to save changes to pattern segment`,
  segmentDiscardChangesTooltip: () =>
    `Click to discard changes to pattern segment`,
  editPatternSegmentTooltip: () => `Click to edit pattern segment`,
  segmentRemoveTextItem: ({ text, isCaseSensitive }) => {
    const caseHint = isCaseSensitive
      ? '(case sensitive)'
      : '(case insensitive)';
    return `Click to remove \"${text}\" ${caseHint}`;
  },
  removePatternSegmentTooltip: () => `Click to remove pattern segment`,
  emptyPatternError: () => `Please add at least one segment to your pattern.`,
  multipleWildcardsInARowError: () =>
    `You may not have multiple wildcard (aka \"any\") segments in a row. See the red rows above for the segments that need to be fixed.`,
  unknownPatternError: () =>
    `There was an error parsing your pattern. Please check the red rows above for the segments that need to be fixed.`,
  patternPreview: ({ sampleValues }) => {
    return `Sample Values: \n${sampleValues.map((s) => `• ${s}`).join('\n')}`;
  },
  noPatternSelected: () => `No pattern selected`,
  dataRuleHeaderPattern: () => `Data Rule CSV Header Pattern`,
  dataRuleValuePattern: () => `Data Rule CSV Value Pattern`,
  entitlementDatabaseNameLabel: ({ databaseName }) => [
    { text: `Database: ` },
    { text: databaseName, isBold: true },
  ],
  addNewDataRuleButton: () => `+ Add New Data Rule`,
  addNewFeatureButton: () => `+ Add New Feature`,
  editEntitlementButton: () => `Edit Entitlement`,
  ok: () => `OK`,
  cancel: () => `Cancel`,
  back: () => `Back`,
  settings: () => `Settings`,
  share: () => `Share`,
  add: () => `Add`,
  removeDataRuleTooltip: () => `Click to remove data rule`,
  dataRulesLabel: () => `Data Rules`,
  featuresLabel: () => `Features`,
  noDataRulesLabel: () => `No data rules configured.`,
  dashboards: () => `Dashboards`,
  allDashboards: () => `All Dashboards`,
  dashboardSummaryToggleLabel: () => `Summarize`,
  dashboardSummaryLoadingToggleLabel: () => `Summarizing`,
  dashboardSummaryTitle: () => `Summarize`,
  dashboardSummaryDescription: () =>
    `Add an AI summary of your dashboard content`,
  dashboardSummaryContextLabel: () => `Context`,
  dashboardSummaryContextPlaceholder: () =>
    `Enter specific details such as tone or language to refine the summary...`,
  dashboardSummaryHelperText: () =>
    `Be sure to check your summary output, AI can make mistakes and may not always be accurate.`,
  dashboardSummarySubmitLabel: () => `Add Summary`,
  dashboardSummaryStampedTitle: ({ dashboardName, date }) =>
    `${dashboardName} Summary (${date})`,
  dashboardSummaryPendingTitle: () => `Running dashboard analysis...`,
  dashboardSummaryGeneratingReportTitle: () => `Generating a report...`,
  dashboardSummaryGeneratingSummaryTitle: () => `Creating your summary...`,
  dashboardSummaryLoadingDescription: () =>
    `Your summary will be added to the top of your dashboard once it's finished. This may take a minute or two.`,
  dashboardSummaryRetryLabel: () => `Retry`,
  dashboardSummaryStartOverLabel: () => `Start Over`,
  dashboardSummaryErrorTitle: () => `We ran into an unexpected error`,
  dashboardSummaryErrorDescription: () =>
    `Our team is working to get your summaries back up and running. Please check back soon.`,
  dashboardSummaryOpenAIErrorTitle: () => `Summary failed to load`,
  dashboardSummaryOpenAIErrorDescription: () =>
    `We couldn't generate a summary right now. Please check your connection and try again.`,

  dashboardsShown: ({ dashboards }) => `${dashboards} Dashboards shown`,
  newDashboard: () => `New dashboard`,
  lastSaved: ({ date }) => {
    const now = new Date();
    const sevenDaysAgo = subDays(now, 7);

    if (isToday(date)) {
      return `Last saved today at ${format(date, 'h:mm a')}`;
    }

    if (isAfter(date, sevenDaysAgo)) {
      return `Last saved ${formatDistanceToNow(date, { addSuffix: true })}`;
    }

    return `Last saved ${format(date, 'EEEE, MMMM do')}`;
  },
  lastEditedLabel: () => `Last Edited`,
  relativeTimeShort: ({ date }) => formatRelativeTimeShort({ date }),
  noFeaturesLabel: () => `No features configured.`,
  groupEntitlementsTitle: () => `Group Entitlements`,
  addEntitlementButton: () => `+ Add Entitlement`,
  selectDatabaseLabel: () => `Select Database`,
  noEntitlements: () => `No entitlements configured.`,
  deleteEntitlementButton: () => `Delete Entitlement`,
  selectFeatureLabel: () => `Select Feature`,
  selectFocusAreaLabel: () => `Select Focus Area`,
  featureKeyTableHeading: () => `Feature Key`,
  featureFocusAreaTableHeading: () => `Feature Focus Area`,
  removeFeatureTooltip: () => `Click to remove feature`,
  featureKey: ({ key }) => key,
  featureFocusArea: ({ key, focusArea }) => {
    if (!isEntitlementFeatureWithOptionalFocusArea(key)) {
      return 'N/A';
    }

    return focusArea === null ? 'All' : focusArea;
  },
  featureValidationError: () =>
    `One of more features in the entitlement are invalid. Please check the feature keys and focus areas.`,
  addAStatistic: () => `Add a visualization`,
  addStatisticLegend: () => `Choose an analysis to add to your dashboard`,
  outcomeTrends: () => 'Outcome Trends',
  disparityTrends: () => 'Disparity Trends',
  controlledDisparities: () => 'Controlled Disparities',
  stat: () => 'Stat',
  editGroupEntitlementsButton: () => `Edit Group Entitlements`,
  manageGroupUsersButton: () => `Manage Group Users`,
  deleteGroupButton: () => `Delete Group`,
  areYouSureTitle: () => `Are you sure?`,
  areYouSureConfirmationPrompt: () => `Please type 'confirm' to confirm.`,
  groupDeleteAreYouSureBody: ({ groupName }) =>
    `Are you sure you would like to delete the group \"${groupName}\"?`,
  areYouSureConfirmButton: () => `Confirm`,
  areYouSureCancelButton: () => `Cancel`,
  createGroupButton: () => `Create Group`,
  groupNameLabel: () => `Group Name`,
  errorCreatingGroup: ({ baseError }) =>
    `An error occurred: ${JSON.stringify(baseError)}`,
  unknownError: () => `An unknown error occurred. Please try again later.`,
  dashboardExternalInviteWarningPrefix: () =>
    `Invites were saved, but invitation emails could not be sent:`,
  saveEntitlementsButton: () => `Save Entitlements`,
  errorSavingEntitlements: ({ baseError }) =>
    `An error occurred: ${JSON.stringify(baseError)}`,
  groupNameWithLabel: ({ groupName }) => [
    { text: `Group Name: ` },
    { text: groupName, isBold: true },
  ],
  organizationNameWithLabel: ({ organizationName }) => [
    { text: `Organization Name: ` },
    { text: organizationName, isBold: true },
  ],
  groupUsersTitle: () => `Group Users`,
  groupsPageTitle: () => `Groups`,
  selectUserLabel: () => `Select User`,
  addUserToGroupButton: () => `+ Add User to Group`,
  removeUserFromGroupButton: () => `Remove User from Group`,
  areYouSureRemoveUserFromGroup: ({ email }) =>
    `Are you sure you would like to remove \"${email}\" from this group?`,
  errorAddingUserToGroup: ({ baseError }) =>
    `An error occurred adding a user to the group: ${JSON.stringify(baseError)}`,
  errorRemovingUserFromGroup: ({ baseError }) =>
    `An error occurred removing a user from the group: ${JSON.stringify(baseError)}`,
  noUsersInGroup: () => `No users in this group.`,
  backToGroupsButton: () => `Back to Groups`,
  addToDashboard: () => `Add to dashboard`,
  nlpGraph: () => `NLP Graph`,
  addADescription: () => `Add a description...`,
  filters: () => `Filters`,
  sigma2Analysis: () => `Sigma Squared Analyses`,
  description: () => `Description`,
  pipelineAnalysis: () => `Pipeline Analysis`,
  groupBy: () => `Breakdown`,
  summaryStats: () => `Summary Statistics`,
  summaryStatsDescription: () =>
    'Create a chart from any characteristics of your organization’s  data.',
  dataTable: () => `Data Table`,
  dataTableDescription: () =>
    `Display a subset of your organization’s data in a table format.`,
  richTextDescription: () =>
    `Include an explanation or summary with  a block of formatted text.`,
  geolocationDescription: () => `Display a map of your organization’s data.`,
  essentialsAnalysis: () => `Essentials Analyses`,
  readinessExplanationHeader: ({ score }) =>
    `CANDIDATE READINESS: ${score}/100`,
  readinessExplanationDevelopmentPriorities: ({ sortBy }) =>
    `DEVELOPMENT PRIORITIES (Ordered by ${sortBy === 'trait_importance' ? 'Importance' : 'Impact'}):`,
  readinessExplanationTargetDescriptionGreaterThan: ({ target }) =>
    `More than ${target}`,
  readinessExplanationTargetDescriptionGreaterThanOrEqual: ({ target }) =>
    `${target} or more`,
  readinessExplanationTargetDescriptionLessThan: ({ target }) =>
    `Less than ${target}`,
  readinessExplanationTargetDescriptionLessThanOrEqual: ({ target }) =>
    `${target} or less`,
  readinessExplanationTargetDescriptionTwoSided: ({ target, upperTarget }) =>
    `${target} - ${upperTarget}`,
  readinessExplanationGapDescriptionInTargetCategorical: () =>
    `Matches target profile`,
  readinessExplanationGapDescriptionInTargetNumerical: () =>
    `Meets target threshold`,
  readinessExplanationGapDescriptionBelowTarget: ({ value }) =>
    `${value} below target`,
  readinessExplanationGapDescriptionMismatch: () =>
    'Does not match target profile',
  readinessExplanationPointUnitSingular: () => `pt`,
  readinessExplanationPointUnitPlural: () => `pts`,
  readinessExplanationImpactWithUnit: ({ impact, unit }) =>
    `+${impact} ${unit}`,
  readinessExplanationShortImpactDescriptionAlreadyOptimal: () =>
    'already optimal',
  readinessExplanationShortImpactDescriptionIfAligns: ({ impactWithUnit }) =>
    `${impactWithUnit} if aligns`,
  readinessExplanationShortImpactDescriptionIfDeveloped: ({ impactWithUnit }) =>
    `${impactWithUnit} if developed`,
  readinessExplanationImpactDescriptionAlreadyOptimal: ({ impactWithUnit }) =>
    `${impactWithUnit} (already optimal)`,
  readinessExplanationImpactDescriptionIfAligns: ({ impactWithUnit }) =>
    `${impactWithUnit} if aligns with role expectations`,
  readinessExplanationImpactDescriptionIfDeveloped: ({ impactWithUnit }) =>
    `${impactWithUnit} if developed`,
  readinessExplanationCurrentAndTargetLine: ({
    currentDescription,
    targetDescription,
  }) => `Current: ${currentDescription} | Target: ${targetDescription}`,
  readinessExplanationGapLine: ({ gapDescription }) => `Gap: ${gapDescription}`,
  readinessExplanationImpactLine: ({ impactDescription }) =>
    `Impact: ${impactDescription}`,
  copilotAutoMLConfigurationSectionLabel: () => 'AutoML Configuration',
  copilotAutoMLConfigurationPresetSelectLabel: () =>
    'Select Copilot AutoML Preset',
  copilotAutoMLConfigurationPresetOptionLabel: ({
    copilotAutoMLConfigurationPreset,
  }) => {
    switch (copilotAutoMLConfigurationPreset) {
      case 'no_automl':
        return 'No AutoML (XGBoost linear)';
      case 'model_only':
        return 'Model-Only';
      case 'permutation_fs':
        return 'Permutation FS';
      case 'ensemble_fs':
        return 'Ensemble FS';
      case 'custom':
        return 'Custom';
      default:
        throw guardExhaustive(copilotAutoMLConfigurationPreset);
    }
  },
  googleMapMissingKey: () => 'Google Maps API key or map ID not found',
  events: () => `Events`,
  dataDisplayPreferences: () => `Data Display Preferences`,
  currentlyDisplaying: () => `Currently displaying`,
  rowsCount: ({ departmentsCount }) => `${departmentsCount} Rows`,
  rowDisplayLimits: () => `Row Display Limits`,
  tableViewLimitsDescription: () => [
    {
      text: `Each of the available chart types (pie chart, bar chart, etc.) have their own visualization quantity limits\n\n`,
    },
    { text: `Table charts are limited to displaying 50 rows.` },
  ],
  unselected: () => 'Unselected',
  new: () => `New`,
  addColor: () => `Add color`,
  confidence: () => `Confidence:`,
  thisDepartment: () => `This Department`,
  organizationAverage: () => `Organization Avg.`,
  visitDashboard: () => `Visit Dashboard`,
  savedToDashboardHeader: ({ chart, dashboard }) => {
    const chartName = getCustomVizChartName({
      customVizRequest: chart.customVizRequest,
    });
    const dashboardName = dashboard?.name ?? 'Unknown';
    return `${chartName} saved to '${dashboardName}' dashboard`;
  },
  customVizDisplayName: ({ customVizId }) => {
    return getCustomVizChartNameById({
      customVizId,
    });
  },
  addingChartToDashboard: () => `Adding chart to dashboard`,
  failedToAddChartToDashboard: () => `Failed to add chart to dashboard`,
  addColorScale: () => `Add a Color Scale`,
  setColorsForOrgAvg: () =>
    `Select colors for values above and below your organization's average.`,
  applyAColor: () => `Apply a color`,
  secondaryBreakdownFilter: () => `Secondary Breakdown`,
  lineChartTitle: () => `Line Chart`,
  warningBannerDeploymentStaleResults: () => [
    { text: 'New version deploying', isBold: true },
    { text: ' — results may refresh shortly.' },
  ],

  dataRefreshIndicatorRefreshing: () => `Refreshing data...`,
  dataRefreshIndicatorComplete: () => `Refresh complete!`,
  dataRefreshIndicatorTooltip: () =>
    'Data refreshes automatically when algorithms update. Numbers may change when the refresh completes.',
  dataRefreshIndicatorUpdatedAt: ({ createdAt }) => {
    const date = new Date(createdAt);
    const minutesAgo = differenceInMinutes(new Date(), date);

    const formatted = format(date, 'MMM d, h:mm a');
    const fullText = `Updated ${formatted}`;

    // < 60 mins → relative time
    if (minutesAgo < 60) {
      const relative = formatDistanceToNow(date, { addSuffix: true });
      return [{ text: `Updated ${relative}`, tooltip: fullText }];
    }

    // >= 60 mins → absolute formatted timestamp
    return [{ text: fullText }];
  },
  publishDashboard: () => `Publish Dashboard`,
  public: () => `Public`,
  private: () => `Private`,
  visibility: () => `Visibility`,
  embedThisDashboard: () => `Embed this dashboard`,
  publishDashboardWarningOne: () =>
    `Public dashboards can be viewed by anyone with the link.`,
  publishDashboardWarningTwo: () =>
    `Turning off public access will immediately disable all shared links.`,
  embedDashboardInYourPage: ({ dashboardName }) => [
    { text: 'Embed ' },
    { text: dashboardName, isBold: true },
    { text: ' on your site.' },
  ],
  generalAccess: () => `General Access`,
  shareDashboard: ({ dashboardName }) => `Share ${dashboardName}`,
  anyoneInThisOrganizationCanEdit: () => `Anyone in this organization can edit`,
  canEdit: () => `Can Edit`,
  editor: () => `Editor`,
  anyoneCanAccessThisDashboard: () =>
    `Anyone, even those outside your organization, will be able to access this dashboard.`,
  viewer: () => `Viewer`,
  embedDashboard: () => `Embed dashboard`,
  downloadDashboard: () => `Download Dashboard`,
  downloadDashboardAsFile: ({ dashboardName }) => [
    { text: 'Download ' },
    { text: dashboardName, isBold: true },
    { text: ' as a separate file.' },
  ],
  documentFile: () => `Document File`,
  downloadDashboardDocxDescription: () =>
    `Download a .docx file with charts and editable text.`,
  copyPublicEmbedCode: () => `Copy public embed code`,
  copy: () => `Copy`,
  privateDashboardWarning: ({ organizationName }) => [
    { text: `Your General Access preferences for this dashboard is set to ` },
    { text: organizationName, isBold: true },
    {
      text: ` only. This embedded iframe will not render on a public site until that is set to Public.`,
    },
  ],
  shareTab: () => 'Share',
  publishTab: () => 'Publish',
  addPeopleOutsideOrganizationPlaceholder: () =>
    'Add people outside of your organization...',
  messageOptional: () => 'Message (Optional)',
  enterMessagePlaceholder: () => 'Enter message...',
  shareWithExternalWarningTitle: () =>
    'You’re sharing with people outside of your organization. Are you sure you want to continue?',
  shareWithExternalWarningBody: ({ dashboardName }) => [
    {
      text: 'Guests will receive a secure link to a view-only version of the ',
    },
    { text: dashboardName, isBold: true },
    { text: '. You can revoke their access at any time.' },
  ],
  previewGuestDashboard: () => 'Preview Guest Dashboard',
  goBack: () => 'Go Back',
  shareAnyways: () => 'Share Anyways',
  peopleWithAccess: () => 'People with access',
  loadingPeopleWithAccess: () => 'Loading people with access...',
  unableToLoadPeopleWithAccess: () => 'Unable to load people with access.',
  noPeopleWithAccessYet: () => 'No people with access yet.',
  resend: () => 'Resend',
  resending: () => 'Resending...',
  removing: () => 'Removing...',
  externalUser: () => 'External user',
  guestLabel: () => '(Guest)',
  guestsHaveViewOnlyAccess: () => 'Guests have access to a view only dashboard',
  open: () => 'Open',
  linkSharingPermissions: () => 'Link sharing permissions',
  linkSharingPermissionsTooltipPrefix: () =>
    'This link is for secure sharing. Need to share publicly or embed? ',
  linkSharingPermissionsTooltipSuffix: () => ' your dashboard.',
  copyLink: () => 'Copy Link',
  linkCopiedToast: () => 'Link copied!',
  publishYourDashboard: () => 'Publish your dashboard',
  publishYourDashboardDescription: () =>
    'Publishing this dashboard will make it publicly accessible. Any changes saved to this dashboard will also be synced in your live version.',
  confirmUnpublishDashboardTitle: () => 'Are you sure you want to un-publish?',
  confirmUnpublishDashboardDescription: () =>
    'Un-publishing will remove this dashboard from public access. Any external users that have previously been shared a link will no longer have access.',
  keepPublished: () => 'No, Keep Published',
  confirmUnpublishDashboardAction: () => 'Yes, Un-publish',
  copyUrl: () => 'Copy URL',
  viewDashboard: () => 'View Dashboard',
  confirmRemoveExternalUser: () =>
    'Are you sure you want to remove this external user?',
  removeLink: () => `Remove link`,
  connectionsPageTitle: () => 'Connections',
  connectionsPageSlackHeading: () => 'Slack',
  connectionsPageSlackDescription: () =>
    'Connect Sigma Squared to Slack to receive richer, more actionable notifications directly in your workspace.',
  noConnectionsEnabled: () => 'Your organization has no connections enabled.',
  connectionsPageSlackStatusEnabledDescription: () =>
    'Slack has been connected',
  connectionsPageSlackStatusDisabledDescription: () =>
    'Slack has not been connected',
  connectionsPageSlackDisconnect: () => 'Disconnect',
  manageOrganizationConnectionsPageTitle: () => 'Manage Connections',
  connectionsInstallError: ({ connectionId, error }) =>
    `An error occurred while trying to install ${connectionId}: ${error}`,
  dashboardsSaveButtonLabel: ({ isPublic }) =>
    isPublic ? 'Save & Publish' : 'Save',
  dashboardsUnsavedChangesLabel: () => 'Unsaved Changes',
  dashboardNewName: ({ now }) => `New Dashboard ${now.toISOString()}`,
  dashboardUpdatedElsewhere: () => 'Dashboard updated',
  dashboardUpdatedElsewhereWarning: () =>
    'This dashboard was updated in another tab. Reload to continue editing.',
  reloadDashboard: () => 'Reload',
  unsavedChanges: () => 'Unsaved changes',
  unsavedChangesWarning: () =>
    'You have unsaved changes. If you leave this page, your changes will be lost.',
  stay: () => 'Stay',
  leave: () => 'Leave',
  subjectsCount: ({ subjectsCount, totalSample, whiteLabelingSubjectPlural }) =>
    `${subjectsCount} of ${totalSample} ${whiteLabelingSubjectPlural ?? 'subjects'}`,
  totalSubjects: ({ totalSubjects }) => `Total subjects: ${totalSubjects}`,
  departmentAverage: () => `Department Avg.`,
  numeratorOutOfTotal: ({ numeratorSize, sampleSize }) =>
    `${numeratorSize} of ${sampleSize}`,
  countPeople: ({ countPeople }) => `${countPeople} people`,
  dashboardSelectDataSourceSlideHeading: () => 'Data Source',
  dashboardSelectDataSourceSlideDescription: () =>
    'You can customize the data source that populates this dashboard.',
  dashboardSelectDataSourceSlideSelectorLabel: () =>
    'Choose a data source version:',
  dashboardSelectDataSourceSlideSelectorInfo: ({
    refreshDt,
    isLatestDataSource,
  }) =>
    `This dashboard is based on data refreshed on ${formatDateStandard({ date: refreshDt, style: 'long' })}.${!isLatestDataSource ? ' Results may not reflect the latest data.' : ''}`,
  dashboardAddGlobalFiltersSlideHeading: () => 'Edit Global Filter',
  dashboardAddGlobalFiltersSlideDescription: () =>
    'You’re adding a global filter, all elections in global filters will override any pre-existing selected filters in visualizations related to selected filters in the global filter.',
  metricRequiresBreakdown: () =>
    `This metric requires a breakdown to be displayed`,
  overallDisplayModeAverageLabel: () => `Overall Average`,
  overallDisplayModeCountLabel: () => `Overall Count`,
  cannotDisplayCountsForMetric: () => `Cannot display counts for this metric`,
  prototypeStreamlitAppIdLabel: () => `View As Streamlit App`,
  prototypeStreamlitAppIdNoneSelected: () => `No app selected`,

  listRubricsPageTitle: () => 'Rubrics',
  listRubricsEmptyStateTitle: () => "You don't have any rubrics",
  listRubricsEmptyStateDescription: () =>
    'Create a rubric to begin evaluating candidate materials',
  listRubricsErrorStateTitle: () => 'Table failed to load',
  listRubricsErrorStateDescription: () =>
    'Try clicking your browser refresh to reload',
  listRubricsAllTabTitle: () => 'All Rubrics',
  listRubricsLiveTabTitle: () => `Live`,
  listRubricsDraftTabTitle: () => `Draft`,
  listRubricsArchivedTabTitle: () => `Archived`,
  rubricPurpleCardTitle: () => 'How it works',
  rubricPurpleCardDescription: () =>
    'Hiring Rubrics automatically score candidate materials for each job title.',
  resumeRubricTitle: () => 'Resume Rubric',
  resumeRubricShortTitle: () => 'Resume',
  resumeRubricDescription: () =>
    'Create scoring criteria to analyze resume submissions',
  writtenResponseRubricTitle: () => 'Written Response Rubric',
  writtenResponseRubricMediumTitle: () => 'Written Response',
  writtenResponseRubricShortTitle: () => 'Response',
  writtenResponseRubricDescription: () =>
    'Create scoring criteria to assess written responses or assessment',
  interviewRubricTitle: () => 'Interview Rubric',
  interviewRubricShortTitle: () => 'Interview',
  interviewRubricDescription: () =>
    'Create scoring criteria to evaluate interview notes or transcripts',
  createRubricPageTitle: () => 'Rubrics',
  rubricListItemTitle: () => 'Rubric',
  rubricListItemJobTitles: (params: { jobTitles: string[] }) => {
    const maxJobTitlesToShow = 2;
    const translatedContent: TranslatedContent = [];
    const fullText = params.jobTitles.join(', ');
    const jobTitlesToPreview = params.jobTitles.slice(0, maxJobTitlesToShow);
    const showPreviewMode = params.jobTitles.length > maxJobTitlesToShow;

    translatedContent.push({
      text: jobTitlesToPreview.join(', '),
      truncationGroupRunCount: showPreviewMode ? 2 : 1,
      tooltip: fullText,
    });

    if (showPreviewMode) {
      translatedContent.push({
        text: `  +${params.jobTitles.length - maxJobTitlesToShow} more`,
        tooltip: fullText,
        isBold: true,
      });
    }
    return translatedContent;
  },
  rubricNameLabel: () => 'Rubric',
  rubricJobTitlesLabel: () => 'Job Titles',
  resumeStatusDraftLabel: () => 'Draft',
  resumeStatusLiveLabel: () => 'Live',
  resumeStatusArchivedLabel: () => 'Archived',
  resumeListKebabEditLabel: () => 'Edit',
  resumeListKebabDuplicateLabel: () => 'Duplicate',
  resumeListKebabPublishLabel: () => 'Publish',
  resumeListKebabUnpublishLabel: () => 'Unpublish',
  resumeListKebabArchiveLabel: () => 'Archive',
  resumeListKebabUnarchiveLabel: () => 'Restore',
  resumeListKebabRestoreLabel: () => 'Restore',
  resumeListKebabDeleteLabel: () => 'Delete',
  rubricAreYouSureDeleteDescription: (params: { name: string }) => [
    {
      text: `Are you sure you want to delete the rubric `,
    },
    {
      text: `\"${params.name}\"`,
      isBold: true,
    },
    {
      text: `? This action cannot be undone.`,
    },
  ],
  editRubricGeneralInfoSectionNameLabel: () => 'Name',
  editRubricGeneralInfoSectionNamePlaceholder: () => 'Enter rubric name',
  editRubricGeneralInfoSectionDescriptionLabel: () => 'Description',
  editRubricGeneralInfoSectionDescriptionPlaceholder: () =>
    'Enter rubric description...',
  editRubricGeneralInfoSectionIntegrationLabel: () => 'Integration',
  editRubricGeneralInfoSectionIntegrationPlaceholder: () =>
    'Select integration',
  editRubricGeneralInfoSectionIntegrationHelperText: () =>
    'Choose where this rubric will be used',
  editRubricGeneralInfoSectionIntegrationDefaultItemLabel: () =>
    'Select integration',
  editRubricJobOpeningSectionHeading: () => 'Assign Job Openings',
  editRubricJobOpeningSectionSubHeading: () =>
    'Create or select existing job titles that will be scored with this rubric within the integrated platform',
  editRubricSelectButtonLabel: () => 'Select',
  editRubricCreateButtonLabel: () => 'Create',
  editRubricCategoriesAndCriteriaSectionHeading: ({ gradingType }) => {
    switch (gradingType) {
      case 'resume':
        return 'Add Categories & Criteria';
      case 'questions':
        return 'Add Questions & Response Criteria';
      case 'interview':
        return 'Add Interview Stages and Response Criteria';
      default:
        throw guardExhaustive(gradingType);
    }
  },
  editRubricCategoriesAndCriteriaSectionSubHeading: ({ gradingType }) => {
    switch (gradingType) {
      case 'resume':
        return 'Create or select existing categories of criteria groupings that will be used to evaluate potential candidates';
      case 'questions':
        return 'Add the questions that will be presented to candidates, specify how you’d like the written responses to be scored';
      case 'interview':
        return 'Add interview stages, specify how you’d like the written responses to be scored';
      default:
        throw guardExhaustive(gradingType);
    }
  },
  editRubricAddCategoryStrippedSectionHeading: ({ gradingType }) => {
    switch (gradingType) {
      case 'resume':
        return 'Add Category';
      case 'questions':
        return 'Add Question';
      case 'interview':
        return 'Add Interview Stage';
      default:
        throw guardExhaustive(gradingType);
    }
  },
  editRubricCategoryCreationSectionCategoryNameLabel: ({ gradingType }) => {
    switch (gradingType) {
      case 'resume':
        return 'Category Name';
      case 'questions':
        return 'Question';
      case 'interview':
        return 'Interview Stage';
      default:
        throw guardExhaustive(gradingType);
    }
  },
  editRubricCategoryCreationSectionCategoryNamePlaceholder: ({
    gradingType,
  }) => {
    switch (gradingType) {
      case 'resume':
        return 'Enter category name';
      case 'questions':
        return 'Enter question';
      case 'interview':
        return 'Enter interview stage';
      default:
        throw guardExhaustive(gradingType);
    }
  },
  editRubricCategoryCreationSectionAddTagsButtonLabel: () => 'Add Tags',
  editRubricAddCriteriaButtonLabel: () => 'Add Criteria',
  editRubricSaveButtonLabel: () => 'Save',
  editRubricCancelButtonLabel: () => 'Cancel',
  rubricRoleOperationDisplay: ({ operation }) => {
    switch (operation) {
      case 'contains':
        return 'Contains';
      case 'isEqualTo':
        return 'Is equal to';
      default:
        throw guardExhaustive(operation);
    }
  },
  editRubricEditButtonLabel: () => 'Edit',
  editRubricRemoveButtonLabel: () => 'Remove',
  editRubricTagsSearchPlaceholder: () => 'Search tags',
  rubricEditRoleOperationJobTitleLabel: () => 'Job Title',
  rubricEditRoleOperationJobTitlePlaceholder: () => 'Enter job title',
  rubricConfirmEditLabel: () => 'Confirm',
  rubricCancelEditLabel: () => 'Cancel',
  remove: () => 'Remove',
  createdAtOrDefault: ({ date }) => [
    {
      text: 'Created',
      isBold: true,
    },
    {
      text: '    ',
    },
    {
      text: date ? formatDateStandard({ date, style: 'long' }) : '-',
    },
  ],
  updatedAtOrDefault: ({ date }) => [
    {
      text: 'Last Edited',
      isBold: true,
    },
    {
      text: '    ',
    },
    {
      text: date ? formatDateStandard({ date, style: 'long' }) : '-',
    },
  ],
  saveAsDraft: () => 'Save as Draft',
  publish: () => 'Publish',
  saveAndPublish: () => 'Save & Publish',
  unpublish: () => 'Unpublish',
  restore: () => 'Restore',
  live: () => 'Live',
  newRubric: () => 'New Rubric',
  rubricRolesModalTitle: () => 'Role Library',
  rubricRolesModalSearchRolesLabel: () => 'Search roles',
  rubricRolesModalNoMatches: () => 'No roles match your search.',
  rubricRolesModalAddRoles: () => 'Add existing roles to your rubric',
  rubricRolesLiveUses: ({ uses }) => [
    { text: `Live Uses: ` },
    { text: `${uses}`, isBold: true },
  ],
  rubricRolesSelectedText: ({ count }) => `${count} selected`,
  resumeRubricCategoryLibraryTitle: () => 'Category Library',
  interviewRubricCategoryLibraryTitle: () => 'Interview Stage library',
  writtenResponseRubricCategoryLibraryTitle: () => 'Question Library',
  resumeRubricCategorySearchPlaceholder: () => 'Search categories',
  interviewRubricCategorySearchPlaceholder: () => 'Search interview stages',
  writtenResponseRubricCategorySearchPlaceholder: () => 'Search questions',
  rubricCategoryModalDescription: () =>
    'Add existing criteria to your scorecard',
  rubricCategoryModalNoMatches: () => 'No matches.',
  rubricCategoryModalCriteriaCount: ({ count }) => `Criteria ${count}`,
  rubricConfirmationPromptTitleDelete: ({ name }) => [
    {
      text: 'Are you sure you want to delete this ',
    },
    {
      text: `\"${name.length > 50 ? `${name.slice(0, 50)}...` : name}\"`,
      tooltip: name,
      isBold: true,
    },
    {
      text: ' scorecard?',
    },
  ],
  rubricConfirmationPromptDescriptionDelete: () =>
    'This scorecard will be removed from the system. This action cannot be undone.',
  rubricConfirmationPromptConfirmLabelDelete: () => 'Yes, Delete',
  rubricConfirmationPromptTitleArchive: ({ name }) => [
    {
      text: 'Are you sure you want to archive this ',
    },
    {
      text: `\"${name.length > 50 ? `${name.slice(0, 50)}...` : name}\"`,
      tooltip: name,
      isBold: true,
    },
    {
      text: ' scorecard?',
    },
  ],
  rubricConfirmationPromptDescriptionArchive: () =>
    'This scorecard will be removed from the list of scorecards. You can un-archive your scorecard at any time.',
  rubricConfirmationPromptConfirmLabelArchive: () => 'Yes, Archive',
  rubricConfirmationPromptTitleUnarchive: ({ name }) => [
    {
      text: 'Are you sure you want to un-archive this ',
    },
    {
      text: `\"${name.length > 50 ? `${name.slice(0, 50)}...` : name}\"`,
      tooltip: name,
      isBold: true,
    },
    {
      text: ' scorecard?',
    },
  ],
  rubricConfirmationPromptDescriptionUnarchive: () =>
    'This scorecard will be restored to the list of scorecards and can be used again.',
  rubricConfirmationPromptConfirmLabelUnarchive: () => 'Yes, Unarchive',
  rubricConfirmationPromptTitlePublish: ({ name }) => [
    {
      text: 'Are you sure you want to publish this ',
    },
    {
      text: `\"${name.length > 50 ? `${name.slice(0, 50)}...` : name}\"`,
      tooltip: name,
      isBold: true,
    },
    {
      text: ' scorecard?',
    },
  ],
  rubricConfirmationPromptDescriptionPublish: () =>
    'This scorecard will become available to assess candidates and may affect scoring.',
  rubricConfirmationPromptConfirmLabelPublish: () => 'Yes, Publish',
  rubricConfirmationPromptTitleUnpublish: ({ name }) => [
    {
      text: 'Are you sure you want to un-publish this ',
    },
    {
      text: `\"${name.length > 50 ? `${name.slice(0, 50)}...` : name}\"`,
      tooltip: name,
      isBold: true,
    },
    {
      text: ' scorecard?',
    },
  ],
  rubricConfirmationPromptDescriptionUnpublish: () =>
    'This scorecard will no longer be used to assess candidates and may affect scoring.',
  rubricConfirmationPromptConfirmLabelUnpublish: () => 'Yes, Unpublish',
  rubricPublishedModalTitle: () => 'Success!',
  rubricPublishedModalDescription: ({ name }) => `${name} has been published`,
  rubricToastArchiveError: ({ name }) => `Failed to archive rubric ${name}`,
  rubricToastArchiveSuccess: ({ name }) =>
    `Rubric ${name} archived successfully`,
  rubricToastDeleteError: ({ name }) => `Failed to delete rubric ${name}`,
  rubricToastDeleteSuccess: ({ name }) => `Rubric ${name} deleted successfully`,
  rubricToastPublishError: ({ name }) => `Failed to publish rubric ${name}`,
  rubricToastPublishSuccess: ({ name }) =>
    `Rubric ${name} published successfully`,
  rubricToastUnarchiveError: ({ name }) => `Failed to unarchive rubric ${name}`,
  rubricToastUnarchiveSuccess: ({ name }) =>
    `Rubric ${name} unarchived successfully`,
  rubricToastUnpublishError: ({ name }) => `Failed to unpublish rubric ${name}`,
  rubricToastUnpublishSuccess: ({ name }) =>
    `Rubric ${name} unpublished successfully`,
  rubricRoleNameAlreadyInUse: () => 'Role name already used for this operation',
  rubricRoleNameRequired: () => 'Please enter a role name',
  rubricCategoryLabelRequired: ({ gradingType }) => {
    switch (gradingType) {
      case 'resume':
        return 'Category name is required';
      case 'questions':
        return 'Question is required';
      case 'interview':
        return 'Interview stage is required';
      default:
        throw guardExhaustive(gradingType);
    }
  },
  rubricCategoryLabelDuplicate: ({ gradingType }) => {
    switch (gradingType) {
      case 'resume':
        return 'Category name already used';
      case 'questions':
        return 'Question already used';
      case 'interview':
        return 'Interview stage already used';
      default:
        throw guardExhaustive(gradingType);
    }
  },
  noResults: () => 'No results',
  create: () => 'Create',
  rubricServerError: ({ code, gradingType }) => {
    const categoriesPlural =
      gradingType === 'resume'
        ? 'categories'
        : gradingType === 'questions'
          ? 'questions'
          : 'interview stages';
    if (code === 'RUBRIC_NAME_DUPLICATE') {
      return 'Rubric name already in use. Please enter a different name.';
    } else if (code.startsWith('CATEGORY_NAME_DUPLICATE')) {
      return `One or more ${categoriesPlural} below are using a name already in use by another rubric. Please enter a different name.`;
    } else if (code.startsWith('CATEGORY_CRITERIA_DUPLICATE')) {
      return `One or more ${categoriesPlural} below have duplicate criteria. Please specify unique criteria.`;
    }

    return 'An unknown error occurred. Please try again later.';
  },
  databaseFeatureFlagDescription: ({ key }) => {
    switch (key) {
      case 'topLevelAnalysisOnDeploy':
        return 'Runs top level analysis automatically after every CI deployment';
      default:
        throw guardExhaustive(key);
    }
  },
  copyright: () =>
    `© ${new Date().getFullYear()} Sigma Squared. All rights reserved.`,
  sharedAccessEnterEmailHeading: () => 'Enter email',
  sharedAccessEnterEmailDescription: () =>
    'Enter your email to receive a unique code',
  sharedAccessEnterCodeHeading: () => 'Enter code',
  sharedAccessEnterCodeDescription: () =>
    'Enter the unique 6-digit code sent to your email',
  sharedAccessEnterCodeHelpText: () => [
    {
      text: 'Didn’t receive a code? Contact ',
    },
    {
      text: 'success@sigmasquared.io',
      isBold: true,
    },
  ],
  sharedAccessInvalidCode: () => 'Enter a valid 6-digit code',
  sharedAccessSendCode: () => 'Send Code',
  sharedAccessGranted: () => 'Access granted. Redirecting...',
  sharedAccessAlreadyHaveAnAccount: () => 'Already have an account?',
  sharedAccessAlreadyHaveAnAccountSignIn: () => 'Sign in',
};

const englishGetPayCorrectionDisplayType = ({
  displayType,
}: {
  displayType: PayCorrectionDisplayType;
}) => {
  const displayTypeMap: Record<PayCorrectionDisplayType, string> = {
    acceptable: 'Acceptable',
    'needs-attention': 'Needs Attention',
    chart: 'Chart',
    'pay-grade': 'Pay Grade',
    'all-employees': 'All Employees',
  };

  return displayTypeMap[displayType];
};

const englishGetInsightParityTitle = ({
  focusAreaDisplay,
  insightWithReferenceDisplay,
}: {
  focusAreaDisplay: string;
  insightWithReferenceDisplay: string;
}) =>
  `${focusAreaDisplay} rates are similar for ${insightWithReferenceDisplay}`;

const englishGetInsightDisparityTitle = ({
  focusAreaDisplay,
  insightWithReferenceDisplay,
}: {
  focusAreaDisplay: string;
  insightWithReferenceDisplay: string;
}) => {
  return `There is evidence of disparity in ${focusAreaDisplay} when comparing ${insightWithReferenceDisplay}.`;
};

const englishGetInsightLowCalibrationTitle = ({
  calibrationFraming,
  focusAreaDisplay,
  insightDisplay,
}: {
  focusAreaDisplay: string;
  insightDisplay: string;
  calibrationFraming: CalibrationFraming;
}) => {
  return `${insightDisplay} are impacted by ${
    calibrationFraming === 'bias' ? 'low-biased' : 'low-efficiency'
  } ${focusAreaDisplay} decisions.`;
};

const englishGetInsightMedCalibrationTitle = ({
  focusAreaDisplay,
  insightDisplay,
}: {
  focusAreaDisplay: string;
  insightDisplay: string;
  calibrationFraming: CalibrationFraming;
}) => {
  return `${focusAreaDisplay} decisions for ${insightDisplay} have room for improvement.`;
};

const englishGetInsightHighCalibrationTitle = ({
  calibrationFraming,
  focusAreaDisplay,
  insightDisplay,
}: {
  focusAreaDisplay: string;
  insightDisplay: string;
  calibrationFraming: CalibrationFraming;
}) => {
  return `${focusAreaDisplay} decisions for ${insightDisplay} are ${
    calibrationFraming === 'bias' ? 'unbiased' : 'efficient'
  }.`;
};

const englishGetShortNone = () => {
  return 'None';
};
const englishGetLongNone = () => {
  return 'None';
};
const englishGetShortVeryLow = () => {
  return 'Very Low';
};
const englishGetLongVeryLow = () => {
  return 'Very Low';
};
const englishGetShortLow = () => {
  return 'Low';
};
const englishGetLongLow = () => {
  return 'Low';
};
const englishGetShortLowToMed = () => {
  return 'Low - Med';
};
const englishGetLongLowToMed = () => {
  return 'Low to Medium';
};
const englishGetShortMed = () => {
  return 'Med';
};
const englishGetLongMed = () => {
  return 'Medium';
};
const englishGetShortMedToHigh = () => {
  return 'Med - High';
};
const englishGetLongMedToHigh = () => {
  return 'Medium to High';
};
const englishGetShortHigh = () => {
  return 'High';
};
const englishGetLongHigh = () => {
  return 'High';
};
const englishGetShortVeryHigh = () => {
  return 'Very High';
};
const englishGetLongVeryHigh = () => {
  return 'Very High';
};
const englishGetShortHighest = () => {
  return 'Highest';
};
const englishGetLongHighest = () => {
  return 'Highest';
};

const englishGetInsightParityText = ({
  focusAreaDisplay,
  insightWithReferenceDisplay,
}: {
  focusAreaDisplay: string;
  insightWithReferenceDisplay: string;
}) =>
  `There is evidence of parity in ${focusAreaDisplay} decisions when comparing ${insightWithReferenceDisplay}.`;

const englishGetInsightDisparityText = ({
  focusAreaDisplay,
  insightWithReferenceDisplay,
  percentDisplay,
  lowerHigherDisplay,
}: {
  focusAreaDisplay: string;
  insightWithReferenceDisplay: string;
  percentDisplay: string;
  lowerHigherDisplay: string;
}) =>
  `${focusAreaDisplay} rates are ${percentDisplay}% ${lowerHigherDisplay} when comparing ${insightWithReferenceDisplay}`;

const englishGetInsightLowCalibrationText = ({
  focusAreaDisplay,
  insightDisplay,
  passedTestCount,
  totalTestCount,
  calibrationScoreDisplay,
  calibrationFraming,
}: {
  focusAreaDisplay: string;
  insightDisplay: string;
  passedTestCount: number;
  totalTestCount: number;
  calibrationScoreDisplay: string;
  calibrationFraming: CalibrationFraming;
}) =>
  `Your organization only passed ${passedTestCount}/${totalTestCount} ${focusAreaDisplay} ${
    calibrationFraming === 'bias' ? 'bias' : 'optimization'
  } tests specific to ${insightDisplay}, indicating ${calibrationScoreDisplay} efficiency.`;

const englishGetCalibrationScoreDisplay = ({
  counts,
  calibrationFraming,
}: {
  counts: TestCount;
  calibrationFraming: CalibrationFraming;
}) => {
  const score = getCalibrationScore({
    testCount: counts,
  });
  const level: CalibrationLevel = getCalibrationLevel(score);

  if (level === 'poor') {
    return calibrationFraming === 'bias'
      ? englishGetShortHigh()
      : englishGetShortLow();
  }

  if (level === 'belowAverage') {
    return calibrationFraming === 'bias'
      ? englishGetShortMedToHigh()
      : englishGetShortLowToMed();
  }

  if (level === 'average') {
    return englishGetShortMed();
  }

  if (level === 'good') {
    return calibrationFraming === 'bias'
      ? englishGetShortLowToMed()
      : englishGetShortMedToHigh();
  }

  if (level === 'veryGood') {
    return calibrationFraming === 'bias'
      ? englishGetShortLow()
      : englishGetShortHigh();
  }

  if (level === 'excellent') {
    return calibrationFraming === 'bias'
      ? englishGetShortVeryLow()
      : englishGetShortVeryHigh();
  }

  if (level === 'best') {
    return calibrationFraming === 'bias'
      ? englishGetShortNone()
      : englishGetShortHighest();
  }

  throw guardExhaustive(level);
};

const englishGetInsightMedCalibrationText = ({
  focusAreaDisplay,
  insightDisplay,
  passedTestCount,
  totalTestCount,
  calibrationScoreDisplay,
  calibrationFraming,
}: {
  focusAreaDisplay: string;
  insightDisplay: string;
  passedTestCount: number;
  totalTestCount: number;
  calibrationScoreDisplay: string;
  calibrationFraming: CalibrationFraming;
}) =>
  `Your organization passed ${passedTestCount}/${totalTestCount} ${focusAreaDisplay} ${
    calibrationFraming === 'bias' ? 'bias' : 'optimization'
  } tests specific to ${insightDisplay}, indicating ${calibrationScoreDisplay} efficiency.`;

const englishGetInsightHighCalibrationText = ({
  focusAreaDisplay,
  insightDisplay,
  passedTestCount,
  totalTestCount,
  calibrationScoreDisplay,
  calibrationFraming,
}: {
  focusAreaDisplay: string;
  insightDisplay: string;
  passedTestCount: number;
  totalTestCount: number;
  calibrationScoreDisplay: string;
  calibrationFraming: CalibrationFraming;
}) =>
  `Your organization passed ${passedTestCount}/${totalTestCount} ${focusAreaDisplay} ${
    calibrationFraming === 'bias' ? 'bias' : 'optimization'
  } tests specific to ${insightDisplay}, indicating ${calibrationScoreDisplay} efficiency.`;

const englishGetComparisonGroup = () => `Comparison Group`;

const englishGetPrivilegedLevelDisplayName = ({
  myObservation,
  dimension,
}: {
  myObservation: MyObservation;
  dimension: string;
}) => {
  const comparisonGroup = englishGetComparisonGroup();
  const privilegedLevel = getPrivilegedLevelForDimensionFromObservation(
    myObservation,
    dimension,
  );

  return privilegedLevel !== undefined
    ? `, ${privilegedLevel.displayName} ${comparisonGroup}`.trim()
    : '';
};

const englishGetSavedAnalysisLevelDisplayName = ({
  myObservation,
  dimension,
  treatmentDimensionLevel,
}: {
  myObservation: MyObservation;
  dimension: string;
  treatmentDimensionLevel: string | undefined;
}) => {
  const level = getLevelByColumnValueFromObservation(
    myObservation,
    dimension,
    treatmentDimensionLevel || '',
  );
  return level?.displayName ?? treatmentDimensionLevel ?? '';
};

const englishGetFocusAreaDisplayName = ({
  focusArea,
}: {
  focusArea: MyFocusAreaDefinition;
}) => {
  return focusArea.displayName;
};

const englishGetEmployeeGroup = ({
  subjectName,
}: {
  subjectName: string | null;
}) => {
  return subjectName ? `${capitalize(subjectName)} Group` : 'Group';
};

const englishGetProgress = () => `Trends`;

const englishGetTimeSeriesTrends = () => `Outcome Trends`;

const englishGetDisparity = () => `Disparities`;

const englishGetAverageRates = () => `Average Rates`;

const englishGetMetric = () => 'Metric';

const englishGetDimension = () => `Dimension`;

const englishGetSideNavExploreTitle = () => `Explore`;

const englishGetOverviewNavigationEmployeeLifecycle = () =>
  `Employee Lifecycle`;

const englishGetSuccessPhenotypeTitle = () => 'Success Factors';

const englishFormatDateDuration = ({
  duration,
}: {
  duration: DateDuration;
}) => {
  const { years, months } = duration;
  const segments: string[] = [];

  if (years > 0) segments.push(`${years} year${years > 1 ? 's' : ''}`);
  if (months > 0 || years === 0)
    segments.push(`${months} month${months !== 1 ? 's' : ''}`);

  return segments.join(' ') || '0 months';
};

const englishFormatDateRange = ({ start, end }: DateRange) => {
  const startLabel = format(start, 'MMM yyyy');
  const endLabel = format(end, 'MMM yyyy');
  return `${startLabel}-${endLabel}`;
};

const getCardBodyFilters = ({
  request,
  myObservation,
  feature,
}: {
  request: CustomVizRequest;
  myObservation: MyObservation;
  feature: FiltersFeatureName;
}) => {
  let filters: FilterDefinitionForExtras[] = [];
  if ('filters' in request.inputs.extras) {
    filters = request.inputs.extras.filters;
  }
  const { filterSetDefinitionsWithValues, focusAreas } = myObservation;
  const filterDefinitions = determineSecondaryFilterDefinitionsForFeature({
    feature,
    focusArea: resolveFocusAreaForCustomViz(request),
    analysisName: resolveAnalysisNameForCustomViz(request),
    filterSetDefinitionsWithValues,
    focusAreas,
    dimensionDefinitions: myObservation.dimensions,
    pipelineAnalysisConfiguration: myObservation.pipelineAnalysisConfiguration,
  });
  if (filters.length === 0) {
    return `- no filters -`;
  }
  return concatTranslatedContent(
    ...filters
      .map((filter, index) => {
        const asFilterStoreValue =
          convertFilterDefinitionForExtrasToFilterStoreValue({
            filterDefinitionForExtras: filter,
            filterSetDefinitions: filterDefinitions,
          });

        const definition = filterDefinitions.find(
          (def) => def.columnHeaderValue === filter.columnHeaderValue,
        );

        if (!definition) {
          return null;
        }

        return concatTranslatedContent(
          [
            {
              text: `${getFilterDisplayName(filter.columnHeaderValue, filterDefinitions)}: `,
              isBold: true,
            },
          ],
          englishTranslateFilterStoreValueLongform({
            value: asFilterStoreValue,
            optionalDisplayValues: definition?.optionalDisplayValues,
          }),
          ...(index < filters.length - 1 ? [', '] : []),
        );
      })
      .filter((tC) => tC !== null),
  );
};

const englishGetSuccessFactorsCardTitle = ({
  myObservation,
  request,
}: {
  request: SuccessPhenotypeV2Request;
  myObservation: MyObservation;
}) => {
  // Get the metric display name
  const { metric } = getSuccessFactorsFilterValues({
    myObservation,
    customVizRequest: request,
  });
  const metricDisplayName = metric?.displayName;

  return toTitleCase(
    `${englishGetSuccessPhenotypeTitle()}: ${metricDisplayName} ${englishGetMetric()}`,
  );
};

const englishGetSuccessFactorsCardBody = ({
  myObservation,
  request,
}: {
  request: SuccessPhenotypeV2Request;
  myObservation: MyObservation;
}): TranslatedContent => {
  return getCardBodyFilters({
    request,
    myObservation,
    feature: 'dataIntelligenceDeepDive',
  });
};

const englishTranslateVariableWithoutArguments = ({
  translation,
}: {
  translation: string;
}) => {
  const dispatcher = englishPhrases[
    translation as PhraseId
  ] as () => TranslatedContent;

  return getTranslatedContentAsString(dispatcher());
};

const englishGetPipelineAnalysisCardTitle = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: PipelineAnalysisRequest;
}) => {
  const { dimension } = getPipelineAnalysisFilterValues({
    myObservation,
    customVizRequest: request,
  });

  // Temporary solution to get a translation out of a variable. This line might
  // be updated once we have class based translations
  const translatedAnalysisName = englishTranslateVariableWithoutArguments({
    translation: getAnalysisNameFromPipelineAnalysisRequest(request),
  });

  return toTitleCase(
    `${translatedAnalysisName}: ${dimension?.displayName} ${englishGetDimension()}`,
  );
};

const englishGetPipelineAnalysisCardBody = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: PipelineAnalysisRequest;
}): TranslatedContent => {
  return getCardBodyFilters({
    request,
    myObservation,
    feature: 'dataIntelligenceDeepDive',
  });
};

const englishGetBinScatterMultiSelectCardTitle = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: BinScatterMultiSelectRequest;
}) => {
  // Get the metric display name
  const { metric, dimension } = getBinScatterMultiSelectFilterValues({
    myObservation,
    customVizRequest: request,
  });

  const metricDisplayName = metric?.displayName;

  return toTitleCase(
    `Group Trends: ${metricDisplayName} ${englishGetMetric()}, ${dimension?.displayName} ${englishGetDimension()}`,
  );
};

const englishGetTableViewCardTitle = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: TableViewRequest;
}) => {
  const { filterSetDefinitionsWithValues, focusAreas } = myObservation;

  const secondaryFilterDefinitions =
    determineSecondaryFilterDefinitionsForFeature({
      feature: 'tableView',
      focusArea: resolveFocusAreaForCustomViz(request),
      analysisName: resolveAnalysisNameForCustomViz(request),
      filterSetDefinitionsWithValues,
      focusAreas,
      dimensionDefinitions: myObservation.dimensions,
      pipelineAnalysisConfiguration:
        myObservation.pipelineAnalysisConfiguration,
    });

  const allowedGroupBySelections = getAllowedGroupBySelectionsForTableView({
    allDimensions: myObservation.dimensions,
    secondaryFilterDefinitions,
    language: englishPhrases,
    includeNoSelection: false,
  });

  const groupBySelection = request.inputs.extras.groupBy;
  const currentGroupBySelection = allowedGroupBySelections.find(
    (selection) => selection.value === groupBySelection,
  );

  const groupByDisplayName =
    currentGroupBySelection?.displayName ?? englishPhrases.noSelection();

  return toTitleCase(`Table View, Breakdown: ${groupByDisplayName}`);
};

const englishGetTableViewCardBody = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: TableViewRequest;
}) => {
  return getCardBodyFilters({
    request,
    myObservation,
    feature: 'tableView',
  });
};

const englishGetSummaryStatsCardTitle = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: SummaryStatsRequest;
}) => {
  return toTitleCase(`Summary Statistics`);
};

const englishGetSummaryStatsCardBody = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: SummaryStatsRequest;
}) => {
  return getCardBodyFilters({
    request,
    myObservation,
    feature: 'summaryStats',
  });
};

const englishGetGeolocationCardTitle = ({}: {
  myObservation: MyObservation;
  request: GeolocationRequest;
}) => {
  return toTitleCase(`Geolocation`);
};

const englishGetGeolocationCardBody = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: GeolocationRequest;
}) => {
  return getCardBodyFilters({
    request,
    myObservation,
    feature: 'geolocation',
  });
};

const englishGetBinScatterMultiSelectCardBody = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: BinScatterMultiSelectRequest;
}): TranslatedContent => {
  return getCardBodyFilters({
    request,
    myObservation,
    feature: 'binScatterMultiSelect',
  });
};

const englishGetExploreCardTitle = ({
  request,
  myObservation,
}: {
  request: HeatmapAnalysisRequest;
  myObservation: MyObservation;
}) => {
  const { treatmentDimensionLevel } = request.inputs.extras;

  const { level, privilegedLevel } = getHeatmapFilterValues({
    myObservation,
    customVizRequest: request,
  });

  // Get the level display name
  const levelDisplayName = level?.displayName ?? treatmentDimensionLevel ?? '';

  const employeeGroup = englishGetEmployeeGroup({ subjectName: null });

  const comparisonGroup = englishGetComparisonGroup();

  // Get the privileged level display
  const privilegedLevelDisplayName =
    privilegedLevel !== undefined
      ? `, ${privilegedLevel.displayName} ${comparisonGroup}`.trim()
      : '';

  return toTitleCase(
    `${englishGetSideNavExploreTitle()}: ${levelDisplayName} ${employeeGroup}${privilegedLevelDisplayName}`,
  );
};

const englishGetExploreCardBody = ({
  request,
  myObservation,
}: {
  request: HeatmapAnalysisRequest;
  myObservation: MyObservation;
}): TranslatedContent => {
  return getCardBodyFilters({
    request,
    myObservation,
    feature: 'exploreHeatmap',
  });
};

const englishGetProgressCardTitle = ({
  request,
  myObservation,
}: {
  request: ProgressRequest;
  myObservation: MyObservation;
}) => {
  const { metric: metricObject, dimension: dimensionObject } =
    getProgressFilterValues({
      myObservation,
      customVizRequest: request,
    });

  const metricDisplayName = metricObject?.displayName;

  return toTitleCase(
    `${englishGetProgress()}: ${metricDisplayName} ${englishGetMetric()}, ${dimensionObject?.displayName} ${englishGetDimension()}`,
  );
};

const englishGetProgressCardBody = ({
  request,
  myObservation,
}: {
  request: ProgressRequest;
  myObservation: MyObservation;
}) => {
  const { focusArea } = request.inputs.extras;

  return getCardBodyFilters({
    request,
    myObservation,
    feature: 'progressPage',
  });
};

const englishGetTimeSeriesTrendsCardTitle = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: TimeSeriesTrendsRequest;
}) => {
  const metricDefinition = getMetricByColumnHeaderValueFromObservation({
    columnHeaderValue: request.inputs.extras.metric,
    myObservation,
  });

  const metricDisplayName =
    metricDefinition?.displayName ?? request.inputs.extras.metric;

  return toTitleCase(`${englishGetTimeSeriesTrends()}: ${metricDisplayName}`);
};

const englishGetTimeSeriesTrendsCardBody = ({
  request,
  myObservation,
}: {
  request: TimeSeriesTrendsRequest;
  myObservation: MyObservation;
}) => {
  return getCardBodyFilters({
    request,
    myObservation,
    feature: 'timeSeriesTrendsPrimary',
  });
};

const englishGetBiasAnalysisCardTitle = ({
  myObservation,
  request,
}: {
  myObservation: MyObservation;
  request: BiasAnalysisRequest;
}) => {
  const { focusArea, metric, treatmentDimensionLevel } = request.inputs.extras;

  const { level, metricObject, privilegedLevel } = getBiasAnalysisFilterValues({
    myObservation,
    customVizRequest: request,
    metric,
  });

  const subjectName = metricObject?.whiteLabeling.subjectSingular ?? null;

  const employeeGroup = englishGetEmployeeGroup({ subjectName });

  const comparisonGroup = englishGetComparisonGroup();

  const { focusAreas } = myObservation;

  const focusAreaDefinition = focusAreas.find(
    (fa) => fa.focusArea === focusArea,
  );

  // Get the level display name
  const levelDisplayName = level?.displayName ?? treatmentDimensionLevel ?? '';

  // Get the focus area display name
  const focusAreaDisplayName = focusAreaDefinition
    ? englishGetFocusAreaDisplayName({
        focusArea: focusAreaDefinition,
      })
    : focusArea;

  // Get the privileged level display
  const privilegedLevelDisplayName =
    privilegedLevel !== undefined
      ? `, ${privilegedLevel.displayName} ${comparisonGroup}`.trim()
      : '';

  return `${focusAreaDisplayName}: ${levelDisplayName} ${employeeGroup}${privilegedLevelDisplayName}`;
};

const englishGetBiasAnalysisCardBody = ({
  request,
  myObservation,
}: {
  request: BiasAnalysisRequest;
  myObservation: MyObservation;
}) => {
  return getCardBodyFilters({
    request,
    myObservation,
    feature: 'dataIntelligenceDeepDive',
  });
};

const englishTranslateFilterStoreValueLongform = ({
  value,
  optionalDisplayValues,
}: {
  value: FilterStoreValue | null;
  optionalDisplayValues: Record<string, string> | undefined;
}): TranslatedContent => {
  if (value === null) {
    return englishGetNoSelection();
  }

  const type = inferTypeForFilterStore(value);

  if (type.type === 'string') {
    const displayValue = optionalDisplayValues?.[type.string] ?? type.string;
    return displayValue;
  }

  if (type.type === 'string[]') {
    return englishGetFilterMultiSelectDisplayLongformPreview({
      items: sortFilterValues(
        type.stringArray.map((item) => {
          return optionalDisplayValues?.[item] ?? item;
        }),
      ),
    });
  }

  if (type.type === '[number, number]') {
    return englishGetNumberRangeDisplay({
      start: type.numberRange[0],
      end: type.numberRange[1],
    });
  }

  if (type.type === 'date') {
    return englishGetDateDisplay({
      date: type.date,
    });
  }

  return englishGetNoSelection();
};

const englishGetNoSelection = () => `No Selection`;

const englishGetFilterMultiSelectDisplayLongformPreview = ({
  items,
}: {
  items: string[];
}) => {
  if (items.length === 0) {
    return [{ text: '' }];
  }

  const previewPeekLength = 2;

  // Use preview mode if there are more than two items, or if there are exactly 2 items and the first item is really long
  const usePreviewMode = items.length > previewPeekLength;

  // We show a preview of 5 items
  const previewItems = items.slice(0, previewPeekLength);
  const moreAmount = items.length - previewPeekLength;

  const fullText = items.join(', ');

  return [
    { text: previewItems.join(', ') },
    ...(usePreviewMode
      ? [
          { text: `, and ` },
          {
            text: `${moreAmount} more`,
            tooltip: fullText,
            isDottedUnderline: true,
          },
        ]
      : []),
  ];
};

const englishGetNumberRangeDisplay = ({
  start,
  end,
}: {
  start: number;
  end: number;
}) => `${start} - ${end}`;

const englishGetDateDisplay = ({ date }: { date: Date }) => date.toISOString();

const getCustomVizChartNameById = ({
  customVizId,
}: {
  customVizId: CustomVizId;
}) => {
  switch (customVizId) {
    case 'progress':
      return 'Progress';
    case 'heatmap':
      return 'Heatmap';
    case 'pipelineAnalysis':
      return 'Pipeline Analysis';
    case 'successPhenotypeV2':
      return 'Success Phenotype';
    case 'topLevelAnalysis':
      return 'Top Level Analysis';
    case 'nlpGraph':
      return 'NLP Graph';
    case 'tableView':
      return 'Table View';
    case 'timeSeriesTrends':
      return 'Time Series Trends';
    case 'summaryStats':
      return 'Summary Stats';
    case 'richText':
      return 'Rich Text';
    case 'geolocation':
      return 'Geolocation';
    case 'binScatterMultiSelect':
      return 'Bin Scatter Multi Select';
    case 'binScatterCrossSelect':
      return 'Bin Scatter Cross Select';
    case 'biasAnalysis':
      return 'Bias Analysis';
    case 'promotionCopilot':
      return 'Promotion Copilot';
    case 'hiringCopilot':
      return 'Hiring Copilot';
    case 'payBenchmarking':
      return 'Pay Benchmarking';
    case 'externalStreamlit':
      return 'Streamlit';
    case 'payCorrection':
      return 'Pay Correction';
    default:
      throw guardExhaustive(customVizId);
  }
};

const getCustomVizChartName = ({
  customVizRequest,
}: {
  customVizRequest: CustomVizRequest | undefined;
}) => {
  if (!customVizRequest) {
    return 'Unknown';
  }

  return getCustomVizChartNameById({
    customVizId: customVizRequest.customVizId,
  });
};
